// // import React, {
// //   useState,
// //   useEffect,
// //   useCallback,
// //   useRef,
// //   useMemo,
// // } from "react";
// // import { FaSearch } from "react-icons/fa";
// // import Cookies from "js-cookie";
// // import api from "../chat/api";
// // import { useLocation, useNavigate } from "react-router";
// // import { Header } from "../../components/Header/Header";
// // import bell from "../../Images/ai-bell.png";
// // import search from "../../Images/search-big.jpg";
// // import axios from "axios";
// // import "./UploadFilePage.css";
// // import SubscriptionPopup from "./SubscriptionPopup.jsx";
// // import { toast } from "react-toastify";
// // import StatusModal from "./StatusModal";
// // import UploadModal from "../Contract/UploadModal";
// // import CreateFolderModal from "../Contract/CreateFolderModal";
// // import FilterModal from "./FilterModal";
// // import chatSlice from "../../Features/chatSlice.js";
// // import "../Contract/contract_data.css";
// // import Spinner from "../Contract/Spinner.jsx";
// // import HoverTooltip from "./HoverTooltip.jsx";
// // import FilterAppliedTooltip from "./FilterAppliedTooltip.jsx";
// // import FileNameWithTooltip from "./FileNameWithTooltip.jsx";
// // import CreateTagModals from "../Tags/CreateTagModals.jsx";
// // import useGooglePicker from "../Ocr_Data/useGooglePicker.js";
// // const UploadFilePage = ({ isMenuOpen }) => {
// //   const [isBulkTagModalOpen, setIsBulkTagModalOpen] = useState(false);
// //   const uploadButtonRef = useRef(null);

// //   const baseColumns = 7; // name, party A, party B, date, etc.
// //   const totalColumns = baseColumns;
// //   const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);
// //   const { isConnected, connect, disconnect, openPicker, accessToken } =
// //     useGooglePicker();
// //   const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
// //   const filterBtnRef = useRef(null);
// //   const [isModalOpen, setIsModalOpen] = useState(false);
// //   const [files, setFiles] = useState([]);
// //   const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
// //   const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
// //   const [filters, setFilters] = useState({
// //     folder: true,
// //     normalDocument: true,
// //     contract: false,
// //     invoices: false,
// //     spreadsheet: false,
// //   });
// //   const [selectedFilters, setSelectedFilters] = useState({
// //     folder: false,
// //     normalDocument: false,
// //     contract: false,
// //     invoice: false,
// //   });
// //   const uploadBtnRef = useRef(null);
// //   const [fieldName, setFieldName] = useState("");
// //   const [selectedColor, setSelectedColor] = useState("");
// //   const [fieldPrompt, setFieldPrompt] = useState("");
// //   const [loadingAddField, setLoadingAddField] = useState(false);
// //   const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
// //   const [isTagSearch, setIsTagSearch] = useState(false);

// //   const colorOptions = [
// //     "#D8FF75",
// //     "#7FFF7A",
// //     "#7AFFCE",
// //     "#7AEDFF",
// //     "#7ABEFF",
// //     "#7A9FFF",
// //     "#B27AFF",
// //     "#E97AFF",
// //     "#FF7AD7",
// //     "#FF7AA5",
// //     "#FF7A7A",
// //     "#FFFFFF",
// //     "#F7F7F7",
// //   ];

// //   const [isHovered, setIsHovered] = useState(false);
// //   const fileInputRef = useRef(null);
// //   const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
// //   const actionMenuRef = useRef(null);
// //   const [isSuccessPopupVisible, setIsSuccessPopupVisible] = useState(false);
// //   const [successFolderName, setSuccessFolderName] = useState("");
// //   const [selectedInvoices, setSelectedInvoices] = useState([]);
// //   const [selectedContractKeys, setSelectedContractKeys] = useState([]);
// //   const [selectedInvoiceKeys, setSelectedInvoiceKeys] = useState([]);
// //   const [file_ids, setFileId] = useState(null);
// //   const [isPopupVisible, setIsPopupVisible] = useState(false);
// //   const [isFilterApplied, setIsFilterApplied] = useState(false);
// //   const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
// //   const [token, setToken] = useState(
// //     Cookies.get("access_token") || localStorage.getItem("token") || ""
// //   );
// //   const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
// //   const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });

// //   const [isRenameFolderModalOpen, setIsRenameFolderModalOpen] = useState(false);
// //   const [currentFolder, setCurrentFolder] = useState(null);
// //   const [copyInProgress, setCopyInProgress] = useState(false);
// //   const [tagModalDocId, setTagModalDocId] = useState(null);

// //   const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false);
// //   const [folderToDelete, setFolderToDelete] = useState(null);
// //   const [dropdownOpen, setDropdownOpen] = useState(false);
// //   const [editContractId, setEditContractId] = useState(null);
// //   const [editedContractData, setEditedContractData] = useState({});
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [rowsPerPage, setRowsPerPage] = useState(25);
// //   const editRowRef = useRef(null);
// //   const [selectedContracts, setSelectedContracts] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const pdf_key = localStorage.getItem("pdfKey");
// //   const tbodyRef = useRef(null);
// //   const [exportInProgress, setExportInProgress] = useState(false);
// //   const [deleteInProgress, setDeleteInProgress] = useState(false);
// //   const [hoveredAction, setHoveredAction] = useState(null);
// //   const [clickedAction, setClickedAction] = useState(null);
// //   const [cancelledPdfKeys, setCancelledPdfKeys] = useState([]);

// //   const [pdfToView, setPdfToView] = useState(null);
// //   const [isViewerOpen, setIsViewerOpen] = useState(false);

// //   const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
// //   const [currentDocument, setCurrentDocument] = useState(null);
// //   const [selectedFolder, setSelectedFolder] = useState(0);
// //   const [folders, setFolders] = useState([]);
// //   const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);
// //   const [selectedFolderName, setSelectedFolderName] = useState("");
// //   const [deleteTarget, setDeleteTarget] = useState(null); // can be "single" or "bulk"

// //   const [popupVisible, setPopupVisible] = useState(false);
// //   const [popupTitle, setPopupTitle] = useState("");
// //   const [popupMessage, setPopupMessage] = useState("");
// //   const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
// //   const [contractToDelete, setContractToDelete] = useState(null);
// //   const [showSingleDeleteConfirm, setShowSingleDeleteConfirm] = useState(false);

// //   const [sortConfig, setSortConfig] = useState({
// //     key: null, // 'size' or 'date'
// //     direction: "asc", // or 'desc'
// //   });

// //   const handleSortBySize = () => {
// //     setSortConfig((prev) => ({
// //       key: "size",
// //       direction:
// //         prev.key === "size" && prev.direction === "asc" ? "desc" : "asc",
// //     }));
// //   };

// //   const handleSortByDate = () => {
// //     setSortConfig((prev) => ({
// //       key: "date",
// //       direction:
// //         prev.key === "date" && prev.direction === "asc" ? "desc" : "asc",
// //     }));
// //   };

// //   function darkenColor(hex, amount = 0.4) {
// //     if (!hex || !hex.startsWith("#")) return "#333";
// //     const num = parseInt(hex.slice(1), 16);
// //     let r = (num >> 16) & 255;
// //     let g = (num >> 8) & 255;
// //     let b = num & 255;

// //     // darken each channel
// //     r = Math.floor(r * (1 - amount));
// //     g = Math.floor(g * (1 - amount));
// //     b = Math.floor(b * (1 - amount));

// //     return `rgb(${r}, ${g}, ${b})`;
// //   }

// //   useEffect(() => {
// //     if (
// //       isRenameModalOpen ||
// //       isCopyModalOpen ||
// //       isRenameFolderModalOpen ||
// //       isDeleteFolderModalOpen ||
// //       confirmDeleteVisible ||
// //       contractToDelete ||
// //       popupVisible
// //     ) {
// //       setIsActionMenuOpen(null);
// //     }
// //   }, [
// //     isRenameModalOpen,
// //     isCopyModalOpen,
// //     isRenameFolderModalOpen,
// //     isDeleteFolderModalOpen,
// //     confirmDeleteVisible,
// //     contractToDelete,
// //     popupVisible,
// //   ]);

// //   useEffect(() => {
// //     if (isConnected && !hasOpenedPickerOnce) {
// //       // Don't open picker here
// //       setHasOpenedPickerOnce(true);
// //     }
// //   }, [isConnected, hasOpenedPickerOnce]);
// //   const handleAddFromDriveClick = () => {
// //     openPicker(async (docs) => {
// //       console.log("📄 Files picked:", docs);

// //       try {
// //         const files = await Promise.all(
// //           docs.map(async (doc) => {
// //             const res = await fetch(
// //               `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
// //               {
// //                 headers: { Authorization: `Bearer ${accessToken}` },
// //               }
// //             );

// //             if (!res.ok) throw new Error("Failed to fetch file from Drive");

// //             const blob = await res.blob();
// //             return new File([blob], doc.name, { type: blob.type });
// //           })
// //         );

// //         setFile(files); // 👈 trigger your upload flow
// //         setIsModalOpen(true); // 👈 open modal
// //       } catch (err) {
// //         console.error("Failed to process selected files", err);
// //         toast.error("Something went wrong while processing selected files.");
// //       }
// //     });
// //   };

// //   useEffect(() => {
// //     const cookieToken = Cookies.get("access_token");
// //     if (cookieToken) {
// //       setToken(cookieToken);
// //     } else {
// //     }
// //   }, []);
// //   useEffect(() => {
// //     if (tagModalDocId) {
// //     }
// //   }, [tagModalDocId]);

// //   const resetSelections = () => {
// //     setSelectedContracts([]);
// //     setSelectedContractKeys([]);
// //     setSelectedInvoiceKeys([]);
// //     setCurrentDocument(null);
// //     setCurrentFolder(null);
// //     setEditContractId(null);
// //     setEditedContractData({});
// //     setIsActionMenuOpen(null);
// //     setContractToDelete(null);
// //     setFolderToDelete(null);
// //     setConfirmDeleteVisible(false);
// //     setIsRenameModalOpen(false);
// //     setIsRenameFolderModalOpen(false);
// //     setIsCopyModalOpen(false);
// //     setIsDeleteFolderModalOpen(false);
// //   };

// //   const clearFilters = async () => {
// //     setSelectedFilters({
// //       folder: false,
// //       normalDocument: false,
// //       contract: false,
// //       invoice: false,
// //     });

// //     try {
// //       const response = await api.get("api/v1/readpdf/files-and-folders/");
// //       if (response.status === 200) {
// //         const { files, folders } = response.data;
// //         setFiles(Array.isArray(files) ? files : []);
// //         setFolders(Array.isArray(folders) ? folders : []);
// //         setIsFilterApplied(false);
// //       }
// //     } catch (error) {
// //       setFiles([]);
// //       setFolders([]);
// //     }
// //   };

// //   const filteredContracts = useMemo(() => {
// //     if (!Array.isArray(files) || files.length === 0) return [];

// //     const query = searchQuery.toLowerCase().trim();

// //     return files.filter((file) => {
// //       const nameMatch = file?.pdf_name?.toLowerCase().includes(query);

// //       const tagMatch =
// //         file?.tags?.some((tag) =>
// //           tag.name?.toLowerCase().includes(query.replace("tags:", "").trim())
// //         ) || false;

// //       return isTagSearch ? tagMatch : nameMatch || tagMatch;
// //     });
// //   }, [files, searchQuery, isTagSearch]);

// //   const totalPages = useMemo(() => {
// //     const totalItems = folders.length + files.length;
// //     return Math.ceil(totalItems / rowsPerPage);
// //   }, [folders, files, rowsPerPage]);

// //   const toggleModal = () => {
// //     setIsModalOpen((prev) => !prev);
// //   };

// //   const [actionMenuPosition, setActionMenuPosition] = useState({
// //     top: 0,
// //     left: 0,
// //   });

// //   const toggleActionMenu = (index, event) => {
// //     event.stopPropagation();
// //     if (isActionMenuOpen === index) {
// //       setIsActionMenuOpen(null);
// //     } else {
// //       const rect = event.currentTarget.getBoundingClientRect();
// //       setActionMenuPosition({
// //         top: rect.bottom + window.scrollY + 6, // Adjust spacing
// //         left: rect.left + window.scrollX - 20, // Shift left slightly if needed
// //       });
// //       setIsActionMenuOpen(index);
// //     }
// //   };

// //   const [file, setFile] = useState(null);

// //   const handleFileChange = (event) => {
// //     if (!isCreateFolderModalOpen) {
// //       // ✅ Prevent UploadModal from opening if folder modal is open
// //       const selectedFiles = Array.from(event.target.files || []);
// //       if (selectedFiles.length === 0) return;

// //       setFile(selectedFiles);
// //       setIsModalOpen(true); // ✅ only open UploadModal when not creating a folder
// //     }
// //   };

// //   const handleApplyFilters = (newFilters, files, folders) => {
// //     const filteredFiles = files
// //       .filter((file) => {
// //         if (newFilters.folder && file.isFolder) return true;
// //         if (newFilters.normalDocument && file.type === "normal_document")
// //           return true;
// //         if (newFilters.contract && file.type === "contract") return true;
// //         if (newFilters.invoice && file.type === "invoice") return true;
// //         if (newFilters.spreadsheet && file.type === "spreadsheet") return true;
// //         return false;
// //       })
// //       .map((file) => {
// //         let fileType = "Unknown";
// //         const name = file.pdf_name || file.name || "";
// //         if (name.endsWith(".pdf")) fileType = "pdf";
// //         else if (name.endsWith(".xlsx")) fileType = "xlsx";
// //         else if (name.endsWith(".xls")) fileType = "xls";
// //         else if (name.endsWith(".csv")) fileType = "csv";
// //         else if (name.endsWith(".doc") || name.endsWith(".docx"))
// //           fileType = "docx";
// //         else if (name.endsWith(".txt")) fileType = "txt";

// //         return {
// //           ...file,
// //           file_type: fileType,
// //         };
// //       });

// //     const filteredFolders = folders.map((folder) => ({
// //       ...folder,
// //       file_type: "Folder",
// //     }));

// //     setFiles(filteredFiles);
// //     setFolders(filteredFolders);
// //   };

// //   const handleExport = async () => {
// //     if (selectedContracts.length === 0) {
// //       showPopup("Error", "Please select at least one document to export.");
// //       return;
// //     }
// //     if (!selectedContractKeys.length && !selectedInvoiceKeys.length) {
// //       alert("Please select at least one document to export.");
// //       return;
// //     }

// //     setExportInProgress(true);

// //     try {
// //       const response = await api.post(
// //         "api/v1/readpdf/export-doc/",
// //         {
// //           contract_keys: selectedContractKeys,
// //           invoice_keys: selectedInvoiceKeys,
// //         },
// //         {
// //           responseType: "blob",
// //         }
// //       );

// //       const url = window.URL.createObjectURL(new Blob([response.data]));
// //       const link = document.createElement("a");
// //       link.href = url;
// //       link.setAttribute("download", "exported_documents.csv");
// //       document.body.appendChild(link);
// //       link.click();

// //       // showPopup("Success", "Documents exported successfully.");
// //       resetSelections();
// //     } catch (error) {
// //       if (error.response) {
// //         const message =
// //           error.response.data.msg || "Failed to export documents.";
// //         showPopup("Error", message);
// //       } else {
// //         showPopup("Error", "An unexpected error occurred. Please try again.");
// //       }
// //     } finally {
// //       setExportInProgress(false);
// //     }
// //   };

// //   const handleClickOutside = (event) => {
// //     if (
// //       actionMenuRef.current &&
// //       !actionMenuRef.current.contains(event.target)
// //     ) {
// //       setIsActionMenuOpen(null);
// //     }
// //   };

// //   useEffect(() => {
// //     document.addEventListener("click", handleClickOutside);

// //     return () => {
// //       document.removeEventListener("click", handleClickOutside);
// //     };
// //   }, []);

// //   const handleCancel = () => {
// //     resetSelections();
// //     setSelectedContracts([]);

// //     setIsModalOpen(false);
// //     setIsFilterModalOpen(false);
// //     setPopupVisible(false);

// //     setConfirmDeleteVisible(false);
// //   };

// //   const handleRowsPerPageChange = (event) => {
// //     setRowsPerPage(Number(event.target.value));
// //     setCurrentPage(1);
// //   };
// //   const handleNextPage = () => {
// //     if (currentPage < totalPages) {
// //       setCurrentPage(currentPage + 1);
// //       scrollToTop();
// //     }
// //   };

// //   const handlePreviousPage = () => {
// //     if (currentPage > 1) {
// //       setCurrentPage(currentPage - 1);
// //       scrollToTop();
// //     }
// //   };

// //   const handlePageChange = (newPage) => {
// //     if (newPage >= 1 && newPage <= totalPages) {
// //       setCurrentPage(newPage);
// //       scrollToTop();
// //     }
// //   };

// //   const scrollToTop = () => {
// //     if (tbodyRef.current) {
// //       tbodyRef.current.scrollTop = 0;
// //     }
// //   };

// //   const handleBulkDeleteConfirmation = () => {
// //     if (selectedContracts.length === 0) {
// //       showPopup("Error", "No files or folders selected for bulk deletion.");
// //       return;
// //     }

// //     setPopupTitle("Confirm Bulk Deletion");
// //     setPopupMessage(
// //       "Are you sure you want to delete the selected items? This action cannot be undone."
// //     );
// //     setDeleteTarget("bulk");
// //     setConfirmDeleteVisible(true);
// //   };

// //   const fetchFolders = async () => {
// //     if (!token) return;

// //     try {
// //       // const response = await api.get("api/v1/folders/");
// //       // setFolders(response.data);
// //     } catch (error) {}
// //   };

// //   const fetchContracts = async () => {
// //     if (!token) return;
// //     setLoading(true);
// //     try {
// //       const response = await api.get("api/v1/readpdf/files-and-folders/");

// //       const { files, folders } = response.data;

// //       setFiles(files || []);
// //       setFolders(folders || []);
// //     } catch (error) {
// //       if (
// //         error.response &&
// //         error.response.data?.message ===
// //           "No valid trial or active subscription. Redirecting to payment."
// //       ) {
// //         setShowSubscriptionPopup(true);
// //       } else {
// //         toast.error("Failed to load documents. Please try again later.", {
// //           autoClose: 3000,
// //         });
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleSelectAll = () => {
// //     const allItems = [...folders, ...files].map((item) => {
// //       const isFolder = !!item.documents;
// //       return {
// //         ...item,
// //         document_type: isFolder ? "folder" : item.document_type || "file",
// //       };
// //     });

// //     if (selectedContracts.length === allItems.length) {
// //       setSelectedContracts([]);
// //       setSelectedContractKeys([]);
// //       setSelectedInvoiceKeys([]);
// //     } else {
// //       setSelectedContracts(allItems);
// //       setSelectedContractKeys(
// //         allItems
// //           .filter((item) => item.document_type === "contract")
// //           .map((item) => item.key)
// //       );
// //       setSelectedInvoiceKeys(
// //         allItems
// //           .filter((item) => item.document_type === "invoice")
// //           .map((item) => item.key)
// //       );
// //     }
// //   };

// //   const filteredData = useMemo(() => {
// //     const normalizedQuery = searchQuery
// //       .trim()
// //       .replace(/\s+/g, " ")
// //       .toLowerCase();

// //     if (!normalizedQuery) return [...folders, ...files];

// //     return [...folders, ...files].filter((item) =>
// //       (item.name || "").toLowerCase().includes(normalizedQuery)
// //     );
// //   }, [folders, files, searchQuery]);

// //   const parseTimeAgo = (timeAgo) => {
// //     if (!timeAgo) return 0;

// //     const [amountStr, unit] = timeAgo.toLowerCase().split(" ");
// //     const amount = parseInt(amountStr);
// //     const now = new Date();

// //     switch (unit) {
// //       case "second":
// //       case "seconds":
// //         return now.getTime() - amount * 1000;
// //       case "minute":
// //       case "minutes":
// //         return now.getTime() - amount * 60 * 1000;
// //       case "hour":
// //       case "hours":
// //         return now.getTime() - amount * 60 * 60 * 1000;
// //       case "day":
// //       case "days":
// //         return now.getTime() - amount * 24 * 60 * 60 * 1000;
// //       case "week":
// //       case "weeks":
// //         return now.getTime() - amount * 7 * 24 * 60 * 60 * 1000;
// //       case "month":
// //       case "months":
// //         return now.getTime() - amount * 30 * 24 * 60 * 60 * 1000;
// //       default:
// //         return 0;
// //     }
// //   };

// //   const handleAddField = async () => {
// //     if (!fieldName.trim() || !selectedColor) return;

// //     try {
// //       setLoadingAddField(true);
// //       await api.post("/api/tagging/tags/", {
// //         name: fieldName.trim(),
// //         color: selectedColor,
// //         description: fieldPrompt.trim() || "",
// //       });

// //       // Clear state
// //       setFieldName("");
// //       setFieldPrompt("");
// //       setSelectedColor("");

// //       // Optional refresh functions
// //       await fetchContracts();
// //       await fetchFolders();

// //       setFieldCreationSuccess(true);
// //       setTimeout(() => setFieldCreationSuccess(false), 3000);
// //       setTagModalDocId(false);
// //     } catch (error) {
// //     } finally {
// //       setLoadingAddField(false);
// //     }
// //   };

// //   const combinedFilesAndFolders = useMemo(() => {
// //     const sorted = [...folders, ...files].map((item) => ({
// //       ...item,
// //       isFolder: !!item.documents,
// //       timeAgoParsed: parseTimeAgo(item.time_ago),
// //       sizeParsed: parseFloat(
// //         item.document_size || item.folder_size || item.size || 0
// //       ),
// //       uploadedTime: new Date(item.created_at || item.uploaded_at).getTime(),
// //     }));

// //     if (sortConfig.key === "size") {
// //       sorted.sort((a, b) =>
// //         sortConfig.direction === "asc"
// //           ? a.sizeParsed - b.sizeParsed
// //           : b.sizeParsed - a.sizeParsed
// //       );
// //     } else if (sortConfig.key === "date") {
// //       sorted.sort((a, b) =>
// //         sortConfig.direction === "asc"
// //           ? a.uploadedTime - b.uploadedTime
// //           : b.uploadedTime - a.uploadedTime
// //       );
// //     } else {
// //       // Default: sort by time ago
// //       sorted.sort((a, b) => b.timeAgoParsed - a.timeAgoParsed);
// //     }

// //     return sorted;
// //   }, [folders, files, sortConfig]);

// //   const paginatedData = useMemo(() => {
// //     const startIndex = (currentPage - 1) * rowsPerPage;
// //     const endIndex = startIndex + rowsPerPage;
// //     return combinedFilesAndFolders.slice(startIndex, endIndex);
// //   }, [combinedFilesAndFolders, currentPage, rowsPerPage]);

// //   const filteredPaginatedData = useMemo(() => {
// //     const query = searchQuery.toLowerCase().trim();
// //     const data = combinedFilesAndFolders;

// //     const filtered = data.filter((item) => {
// //       const nameMatch = (item.name || "").toLowerCase().includes(query);
// //       const tagMatch =
// //         item.tags?.some((tag) =>
// //           tag.name?.toLowerCase().includes(query.replace("tags:", "").trim())
// //         ) || false;

// //       return isTagSearch ? tagMatch : nameMatch || tagMatch;
// //     });

// //     const startIndex = (currentPage - 1) * rowsPerPage;
// //     const endIndex = startIndex + rowsPerPage;
// //     return filtered.slice(startIndex, endIndex);
// //   }, [
// //     combinedFilesAndFolders,
// //     searchQuery,
// //     isTagSearch,
// //     currentPage,
// //     rowsPerPage,
// //   ]);

// //   const handleCheckboxChange = (item) => {
// //     const isSelected = selectedContracts.some(
// //       (selectedItem) => selectedItem.id === item.id
// //     );

// //     if (isSelected) {
// //       setSelectedContracts(
// //         selectedContracts.filter((selectedItem) => selectedItem.id !== item.id)
// //       );

// //       // Remove the key from the respective keys list
// //       if (item.document_type === "contract") {
// //         setSelectedContractKeys(
// //           selectedContractKeys.filter((key) => key !== item.key)
// //         );
// //       } else if (item.document_type === "invoice") {
// //         setSelectedInvoiceKeys(
// //           selectedInvoiceKeys.filter((key) => key !== item.key)
// //         );
// //       }
// //     } else {
// //       setSelectedContracts([...selectedContracts, item]);

// //       // Add the key to the respective keys list
// //       if (item.document_type === "contract") {
// //         setSelectedContractKeys([...selectedContractKeys, item.key]);
// //       } else if (item.document_type === "invoice") {
// //         setSelectedInvoiceKeys([...selectedInvoiceKeys, item.key]);
// //       }
// //     }
// //   };

// //   useEffect(() => {
// //     if (!folders.length && !files.length) {
// //       fetchFolders();
// //       fetchContracts();
// //     }
// //   }, []);

// //   const handleUploadSuccess = () => {
// //     fetchContracts();
// //     fetchFolders();
// //     toggleModal();
// //   };

// //   const handleCloseModal = () => {
// //     toggleModal();
// //   };

// //   const toggleFilterModal = () => {
// //     setIsFilterModalOpen((prev) => !prev);
// //   };

// //   const CopyToFolderModal = ({
// //     isOpen,
// //     onClose,
// //     documents,
// //     folders,
// //     onCopy,
// //     onCreateFolder,
// //   }) => {
// //     const [selectedFolder, setSelectedFolder] = useState(null);
// //     const [selectedFolderName, setSelectedFolderName] = useState("");
// //     const [dropdownOpen, setDropdownOpen] = useState(false);
// //     const [creatingNewFolder, setCreatingNewFolder] = useState(false);
// //     const [newFolderName, setNewFolderName] = useState("");
// //     const [errorMessage, setErrorMessage] = useState("");

// //     const handleSave = async () => {
// //       if (!selectedFolder) {
// //         setErrorMessage("Please select a folder.");
// //         return;
// //       }
// //       if (!documents || documents.length === 0) {
// //         alert("No document selected for copying.");
// //         return;
// //       }

// //       setErrorMessage("");
// //       setCopyInProgress(true); // Start loader
// //       try {
// //         await onCopy(
// //           documents.map((doc) => doc.id),
// //           selectedFolder
// //         );
// //         onClose(); // Close modal after copy is done
// //         resetSelections();
// //       } catch (err) {
// //         setErrorMessage("Failed to copy documents.");
// //       } finally {
// //         setCopyInProgress(false);
// //       }
// //     };

// //     const handleCreateFolder = async () => {
// //       const trimmedFolderName = newFolderName.trim();

// //       if (!trimmedFolderName) {
// //         setErrorMessage("Folder name cannot be empty.");
// //         return;
// //       }

// //       if (!documents || documents.length === 0) {
// //         toast.warn("Please select at least one document.", { autoClose: 2000 });
// //         return;
// //       }

// //       // 🔍 Check for duplicate folder name
// //       const isDuplicate = folders.some(
// //         (folder) =>
// //           folder.name.toLowerCase() === trimmedFolderName.toLowerCase()
// //       );

// //       if (isDuplicate) {
// //         toast.warn("A folder with this name already exists.", {
// //           autoClose: 3000,
// //         });
// //         return;
// //       }

// //       setErrorMessage("");
// //       setLoading(true);

// //       try {
// //         const documentIds = documents.map((doc) => doc.id);

// //         const response = await api.post("api/v1/readpdf/add-files/", {
// //           file_ids: documentIds,
// //           folder_name: trimmedFolderName,
// //         });

// //         if (response.status === 200) {
// //           const newFolderId = response.data.folder_id;

// //           setSelectedFolder(newFolderId);
// //           setSelectedFolderName(trimmedFolderName);
// //           setNewFolderName("");
// //           setCreatingNewFolder(false);

// //           if (onCreateFolder) {
// //             onCreateFolder({
// //               id: newFolderId,
// //               name: trimmedFolderName,
// //             });
// //           }

// //           fetchFolders();
// //           fetchContracts();
// //           resetSelections();
// //           onClose();
// //         }
// //       } catch (error) {
// //         if (
// //           error.response &&
// //           error.response.data &&
// //           error.response.data.msg === "Folder with this name already exists"
// //         ) {
// //           toast.warn("A folder with this name already exists.", {
// //             autoClose: 2000,
// //           });
// //         } else {
// //           toast.error("Failed to create folder. Please try again.", {
// //             autoClose: 2000,
// //           });
// //         }
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     return isOpen ? (
// //       <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //         <div className="copy-modal">
// //           <div className="flex justify-between items-center mb-4">
// //             <h2 className="text-lg font-semibold text-gray-700">
// //               Copy to Folder
// //             </h2>
// //             <button
// //               onClick={onClose}
// //               className="text-gray-500 hover:text-gray-700 transition"
// //             >
// //               X
// //             </button>
// //           </div>
// //           <p>Copy into any folder and organize your documents</p>
// //           <h3>Choose Folder</h3>

// //           <div className="select-container">
// //             {/* Folder Selection Dropdown */}
// //             <div
// //               className="custom-select"
// //               onClick={() => setDropdownOpen(!dropdownOpen)}
// //             >
// //               <div className="selected-option">
// //                 {selectedFolder ? selectedFolderName : "Select a folder"}
// //               </div>
// //               <span className="select-icon">
// //                 <img src="/copyToFolder-icon.svg" alt="Dropdown Icon" />
// //               </span>
// //             </div>

// //             {/* Show "Create New Folder" Input Box Between Dropdown & Folder List */}
// //             {creatingNewFolder && (
// //               <div className="new-folder-container flex mt-2 p-2 border border-gray-300 rounded-md">
// //                 <input
// //                   type="text"
// //                   placeholder="Enter your folder name here"
// //                   value={newFolderName}
// //                   onChange={(e) => setNewFolderName(e.target.value)}
// //                   style={{
// //                     color: "#000000", // ✅ Pure black text
// //                     width: "200px",
// //                     fontFamily: "Outfit, sans-serif",
// //                     fontSize: "15px", // ✅ 15px font size
// //                     fontStyle: "normal",
// //                     fontWeight: 400,
// //                     lineHeight: "normal",
// //                     padding: "12px",
// //                     border: "none",
// //                     background: "#FFFFFF",
// //                   }}
// //                 />
// //                 <div className="folder-action-buttons flex ml-2">
// //                   <button
// //                     onClick={async () => {
// //                       await handleCreateFolder();
// //                     }}
// //                     className="save-button-copy"
// //                   >
// //                     Save
// //                   </button>
// //                   <button
// //                     onClick={() => setCreatingNewFolder(false)}
// //                     className="cancel-button-copy"
// //                   >
// //                     Cancel
// //                   </button>
// //                 </div>
// //               </div>
// //             )}

// //             {/* Folder List (Remains Below Input Box) */}
// //             {dropdownOpen && (
// //               <div className="custom-dropdown-options">
// //                 {folders.length > 0 ? (
// //                   folders.map((folder) => (
// //                     <div
// //                       key={folder.id}
// //                       className="custom-dropdown-option"
// //                       onClick={(e) => {
// //                         e.stopPropagation();
// //                         setSelectedFolder(folder.id);
// //                         setSelectedFolderName(folder.name);
// //                         setDropdownOpen(false);
// //                       }}
// //                     >
// //                       {folder.name}
// //                     </div>
// //                   ))
// //                 ) : (
// //                   <div className="custom-dropdown-option no-folders">
// //                     No folders available
// //                   </div>
// //                 )}
// //               </div>
// //             )}

// //             {/* "Create New Folder" Button */}
// //             {dropdownOpen && !creatingNewFolder && (
// //               <button
// //                 className="create-new-folder-btn mt-3"
// //                 onClick={() => {
// //                   setCreatingNewFolder(true);
// //                   setDropdownOpen(true);
// //                 }}
// //               >
// //                 <img
// //                   src="/folder-icon-copy.svg"
// //                   alt="Folder Icon"
// //                   className="folder-icon"
// //                 />
// //                 <span>Create New Folder</span>
// //               </button>
// //             )}
// //           </div>

// //           {errorMessage && (
// //             <p className="error-message text-red-500 mt-2">{errorMessage}</p>
// //           )}

// //           {selectedFolder && (
// //             <div className="copy-modal-actions flex justify-end mt-20">
// //               <button onClick={onClose} className="cancel-button">
// //                 Cancel
// //               </button>
// //               <button
// //                 onClick={handleSave}
// //                 disabled={copyInProgress}
// //                 className="save-button"
// //               >
// //                 {copyInProgress ? "Copying..." : "Copy"}
// //               </button>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     ) : null;
// //   };

// //   const RenameModal = ({ isOpen, onClose, document, onRename }) => {
// //     const [newName, setNewName] = useState("");

// //     const [isRenaming, setIsRenaming] = useState(false);
// //     useEffect(() => {
// //       if (document) {
// //         const initialName = document.pdf_name || document.name || "";
// //         setNewName(initialName);
// //       }
// //     }, [document]);

// //     const handleSave = async () => {
// //       if (!newName.trim()) return;
// //       setIsRenaming(true);

// //       try {
// //         await onRename(document.id, newName.trim()); // Wait for rename to complete
// //       } catch (err) {
// //       } finally {
// //         setIsRenaming(false);
// //         onClose(); // Close only after rename finishes
// //       }
// //     };

// //     return isOpen ? (
// //       <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //         <div className="rename-modal">
// //           <h2>Rename Document</h2>
// //           <p>Create a Custom Name for your Documents</p>
// //           <h3>Title</h3>
// //           <input
// //             type="text"
// //             value={newName}
// //             onChange={(e) => setNewName(e.target.value)}
// //             placeholder="Enter new name"
// //             disabled={isRenaming}
// //           />
// //           <div className="rename-modal-actions">
// //             <button onClick={onClose}>Cancel</button>
// //             <button
// //               onClick={handleSave}
// //               disabled={isRenaming || !newName.trim()}
// //             >
// //               {isRenaming ? "Saving..." : "Save"}
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     ) : null;
// //   };

// //   const handleRename = async (documentId, newName) => {
// //     try {
// //       const response = await api.put(
// //         `api/v1/readpdf/rename-doc/${documentId}/`,
// //         { new_name: newName }
// //       );
// //       if (response.status === 200) {
// //         // Update the file name in state
// //         setFiles((prevFiles) =>
// //           prevFiles.map((file) =>
// //             file.id === documentId
// //               ? { ...file, pdf_name: response.data.new_name }
// //               : file
// //           )
// //         );

// //         // ✅ Don’t show popup — just close modal and refresh if needed
// //         fetchContracts(); // Optional if you want to refetch everything
// //         fetchFolders(); // Optional
// //       }
// //     } catch (err) {
// //       showPopup("Error", "Rename failed. Please try again.");
// //       throw err; // Rethrow to allow modal to close properly
// //     }
// //   };

// //   const handleRenameFolder = async (folderId, newName) => {
// //     try {
// //       const response = await api.put(
// //         // ✅ using api instance
// //         `api/v1/readpdf/rename-folder/${folderId}/`,
// //         { new_name: newName }
// //       );

// //       if (response.status === 200) {
// //         setFolders((prevFolders) =>
// //           prevFolders.map((folder) =>
// //             folder.id === folderId
// //               ? { ...folder, folder_name: response.data.folder_name }
// //               : folder
// //           )
// //         );

// //         // ✅ Don’t show popup — just refresh data
// //         fetchContracts();
// //         fetchFolders();
// //       }
// //     } catch (error) {
// //       if (error.response) {
// //         showPopup(
// //           "Error",
// //           `Failed to rename folder: ${
// //             error.response.data.msg || error.response.statusText
// //           }`
// //         );
// //       } else if (error.request) {
// //         showPopup(
// //           "Error",
// //           "Failed to rename folder: No response received from the server."
// //         );
// //       } else {
// //         showPopup("Error", "An unexpected error occurred. Please try again.");
// //       }
// //     }
// //   };

// //   const handleCopyToFolder = async (folderId, fileIds) => {
// //     const flatFileIds = fileIds.flat();

// //     setCopyInProgress(true);

// //     try {
// //       const response = await api.post(
// //         `api/v1/readpdf/add-files/`,
// //         { file_ids: flatFileIds, folder_id: folderId } // No need for headers here
// //       );

// //       if (response.status === 200) {
// //         setFileId(folderId);
// //         setSuccessFolderName(
// //           folders.find((f) => f.id === folderId)?.name || "Selected Folder"
// //         );
// //         setIsSuccessPopupVisible(true);
// //       }
// //     } catch (error) {
// //       if (error.response) {
// //         toast.error(
// //           error.response.data.msg ||
// //             "Failed to copy documents. Please try again.",
// //           { autoClose: 3000 }
// //         );
// //       } else if (error.request) {
// //         showPopup(
// //           "Error",
// //           "No response received from the server. Please check your network."
// //         );
// //       } else {
// //         showPopup("Error", "An unexpected error occurred. Please try again.");
// //       }
// //     } finally {
// //       setCopyInProgress(false); // End loading
// //     }
// //   };

// //   const handleViewMore = (fileKey) => {
// //     if (!fileKey) {
// //       alert("File key is not available.");
// //       return;
// //     }

// //     navigate("/Contract/contract-details", { state: { contractKey: fileKey } });
// //   };

// //   const enableEdit = (contract) => {
// //     if (contract) {
// //       setIsActionMenuOpen(false);
// //       setEditContractId(contract.id);
// //       setEditedContractData({ ...contract });
// //     } else {
// //       setEditContractId(null);
// //       setEditedContractData({});
// //     }
// //   };

// //   const handleEditChange = (field, value) => {
// //     setEditedContractData((prev) => ({
// //       ...prev,
// //       [field]: value,
// //     }));
// //   };
// //   const goToPage = (pageNumber) => {
// //     if (pageNumber < 1 || pageNumber > totalPages) return;
// //     setCurrentPage(pageNumber);
// //   };

// //   const handleIncreasePage = () => {
// //     setCurrentPage((prevPage) =>
// //       prevPage < totalPages ? prevPage + 1 : prevPage
// //     );
// //   };

// //   const handleDecreasePage = () => {
// //     setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
// //   };

// //   const showPopup = (title, message) => {
// //     setIsSuccessPopupVisible(false);
// //     setPopupTitle(title);
// //     setPopupMessage(message);
// //     setPopupVisible(true);
// //   };

// //   const closePopup = () => {
// //     setPopupVisible(false);
// //     fetchContracts();
// //     fetchFolders();
// //   };

// //   const [showModal, setShowModal] = useState(false);

// //   const openModal = () => {
// //     setShowModal(true);
// //   };

// //   const closeModal = () => {
// //     setShowModal(false);
// //   };
// //   var intervalId;
// //   const [loading, setLoading] = useState(false);
// //   const navigate = useNavigate();
// //   const [status, setStatus] = useState("");

// //   const location = useLocation();

// //   const contractKey = location.state?.contractKey;
// //   useEffect(() => {
// //     if (location.state?.cancelledPdfKeys) {
// //       setCancelledPdfKeys(location.state.cancelledPdfKeys);
// //     }
// //   }, [location.state]);

// //   useEffect(() => {
// //     if (contractKey) {
// //     } else {
// //     }
// //   }, [contractKey]);

// //   const formatDateTimeWithRelative = (dateTimeString) => {
// //     if (!dateTimeString) return "N/A";

// //     const date = new Date(dateTimeString);
// //     const now = new Date();

// //     if (isNaN(date.getTime())) return "N/A";

// //     const diffInMs = now - date;
// //     const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
// //     const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
// //     const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

// //     let relativeTime;
// //     if (diffInMinutes < 1) {
// //       relativeTime = "Just now";
// //     } else if (diffInMinutes < 60) {
// //       relativeTime = `${diffInMinutes} minutes ago`;
// //     } else if (diffInHours < 24) {
// //       relativeTime = `${diffInHours} hours ago`;
// //     } else {
// //       relativeTime = `${diffInDays} days ago`;
// //     }

// //     const absoluteDate = date.toLocaleDateString("en-GB", {
// //       day: "2-digit",
// //       month: "2-digit",
// //       year: "numeric",
// //     });

// //     return `${relativeTime} (${absoluteDate})`;
// //   };
// //   const handleFile = (e) => {
// //     return new Promise((resolve, reject) => {
// //       let selectedFile = e.target.files[0];

// //       const fileType = ["application/pdf"];

// //       if (selectedFile) {
// //         if (selectedFile && fileType.includes(selectedFile.type)) {
// //           let reader = new FileReader();
// //           reader.readAsDataURL(selectedFile);
// //           reader.onload = (e) => {
// //             const result = e.target.result;
// //             resolve(result);
// //           };
// //           reader.onerror = (error) => {
// //             reject(error);
// //           };
// //         } else {
// //         }
// //       } else {
// //         reject(new Error("No file selected"));
// //       }
// //     });
// //   };

// //   const handleBulkDelete = async () => {
// //     if (selectedContracts.length === 0) {
// //       showPopup("Error", "No files or folders selected for deletion.");
// //       return;
// //     }
// //     setDeleteInProgress(true);
// //     try {
// //       const folderIds = selectedContracts
// //         .filter(
// //           (item) =>
// //             item.documents ||
// //             item.document_type === "folder" ||
// //             item.doc_type === "folder"
// //         )
// //         .map((item) => item.id);

// //       const documentIds = selectedContracts
// //         .filter(
// //           (item) =>
// //             !item.documents &&
// //             item.document_type !== "folder" &&
// //             item.doc_type !== "folder"
// //         )
// //         .map((item) => item.id);

// //       const payload = {
// //         folder_ids: folderIds,
// //         document_ids: documentIds,
// //       };

// //       const response = await api.post(`api/v1/readpdf/bulk-delete/`, payload);

// //       if (response.status === 200) {
// //         const { deleted_folders, deleted_documents, failed_collections } =
// //           response.data;

// //         setFiles((prevFiles) =>
// //           prevFiles.filter((file) => !deleted_documents.includes(file.id))
// //         );
// //         setFolders((prevFolders) =>
// //           prevFolders.filter((folder) => !deleted_folders.includes(folder.id))
// //         );

// //         setSelectedContracts([]);

// //         setTimeout(() => {
// //           setConfirmDeleteVisible(false);
// //           setDeleteInProgress(false);
// //           fetchContracts(); // ✅ Refetch data to reflect updated table
// //           fetchFolders();
// //         }, 2000);
// //       } else {
// //         showPopup(
// //           "Error",
// //           "Failed to delete selected items. Please try again."
// //         );
// //       }
// //     } catch (error) {
// //       showPopup("Error", "An unexpected error occurred during deletion.");
// //       setConfirmDeleteVisible(false);
// //       setDeleteInProgress(false);
// //       fetchContracts(); // ✅ Refetch data to reflect updated table
// //       fetchFolders();
// //     } finally {
// //       setConfirmDeleteVisible(false);
// //     }
// //   };

// //   const handleResponse = (res, file) => {
// //     if (!res || !res.data) {
// //       return setStatus("Failed to get a valid response from the server");
// //     }

// //     if (res.data.pdf_key) {
// //       localStorage.setItem("pdfKey", res.data.pdf_key);
// //     }

// //     switch (res.data.status) {
// //       case "STARTING":
// //         return setStatus("Uploading Pdf ..");
// //       case "LOADING":
// //         return setStatus("Loading Pdf ...");
// //       case "ANALYZING":
// //         return setStatus("Analysing Pdf ...");
// //       case "SUMMARIZING":
// //         return setStatus("Summarizing Pdf ...");
// //       case "PENDING":
// //         return setStatus("Maybe Asynchronous task failed...");
// //       case "FAILED":
// //         return setStatus("Failed due to some issues, please try again!");
// //       case "Completed":
// //         clearInterval(intervalId);
// //         setStatus("Upload successful!");

// //         return location.pathname === "/test"
// //           ? navigate("/test/c", {
// //               state: {
// //                 summary: res.data.data.summary,
// //                 questions: res.data.data.examples,
// //                 file: file,
// //               },
// //             })
// //           : navigate("/chat", {
// //               state: {
// //                 summary: res.data.data.summary,
// //                 questions: res.data.data.examples,
// //                 file: file,
// //               },
// //             });
// //       default:
// //         throw new Error(`Unknown status from server ${res.data.status}`);
// //     }
// //   };

// //   const handleDelete = (pdfId) => {
// //     if (!token) {
// //       showPopup("Session Expired", "Session expired. Please log in again.");
// //       return;
// //     }

// //     setPopupTitle("Are you sure you want to delete the selected item(s)");
// //     setPopupMessage(
// //       "Are you sure you want to delete this PDF? This action cannot be undone."
// //     );

// //     setContractToDelete(pdfId);
// //     setDeleteTarget("single");
// //     setShowSingleDeleteConfirm(true);
// //   };

// //   const handleEditSave = async (contractId) => {
// //     if (!editedContractData.contract_name) {
// //       showPopup("Error", "Contract name is required.");
// //       return;
// //     }

// //     try {
// //       const response = await api.post(`api/v1/contract/edit-contract-name/`, {
// //         contract_key: editedContractData?.key,
// //         new_contract_name: editedContractData?.contract_name,
// //       });

// //       if (response.status === 200) {
// //         setFiles((prevFiles) =>
// //           prevFiles.map((filee) =>
// //             filee.id === filee ? editedContractData : filee
// //           )
// //         );
// //         setEditContractId(null);
// //         showPopup("Success", "Contract updated successfully.");
// //       }
// //     } catch (error) {
// //       if (error.response) {
// //         showPopup(
// //           "Error",
// //           `Failed to update contract: ${
// //             error.response.data.msg || error.response.statusText
// //           }`
// //         );
// //       } else if (error.request) {
// //         showPopup(
// //           "Error",
// //           "Failed to update contract: No response received from the server."
// //         );
// //       } else {
// //         showPopup("Error", "Failed to update contract. Please try again.");
// //       }
// //     }
// //   };

// //   const confirmDelete = async () => {
// //     if (!contractToDelete || !token) {
// //       showPopup("Error", "No file or folder selected for deletion.");
// //       return;
// //     }

// //     setDeleteInProgress(true);

// //     try {
// //       // Determine if it's a folder or a document
// //       const targetItem = [...files, ...folders].find(
// //         (item) => item.id === contractToDelete
// //       );

// //       const isFolder =
// //         targetItem?.documents ||
// //         targetItem?.document_type === "folder" ||
// //         targetItem?.doc_type === "folder";

// //       const payload = {
// //         folder_ids: isFolder ? [contractToDelete] : [],
// //         document_ids: !isFolder ? [contractToDelete] : [],
// //       };

// //       const response = await api.post(`api/v1/readpdf/bulk-delete/`, payload);

// //       if (response.status === 200) {
// //         const { deleted_folders = [], deleted_documents = [] } = response.data;

// //         // Update local state
// //         setFiles((prev) =>
// //           prev.filter((file) => !deleted_documents.includes(file.id))
// //         );
// //         setFolders((prev) =>
// //           prev.filter((folder) => !deleted_folders.includes(folder.id))
// //         );

// //         fetchContracts();
// //         fetchFolders();
// //       } else {
// //         toast.error("Failed to delete the item. Please try again.");
// //       }
// //     } catch (error) {
// //       toast.error("An unexpected error occurred during deletion.");
// //       setDeleteInProgress(false);
// //       setConfirmDeleteVisible(false);
// //       setContractToDelete(null);
// //       fetchContracts();
// //       fetchFolders();
// //     } finally {
// //       setDeleteInProgress(false);
// //       setConfirmDeleteVisible(false);
// //       setContractToDelete(null);
// //     }
// //   };

// //   useEffect(() => {
// //     if (editContractId) {
// //       document.addEventListener("mousedown", handleClickOutside);
// //     } else {
// //       document.removeEventListener("mousedown", handleClickOutside);
// //     }

// //     return () => {
// //       document.removeEventListener("mousedown", handleClickOutside);
// //     };
// //   }, [editContractId]);

// //   const upload = async (e) => {
// //     const selectedFile = e.target.files[0];
// //     if (!selectedFile) {
// //       return;
// //     }

// //     const formData = new FormData();
// //     formData.append("file", e.target.files[0]);
// //     let file = null;
// //     handleFile(e).then((res) => {
// //       file = res;
// //     });

// //     try {
// //       setLoading(true);
// //       setStatus("Uploading...");
// //       const response = await api
// //         .post(`api/v1/readpdf/qdrant-upload-async/`, formData, {
// //           headers: {
// //             "Content-Type": "multipart/form-data",
// //           },
// //         })
// //         .then((res) => {});
// //     } catch (err) {
// //       setLoading(false);
// //       setStatus("Error during file upload");
// //       if (
// //         err.response &&
// //         err.response.data &&
// //         err.response.data.msg === "Unsupported file format"
// //       ) {
// //         toast.warn("Unsupported file format", { autoClose: 2000 });
// //       } else {
// //         toast.error("An error occurred during file upload", {
// //           autoClose: 2000,
// //         });
// //       }
// //     }
// //   };

// //   const handleDeleteFolder = async (folderId) => {
// //     setDeleteInProgress(true);
// //     try {
// //       const response = await api.delete(
// //         `api/v1/readpdf/delete-folder/${folderId}/`
// //       );

// //       if (response.status === 204) {
// //         setFolders((prevFolders) =>
// //           prevFolders.filter((folder) => folder.id !== folderId)
// //         );

// //         setTimeout(() => {
// //           setIsDeleteFolderModalOpen(false); // ✅ Close modal after delay
// //           setDeleteInProgress(false); // ✅ Stop loader
// //           fetchContracts();
// //           fetchFolders();
// //         }, 2000);
// //       } else {
// //         showPopup("Error", "Failed to delete folder. Please try again.");
// //         setDeleteInProgress(false);
// //       }
// //     } catch (error) {
// //       showPopup("Error", "Failed to delete folder. Please try again.");
// //       setDeleteInProgress(false);
// //     }
// //   };

// //   const [isSearchFocused, setIsSearchFocused] = useState(false);
// //   const [isTooltipVisible, setIsTooltipVisible] = useState(false);

// //   return (
// //     <>
// //       {loading && <Spinner />}
// //       <div className="full-container max-w-full overflow-x-hidden">
// //         <div className="">
// //           <Header name="Documents" icon={""} isMenuOpen={isMenuOpen} />
// //         </div>

// //         <div>
// //           <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[6px]">
// //             {/* LEFT: Search & Filter */}
// //             <div
// //               className="flex items-center gap-1 min-w-[300px]"
// //               style={{ marginLeft: isMenuOpen ? "206px" : "110px" }}
// //             >
// //               {/* Search */}
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   width: "320px",
// //                   height: "40px",
// //                   padding: "8px 20px 8px 26px", // ← increased left padding
// //                   alignItems: "center",
// //                   gap: "1px",
// //                   flexShrink: 0,
// //                   borderRadius: "20px",
// //                   border: isSearchFocused
// //                     ? "1px solid rgba(187, 66, 174, 0.36)"
// //                     : "1px solid rgba(0, 0, 0, 0.10)",
// //                   backgroundColor: "#FFF",
// //                   boxShadow: isSearchFocused
// //                     ? "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)"
// //                     : "none",
// //                   overflow: "hidden",
// //                 }}
// //               >
// //                 <img
// //                   src="/search.svg"
// //                   alt="Search"
// //                   style={{
// //                     width: "24px",
// //                     height: "24px",
// //                     flexShrink: 0,
// //                     marginRight: "4px", // ← extra spacing between icon and input
// //                   }}
// //                 />
// //                 <input
// //                   type="text"
// //                   placeholder="Search by name or type Tags: tagname"
// //                   value={searchQuery}
// //                   onChange={(e) => {
// //                     const value = e.target.value;
// //                     setSearchQuery(value);

// //                     // Enter "tag mode" if user types "tags:" or "Tags:"
// //                     if (value.toLowerCase().startsWith("tags:")) {
// //                       setIsTagSearch(true);
// //                     } else {
// //                       setIsTagSearch(false);
// //                     }
// //                   }}
// //                   onFocus={() => setIsSearchFocused(true)}
// //                   onBlur={() => setIsSearchFocused(false)}
// //                   style={{
// //                     fontFamily: "Outfit, sans-serif",
// //                     fontSize: "14px",
// //                     fontStyle: "normal",
// //                     fontWeight: 400,
// //                     lineHeight: "normal",
// //                     border: "none",
// //                     outline: "none",
// //                     width: "100%",
// //                     overflowX: "auto",
// //                     whiteSpace: "nowrap",
// //                     color: "#171717",
// //                   }}
// //                 />
// //               </div>

// //               {/* Filter */}
// //               <button
// //                 ref={filterBtnRef}
// //                 onMouseEnter={() => setIsHovered(true)}
// //                 onMouseLeave={() => setIsHovered(false)}
// //                 className={`button-filter-doc-button  bg-white border ${
// //                   isFilterApplied
// //                     ? "border-[rgba(187,66,174,0.36)]"
// //                     : "border-[rgba(0,0,0,0.10)]"
// //                 }`}
// //                 onClick={toggleFilterModal}
// //               >
// //                 <img
// //                   src="/filter-icon-first.svg"
// //                   alt="Filter Icon"
// //                   className="inline-block mr-2"
// //                 />
// //                 <span className="filter-text-button">Filter</span>
// //               </button>

// //               {isFilterApplied && (
// //                 <>
// //                   <img
// //                     src="/Filter_CTA.svg"
// //                     alt="Clear Filter"
// //                     className="absolute bottom-6 -right-1 w-5 h-5"
// //                     onClick={clearFilters}
// //                   />

// //                   <FilterAppliedTooltip
// //                     targetRef={filterBtnRef}
// //                     isVisible={isHovered}
// //                     selectedFilters={selectedFilters}
// //                   />
// //                 </>
// //               )}
// //             </div>

// //             {/* RIGHT: Custom field, Upload, Bulk Actions */}
// //             <div className="flex items-center gap-3 flex-wrap justify-end">
// //               {selectedContracts.length > 0 ? (
// //                 <div className="flex items-center gap-2 flex-wrap justify-end">
// //                   {/* ✅ Selected Count Badge — shown for all */}
// //                   <div
// //                     style={{
// //                       display: "flex",
// //                       padding: "3px 12px",
// //                       justifyContent: "center",
// //                       alignItems: "center",
// //                       gap: "10px",
// //                       borderRadius: "8px",
// //                       background: "rgba(139, 85, 221, 0.08)",
// //                       color: "#8B55DD",
// //                       fontFamily: "Outfit",
// //                       fontSize: "14px",
// //                       fontWeight: 400,
// //                     }}
// //                   >
// //                     {selectedContracts.length} Documents selected
// //                   </div>

// //                   {/* ✅ Bulk Tag — shown for all (including folders) */}
// //                   <button
// //                     onClick={() => setIsBulkTagModalOpen(true)}
// //                     className="flex items-center h-[36px] px-[14px] py-[8px] gap-[4px] rounded-[6px] border border-[rgba(0,0,0,0.10)] bg-[#8B55DD] text-white text-sm font-[Outfit]"
// //                   >
// //                     <span className="text-[#F5F4F3] font-[Outfit] text-[14px] font-medium leading-none">
// //                       Bulk tag
// //                     </span>
// //                     <img
// //                       src="/tag-icon-white.svg"
// //                       alt="Tag"
// //                       className="w-4 h-4"
// //                     />
// //                   </button>

// //                   {/* ✅ Copy to Folder — only if all are files (not folders) */}
// //                   {selectedContracts.every(
// //                     (item) => item.document_type !== "folder" && !item.documents
// //                   ) && (
// //                     <button
// //                       onClick={(e) => {
// //                         e.stopPropagation();
// //                         setCurrentDocument(selectedContracts);
// //                         setIsCopyModalOpen(true);
// //                       }}
// //                       disabled={exportInProgress}
// //                       className="flex items-center justify-center gap-1.5 px-[14px] py-[8px] rounded-full border border-[rgba(0,0,0,0.10)] bg-[rgba(139,85,221,0.16)] text-[#8B55DD] font-medium text-sm font-[Outfit] transition disabled:opacity-60 disabled:cursor-not-allowed"
// //                     >
// //                       <img
// //                         src="./copyToFolder.svg"
// //                         alt="Copy"
// //                         className="w-4 h-4 inline-block"
// //                       />
// //                       <span className="text-[#8B55DD] text-[14px] font-medium leading-none">
// //                         {exportInProgress ? "Copying..." : "Copy to Folder"}
// //                       </span>
// //                     </button>
// //                   )}

// //                   {/* ✅ Export — if all are invoice/contract */}
// //                   {selectedContracts.every(
// //                     (item) =>
// //                       item.document_type === "contract" ||
// //                       item.document_type === "invoice"
// //                   ) && (
// //                     <button
// //                       onClick={handleExport}
// //                       disabled={exportInProgress}
// //                       className="flex items-center justify-center gap-1 px-[14px] py-[8px] rounded-full border border-[rgba(0,0,0,0.10)] bg-[rgba(139,85,221,0.16)] disabled:opacity-60 disabled:cursor-not-allowed transition"
// //                     >
// //                       <img
// //                         src="/export-icon-blue.svg"
// //                         alt="Export"
// //                         className="w-4 h-4"
// //                       />
// //                       <span className="text-[#8B55DD] font-[Outfit] text-[14px] font-medium leading-none">
// //                         {exportInProgress ? "Exporting..." : "Export"}
// //                       </span>
// //                     </button>
// //                   )}

// //                   {/* ✅ Delete — always visible if any selected */}
// //                   <button
// //                     onClick={handleBulkDeleteConfirmation}
// //                     disabled={selectedContracts.length === 0}
// //                     className="flex items-center justify-center gap-1 px-[14px] py-[8px] rounded-full border border-transparent bg-red-100 hover:bg-red-200 disabled:opacity-60 disabled:cursor-not-allowed transition"
// //                   >
// //                     <img
// //                       src="/delete-icon-red.svg"
// //                       alt="Delete"
// //                       className="w-4 h-4"
// //                     />
// //                     <span className="text-[rgba(226,25,25,0.76)] font-[Outfit] text-[14px] font-medium leading-none">
// //                       Delete
// //                     </span>
// //                   </button>

// //                   {/* ✅ Cancel Button */}
// //                   <button
// //                     onClick={handleCancel}
// //                     className="flex items-center justify-center gap-1 p-2 rounded-full border border-[rgba(0,0,0,0.10)] bg-[#ECECEC] transition"
// //                   >
// //                     <img
// //                       src="/cancel_icon.svg"
// //                       alt="Cancel Icon"
// //                       className="w-5 h-5 min-w-[20px] min-h-[20px]"
// //                     />
// //                   </button>
// //                 </div>
// //               ) : (
// //                 <>
// //                   {/* Create Folder */}
// //                   <button
// //                     onClick={() => setIsCreateFolderModalOpen(true)}
// //                     className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-md border border-[#C95EBE] bg-white hover:bg-gray-50 transition"
// //                   >
// //                     <img
// //                       src="/upload-doc-create.svg"
// //                       alt="Create Folder"
// //                       className="w-5 h-5"
// //                     />
// //                     <span className="text-[#C95EBE] font-[Outfit] text-[14px] font-semibold leading-[24px] tracking-[0.14px]">
// //                       Create Folder
// //                     </span>
// //                   </button>

// //                   {/* Upload Button with Tooltip */}
// //                   <div className="relative z-50 inline-block">
// //                     <button
// //                       ref={uploadButtonRef}
// //                       className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
// //                       onClick={() => setIsTooltipVisible(!isTooltipVisible)}
// //                       onMouseEnter={() => {
// //                         if (uploadButtonRef.current) {
// //                           const rect =
// //                             uploadButtonRef.current.getBoundingClientRect();
// //                           setTooltipCoords({
// //                             top: rect.top + window.scrollY + 45,
// //                             left: rect.left + window.scrollX + rect.width - 140,
// //                           });
// //                         }
// //                       }}
// //                     >
// //                       <img src="/upload_icon_white.svg" className="w-5 h-5" />
// //                       <span className="new-custom-butons-design-texts">
// //                         Upload
// //                       </span>
// //                     </button>

// //                     {/* Tooltip */}
// //                     {isTooltipVisible && (
// //                       <div
// //                         className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
// //                         style={{
// //                           top: `${tooltipCoords.top + 10}px`,
// //                           left: `${tooltipCoords.left - 50}px`,
// //                         }}
// //                         onMouseLeave={() => setIsTooltipVisible(false)}
// //                       >
// //                         {/* Upload from Device */}
// //                         <div
// //                           className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
// //                           onClick={() => {
// //                             setIsTooltipVisible(false);
// //                             fileInputRef.current.click();
// //                           }}
// //                         >
// //                           <img
// //                             src="/upload-icon.svg"
// //                             alt="Upload"
// //                             className="w-4 h-4"
// //                           />
// //                           Add from device
// //                         </div>

// //                         {/* Connect Google Drive */}
// //                         {!isConnected && (
// //                           <div
// //                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
// //                             onClick={() => {
// //                               setIsTooltipVisible(false);
// //                               navigate("/account/integration");
// //                             }}
// //                             onMouseEnter={() => setIsHovered(true)}
// //                             onMouseLeave={() => setIsHovered(false)}
// //                           >
// //                             <img
// //                               src={
// //                                 isHovered
// //                                   ? "/connect-icon-hover.svg"
// //                                   : "/connect-icon.svg"
// //                               }
// //                               alt="Open Picker"
// //                               className="w-4 h-4 transition-all duration-150"
// //                             />{" "}
// //                             Connect Drive
// //                           </div>
// //                         )}

// //                         {isConnected && (
// //                           <div
// //                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
// //                             onMouseEnter={() => setIsHovered(true)}
// //                             onMouseLeave={() => setIsHovered(false)}
// //                             onClick={handleAddFromDriveClick} // Trigger the picker on click
// //                           >
// //                             <img
// //                               src={
// //                                 isHovered
// //                                   ? "/picker-icon-hover.svg"
// //                                   : "/picker-icon.svg"
// //                               }
// //                               alt="Open Picker"
// //                               className="w-4 h-4 transition-all duration-150"
// //                             />
// //                             Add from Drive
// //                           </div>
// //                         )}
// //                       </div>
// //                     )}

// //                     <input
// //                       ref={fileInputRef}
// //                       type="file"
// //                       multiple
// //                       className="hidden"
// //                       accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png,.docx"
// //                       onChange={handleFileChange}
// //                     />

// //                     {/* Tooltip rendered in a portal */}
// //                     <HoverTooltip
// //                       targetRef={uploadBtnRef}
// //                       isVisible={isTooltipVisible}
// //                       content={"Your tooltip content"}
// //                     />
// //                   </div>
// //                 </>
// //               )}
// //             </div>
// //           </div>

// //           {/* Main scrollable container for the table only */}
// //           <div
// //             className={`overflow-x-auto  transition-all duration-300 mt-1 w-full`}
// //             style={{
// //               marginLeft: isMenuOpen ? "182px" : "80px",
// //             }}
// //           >
// //             <div className="overflow-x-auto w-[100%]">
// //               <div
// //                 className="relative overflow-x-auto  custom-scrollbar-container"
// //                 style={{
// //                   height: "calc(100vh - 158px)", // Adjust height as needed
// //                 }}
// //                 ref={tbodyRef}
// //               >
// //                 <table className="text-sm text-left table-auto w-full">
// //                   <thead className="bg-[#FFF] h-[46px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
// //                     <tr>
// //                       <th className="w-[40px] px-3">
// //                         <input
// //                           type="checkbox"
// //                           className="custom-checkbox"
// //                           style={{
// //                             appearance: "none",
// //                             // width: "16px",
// //                             // height: "16px",
// //                             border: "1.5px solid #c0c0c0",
// //                             borderRadius: "4px",
// //                             cursor: "pointer",
// //                             backgroundImage:
// //                               selectedContracts.length ===
// //                                 folders.length + files.length &&
// //                               folders.length + files.length > 0
// //                                 ? "url('/checck.svg')"
// //                                 : "none",
// //                             backgroundPosition: "center",
// //                             backgroundRepeat: "no-repeat",
// //                             backgroundSize: "20px 20px",
// //                           }}
// //                           onChange={handleSelectAll}
// //                           checked={
// //                             selectedContracts.length ===
// //                               folders.length + files.length &&
// //                             folders.length + files.length > 0
// //                           }
// //                         />
// //                       </th>
// //                       <th className="w-[60px] px-1 file-size-of-heading">
// //                         File Name
// //                       </th>
// //                       <th className="w-[60px] px-3 file-size-of-heading">
// //                         File Type
// //                       </th>
// //                       <th className="w-[60px] px-3 file-size-of-heading">
// //                         <div
// //                           className="flex items-center gap-2 cursor-pointer"
// //                           onClick={handleSortBySize}
// //                         >
// //                           <span>Size</span>
// //                           <img
// //                             src="/icons-size-icon.svg"
// //                             alt="Size Icon"
// //                             className="w-4 h-4"
// //                           />
// //                         </div>
// //                       </th>
// //                       <th className="w-[70px] px-3 file-size-of-heading">
// //                         <div
// //                           className="flex items-center gap-2 cursor-pointer"
// //                           onClick={handleSortByDate}
// //                         >
// //                           <span>Uploaded Date</span>
// //                           <img
// //                             src="/icons-size-icon.svg"
// //                             alt="Date Icon"
// //                             className="w-4 h-4"
// //                           />
// //                         </div>
// //                       </th>
// //                       <th className="w-[70px] px-3 file-size-of-heading">
// //                         Tags
// //                       </th>
// //                       <th className="w-[50px] px-3 file-size-of-heading">
// //                         Chat
// //                       </th>
// //                       <th className="w-[200px] px-3 file-size-of-heading">
// //                         Action
// //                       </th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {loading ? (
// //                       <tr className="h-[36px]">
// //                         <td colSpan="7" className="text-center">
// //                           <Spinner />
// //                         </td>
// //                       </tr>
// //                     ) : filteredPaginatedData.length > 0 ? (
// //                       filteredPaginatedData.map((item, index) => (
// //                         <tr
// //                           key={`${
// //                             item.isFolder ? item.doc_type : item.document_type
// //                           }-${index}`}
// //                           className="h-[40px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
// //                           onClick={(e) => {
// //                             if (
// //                               e.target.type !== "checkbox" &&
// //                               !e.target.classList.contains("action-button")
// //                             ) {
// //                               e.stopPropagation();

// //                               // ⛔ Prevent navigation if item is cancelled
// //                               if (cancelledPdfKeys.includes(item.key)) {
// //                                 return;
// //                               }

// //                               if (item.documents) {
// //                                 navigate(`/folder/?folderId=${item.id}`, {
// //                                   state: {
// //                                     folderId: item.id,
// //                                     folderName: item.name,
// //                                   },
// //                                 });
// //                               } else {
// //                                 navigate("/chat", {
// //                                   state: {
// //                                     pdfUrl: item.pdf_url,
// //                                     pdfKey: item.key,
// //                                     pdfId: item.id,
// //                                     document_type: item.document_type || null,
// //                                   },
// //                                 });
// //                               }
// //                             }
// //                           }}
// //                         >
// //                           <td className="px-3">
// //                             <input
// //                               type="checkbox"
// //                               className="custom-checkbox"
// //                               style={{
// //                                 appearance: "none",
// //                                 // width: "16px",
// //                                 // height: "16px",
// //                                 border: "1.5px solid #c0c0c0",
// //                                 borderRadius: "4px",
// //                                 cursor: "pointer",
// //                                 backgroundImage: selectedContracts.some(
// //                                   (selectedItem) => selectedItem.id === item.id
// //                                 )
// //                                   ? "url('/checck.svg')"
// //                                   : "none",
// //                                 backgroundPosition: "center",
// //                                 backgroundRepeat: "no-repeat",
// //                                 backgroundSize: "20px 20px",
// //                               }}
// //                               checked={selectedContracts.some(
// //                                 (selectedItem) => selectedItem.id === item.id
// //                               )}
// //                               onChange={() =>
// //                                 handleCheckboxChange({
// //                                   ...item,
// //                                   document_type: item.isFolder
// //                                     ? item.doc_type
// //                                     : item.document_type,
// //                                 })
// //                               }
// //                             />
// //                           </td>
// //                           <td className="px-1 truncate">
// //                             <div className="flex items-center gap-2">
// //                               <img
// //                                 src={
// //                                   item.documents
// //                                     ? "/folder-icon-new.svg"
// //                                     : item.file_type === "pdf"
// //                                     ? "/pdff.svg"
// //                                     : item.file_type === "xlsx"
// //                                     ? "/Xls.svg"
// //                                     : item.file_type === "docx"
// //                                     ? "/docX.svg"
// //                                     : item.file_type === "csv"
// //                                     ? "/CSV.svg"
// //                                     : item.file_type === "txt"
// //                                     ? "/TXT.svg"
// //                                     : item.file_type === "xls"
// //                                     ? "/Xls.svg"
// //                                     : "/pdf.svg"
// //                                 }
// //                                 className="w-5 h-5"
// //                                 alt="Icon"
// //                               />
// //                               <FileNameWithTooltip name={item.name} />
// //                             </div>
// //                           </td>
// //                           <td className="px-3 file-size-of-subheading">
// //                             {item.documents
// //                               ? "Folder"
// //                               : item.document_type || "N/A"}
// //                           </td>
// //                           <td className="px-3 file-size-of-subheading">
// //                             {item.documents
// //                               ? item.folder_size || item.size || "N/A"
// //                               : item.document_size || item.size || "N/A"}
// //                           </td>
// //                           <td className="px-3 file-size-of-subheading">
// //                             {item.created_at || item.uploaded_at
// //                               ? new Date(
// //                                   item.created_at || item.uploaded_at
// //                                 ).toLocaleDateString()
// //                               : "N/A"}
// //                           </td>
// //                           <td className="px-3 file-size-of-subheading">
// //                             {item.tags && item.tags.length > 0 ? (
// //                               <div
// //                                 className={`flex flex-wrap gap-1 relative max-w-[190px] ${
// //                                   cancelledPdfKeys.includes(item.key)
// //                                     ? "opacity-50 cursor-not-allowed pointer-events-none"
// //                                     : "group"
// //                                 }`}
// //                                 onClick={(e) => {
// //                                   if (cancelledPdfKeys.includes(item.key))
// //                                     return;
// //                                   e.stopPropagation();
// //                                   setTagModalDocId(item.id);
// //                                 }}
// //                               >
// //                                 {item.tags.slice(0, 2).map((tag) => (
// //                                   <span
// //                                     key={tag.id}
// //                                     className="tag-pill cursor-pointer"
// //                                     style={{
// //                                       color: darkenColor(tag.color),
// //                                       backgroundColor: `${tag.color}1A`,
// //                                       border: `2px solid ${tag.color}`,
// //                                     }}
// //                                   >
// //                                     {tag.name}
// //                                   </span>
// //                                 ))}

// //                                 {item.tags.length > 2 &&
// //                                   (() => {
// //                                     const tag = item.tags[2];
// //                                     return (
// //                                       <span
// //                                         className="tag-pill"
// //                                         style={{
// //                                           color: darkenColor(tag.color),
// //                                           backgroundColor: `${tag.color}1A`,
// //                                           border: `2px solid ${tag.color}`,
// //                                         }}
// //                                       >
// //                                         +{item.tags.length - 2}
// //                                       </span>
// //                                     );
// //                                   })()}

// //                                 {/* Hover card only shown when not disabled */}
// //                                 {!cancelledPdfKeys.includes(item.key) && (
// //                                   <div className="hidden group-hover:flex absolute top-[100%] left-0 mt-1 z-50 bg-white p-2 rounded-md shadow-lg border border-gray-200 flex-wrap gap-1 w-max max-w-xs">
// //                                     {item.tags.map((tag) => (
// //                                       <span
// //                                         key={tag.id}
// //                                         className="tag-pill"
// //                                         style={{
// //                                           color: darkenColor(tag.color),
// //                                           backgroundColor: `${tag.color}1A`,
// //                                           border: `2px solid ${tag.color}`,
// //                                         }}
// //                                       >
// //                                         {tag.name}
// //                                       </span>
// //                                     ))}
// //                                   </div>
// //                                 )}
// //                               </div>
// //                             ) : (
// //                               <span
// //                                 className={`inline-flex items-center gap-2 px-3 py-[6px] rounded-[20px] border border-[rgba(0,0,0,0.10)] bg-white text-[#52525B] text-[14px] font-[500] font-[Outfit] ${
// //                                   cancelledPdfKeys.includes(item.key)
// //                                     ? "opacity-50 cursor-not-allowed pointer-events-none"
// //                                     : "cursor-pointer"
// //                                 }`}
// //                                 onClick={(e) => {
// //                                   if (cancelledPdfKeys.includes(item.key))
// //                                     return;
// //                                   e.stopPropagation();
// //                                   setTagModalDocId(item.id);
// //                                 }}
// //                               >
// //                                 + Add Tag
// //                               </span>
// //                             )}
// //                           </td>

// //                           <td className="px-3 file-size-of-subheading">
// //                             <div
// //                               title={
// //                                 cancelledPdfKeys.includes(item.key)
// //                                   ? "You cancelled this upload. Please refresh to remove it."
// //                                   : ""
// //                               }
// //                             >
// //                               <button
// //                                 onClick={(e) => {
// //                                   e.stopPropagation();

// //                                   if (cancelledPdfKeys.includes(item.key)) {
// //                                     return;
// //                                   }

// //                                   if (item.documents) {
// //                                     navigate("/Contract/FolderChat", {
// //                                       state: {
// //                                         folderId: item.id,
// //                                         folderName: item.name || "N/A",
// //                                         pdfList: item.documents.map((doc) => ({
// //                                           pdfKey: doc.key || doc.id,
// //                                           pdfUrl:
// //                                             doc.pdf_url ||
// //                                             doc.file_url ||
// //                                             doc.pdfUrl ||
// //                                             "",
// //                                           name: doc.name,
// //                                         })),
// //                                       },
// //                                     });
// //                                   } else {
// //                                     navigate("/chat", {
// //                                       state: {
// //                                         pdfUrl: item.pdf_url || item.url,
// //                                         pdfKey: item.key,
// //                                         pdfId: item.id,
// //                                         document_type:
// //                                           item.document_type || null,
// //                                       },
// //                                     });
// //                                   }
// //                                 }}
// //                                 onMouseEnter={() => setIsHovered(true)}
// //                                 onMouseLeave={() => setIsHovered(false)}
// //                                 disabled={cancelledPdfKeys.includes(item.key)}
// //                                 className={`flex items-center gap-1 font-medium chat-button-documents-for ${
// //                                   cancelledPdfKeys.includes(item.key)
// //                                     ? "text-gray-400 cursor-not-allowed"
// //                                     : "text-purple-500"
// //                                 }`}
// //                               >
// //                                 <img
// //                                   src={
// //                                     isHovered
// //                                       ? "/chat-icon-doc-hover.svg"
// //                                       : "/chat-icon-doc.svg"
// //                                   }
// //                                   className="w-4 h-4"
// //                                   alt="Chat"
// //                                 />
// //                                 Chat
// //                               </button>
// //                             </div>
// //                           </td>

// //                           <td className="px-3 relative">
// //                             <img
// //                               src={
// //                                 cancelledPdfKeys.includes(item.key)
// //                                   ? "./action.svg" // Optional: gray/disabled icon
// //                                   : "./action.svg"
// //                               }
// //                               alt="Actions"
// //                               width="20"
// //                               height="20"
// //                               onClick={(e) => {
// //                                 if (cancelledPdfKeys.includes(item.key)) {
// //                                   return;
// //                                 }
// //                                 toggleActionMenu(index, e);
// //                               }}
// //                               style={{
// //                                 cursor: cancelledPdfKeys.includes(item.key)
// //                                   ? "not-allowed"
// //                                   : "pointer",
// //                                 opacity: cancelledPdfKeys.includes(item.key)
// //                                   ? 0.4
// //                                   : 1,
// //                               }}
// //                               title={
// //                                 cancelledPdfKeys.includes(item.key)
// //                                   ? "This upload was cancelled. Please refresh to remove it."
// //                                   : "Actions"
// //                               }
// //                             />
// //                           </td>
// //                         </tr>
// //                       ))
// //                     ) : (
// //                       <tr className="h-[44px] text-center">
// //                         <td colSpan="7" className="py-6 text-black-400">
// //                           <img
// //                             src="/no-contracts.svg"
// //                             alt="No Data"
// //                             className="mx-auto mb-2"
// //                           />
// //                           <p className="text-[16px]">
// //                             Looks like your table is empty!
// //                           </p>
// //                         </td>
// //                       </tr>
// //                     )}
// //                   </tbody>
// //                 </table>
// //               </div>
// //               {paginatedData.length > 0 && (
// //                 <div className="pagination-doc ml-2">
// //                   <div className="pagination-dropdown">
// //                     <p className="page-selector">{currentPage}</p>
// //                   </div>
// //                   <p className="contentDown">of {totalPages} pages</p>
// //                   <button
// //                     onClick={handlePreviousPage}
// //                     disabled={currentPage === 1}
// //                     style={{
// //                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
// //                     }}
// //                   >
// //                     <img
// //                       src="decrease.svg"
// //                       alt="Previous Page"
// //                       style={{ height: "12px", width: "12px" }}
// //                     />
// //                   </button>
// //                   <button
// //                     onClick={handleNextPage}
// //                     disabled={currentPage === totalPages}
// //                     style={{
// //                       cursor:
// //                         currentPage === totalPages ? "not-allowed" : "pointer",
// //                     }}
// //                   >
// //                     <img
// //                       src="increase.svg"
// //                       alt="Next Page"
// //                       style={{ height: "12px", width: "12px" }}
// //                     />
// //                   </button>
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         </div>

// //         {/* {popupVisible && (
// //           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //             <div className="document-popup-box">
         
// //               <div className="flex items-center justify-center mb-2">
// //                 <div className="relative w-16 h-16">
// //                   <img
// //                     src="/edit-active-icon-one-contract.svg"
// //                     alt="Top"
// //                     className="absolute top-0 left-0 w-16 h-16"
// //                   />
// //                   <img
// //                     src="/edit-active-icon-two-contract.svg"
// //                     alt="Middle"
// //                     className="absolute top-2 left-2 w-12 h-12"
// //                   />
// //                   <img
// //                     src="/edit-active-icon-contract.svg"
// //                     alt="Bottom"
// //                     className="absolute top-4 left-4 w-8 h-8"
// //                   />
// //                 </div>
// //               </div>

          
// //               <h2 className="text-lg font-semibold text-center text-[#171717]">
// //                 Documents Successfully Copied
// //               </h2>
             

             
// //               <div className="mt-3 flex justify-center gap-4">
              
// //                 <button
// //                   className="px-4 py-2 text-sm font-medium text-white bg-[#C95EBE] hover:bg-[#b44eaa] rounded-md transition"
// //                   onClick={closePopup}
// //                 >
// //                   Done
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )} */}

// //         {confirmDeleteVisible && (
// //           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //             <div className="document-popup-box-delete">
// //               <h2>Are you sure you want to delete the selected item(s)?</h2>
// //               <p>
// //                 Once deleted, the selected item(s) will be permanently removed.
// //                 This action cannot be undone.
// //               </p>
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   gap: "8px",
// //                   justifyContent: "center",
// //                   marginTop: "20px",
// //                 }}
// //               >
// //                 <button
// //                   onClick={() => {
// //                     if (!deleteInProgress) {
// //                       setConfirmDeleteVisible(false);
// //                     }
// //                   }}
// //                   className="document-popup-close-delete"
// //                   disabled={deleteInProgress}
// //                 >
// //                   Cancel
// //                 </button>
// //                 <button
// //                   onClick={handleBulkDelete}
// //                   className="document-popup-close-button"
// //                   disabled={deleteInProgress}
// //                 >
// //                   {deleteInProgress ? "Deleting..." : "Delete"}
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {contractToDelete && (
// //           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //             <div className="document-popup-box-delete">
// //               <h2>Are you sure you want to delete the selected item(s)?</h2>
// //               <p>
// //                 Once deleted, the selected item(s) will be permanently removed.
// //                 This action cannot be undone.
// //               </p>
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   gap: "8px",
// //                   justifyContent: "center",
// //                   marginTop: "20px",
// //                 }}
// //               >
// //                 <button
// //                   onClick={() => setContractToDelete(null)}
// //                   className="document-popup-close-delete"
// //                   disabled={deleteInProgress}
// //                 >
// //                   Cancel
// //                 </button>
// //                 <button
// //                   onClick={confirmDelete}
// //                   className="document-popup-close-button"
// //                   disabled={deleteInProgress}
// //                 >
// //                   {deleteInProgress ? "Deleting..." : "Delete"}
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //         <UploadModal
// //           isOpen={isModalOpen}
// //           onClose={handleCloseModal}
// //           onUploadSuccess={handleUploadSuccess}
// //           type={"document"}
// //           file={file}
// //         />
// //         <RenameModal
// //           isOpen={isRenameModalOpen}
// //           onClose={() => setIsRenameModalOpen(false)}
// //           document={currentDocument}
// //           onRename={(documentId, newName) => handleRename(documentId, newName)}
// //         />

// //         <CopyToFolderModal
// //           isOpen={isCopyModalOpen}
// //           onClose={() => setIsCopyModalOpen(false)}
// //           documents={currentDocument}
// //           folders={folders}
// //           onCopy={(documentId, folderId) =>
// //             handleCopyToFolder(folderId, [documentId])
// //           }
// //           onCreateFolder={fetchFolders}
// //         />

// //         <FilterModal
// //           isOpen={isFilterModalOpen}
// //           onClose={() => setIsFilterModalOpen(false)}
// //           onApply={(filteredFiles, filteredFolders) => {
// //             setFiles(filteredFiles);
// //             setFolders(filteredFolders);
// //             setIsFilterApplied(true); // ✅ Mark filters as applied
// //           }}
// //           setFiles={setFiles}
// //           setFolders={setFolders}
// //           setIsFilterApplied={setIsFilterApplied}
// //           selectedFilters={selectedFilters}
// //           setSelectedFilters={setSelectedFilters} // ✅ Ensure filter status updates
// //           clearFilters={clearFilters}
// //         />

// //         <CreateFolderModal
// //           isOpen={isCreateFolderModalOpen}
// //           onClose={() => setIsCreateFolderModalOpen(false)}
// //           onCreateSuccess={fetchFolders}
// //         />
// //         <RenameModal
// //           isOpen={isRenameFolderModalOpen}
// //           onClose={() => setIsRenameFolderModalOpen(false)}
// //           document={currentFolder}
// //           onRename={handleRenameFolder}
// //         />

// //         <button
// //           onClick={handleBulkDelete}
// //           disabled={selectedContracts.length === 0}
// //         >
// //           <img src="/delete-icon-red.svg" alt="Delete Icon" />
// //         </button>

// //         {isSuccessPopupVisible && (
// //           <div className="success-popup-overlay">
// //             <div className="success-popup-box">
// //               <div className="stacked-icons-container">
// //                 <img
// //                   src="/folder-copy-tick.svg"
// //                   alt="Tick"
// //                   className="icon tick-icon"
// //                 />
// //                 <img
// //                   src="/folder-copy-circle.svg"
// //                   alt="Circle"
// //                   className="icon circle-icon"
// //                 />
// //                 <img
// //                   src="/folder-copied-circle.svg"
// //                   alt="Copied"
// //                   className="icon copied-icon"
// //                 />
// //               </div>

// //               <h2 className="folder-uploaded-success">
// //                 Folder Successfully Copied
// //               </h2>
// //               <p className="folder-folderName">
// //                 Your documents have been copied to {successFolderName}.
// //               </p>
// //               <div className="copy-folder-last">
// //                 <button
// //                   onClick={() => navigate(`/folder/?folderId=${file_ids}`)}
// //                   className="copy-folder-view"
// //                 >
// //                   View Folder
// //                 </button>

// //                 <button
// //                   onClick={() => setIsSuccessPopupVisible(false)}
// //                   className="copy-folder-done"
// //                 >
// //                   Done
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         {isDeleteFolderModalOpen && (
// //           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //             <div className="document-popup-box-delete">
// //               <h2>Are you sure you want to delete the selected item(s)?</h2>
// //               <p>
// //                 Once deleted, the selected item(s) will be permanently removed.
// //                 This action cannot be undone.
// //               </p>
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   gap: "8px",
// //                   justifyContent: "center",
// //                   marginTop: "20px",
// //                 }}
// //               >
// //                 <button
// //                   onClick={() => setIsDeleteFolderModalOpen(false)}
// //                   className="document-popup-close-delete"
// //                   disabled={deleteInProgress}
// //                 >
// //                   Cancel
// //                 </button>
// //                 <button
// //                   onClick={() => handleDeleteFolder(folderToDelete)}
// //                   className="document-popup-close-button"
// //                   disabled={deleteInProgress}
// //                 >
// //                   {deleteInProgress ? "Deleting..." : "Delete"}
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //         {showSubscriptionPopup && (
// //           <SubscriptionPopup onClose={() => setShowSubscriptionPopup(false)} />
// //         )}

// //         {isActionMenuOpen !== null && (
// //           <div
// //             className="fixed inset-0 z-[9998] backdrop-overlay"
// //             onClick={() => setIsActionMenuOpen(null)} // click outside to close
// //           >
// //             <div
// //               className={`document-action-menu ${
// //                 paginatedData[isActionMenuOpen]?.documents
// //                   ? "folder-options"
// //                   : ""
// //               } fixed z-[9999] bg-white shadow-md rounded-md`}
// //               ref={actionMenuRef}
// //               style={{
// //                 top:
// //                   isActionMenuOpen >= paginatedData.length - 4
// //                     ? `${actionMenuPosition.top - 130}px` // adjust -130px as per your menu height
// //                     : `${actionMenuPosition.top}px`,
// //                 left: `${actionMenuPosition.left}px`,
// //               }}
// //             >
// //               {paginatedData[isActionMenuOpen]?.documents ? (
// //                 <>
// //                   <div
// //                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-2"
// //                     onMouseEnter={() => setHoveredAction("rename-folder")}
// //                     onMouseLeave={() => setHoveredAction(null)}
// //                     onMouseDown={() => setClickedAction("rename-folder")}
// //                     onMouseUp={() => setClickedAction(null)}
// //                     onClick={() => {
// //                       setCurrentFolder(paginatedData[isActionMenuOpen]);
// //                       setIsRenameFolderModalOpen(true);
// //                     }}
// //                     style={{
// //                       color:
// //                         clickedAction === "rename-folder"
// //                           ? "#C95EBE"
// //                           : hoveredAction === "rename-folder"
// //                           ? "#C95EBE"
// //                           : "",
// //                       transition:
// //                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
// //                       borderRadius: "8px",
// //                       background:
// //                         clickedAction === "rename-folder" ||
// //                         hoveredAction === "rename-folder"
// //                           ? "#FAF9F6"
// //                           : "transparent",
// //                       padding: "10px",
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     <img
// //                       src={
// //                         clickedAction === "rename-folder" ||
// //                         hoveredAction === "rename-folder"
// //                           ? "./edit-active-contract.svg"
// //                           : "./edit.svg"
// //                       }
// //                       alt="Edit Icon"
// //                       className="document-action-icon"
// //                     />
// //                     <p>Rename Folder</p>
// //                   </div>

// //                   <div
// //                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
// //                     onMouseEnter={() => setHoveredAction("delete-folder")}
// //                     onMouseLeave={() => setHoveredAction(null)}
// //                     onMouseDown={() => setClickedAction("delete-folder")}
// //                     onMouseUp={() => setClickedAction(null)}
// //                     onClick={(e) => {
// //                       e.stopPropagation();
// //                       setFolderToDelete(paginatedData[isActionMenuOpen].id);
// //                       setIsDeleteFolderModalOpen(true);
// //                     }}
// //                     style={{
// //                       color:
// //                         clickedAction === "delete-folder"
// //                           ? "#E74C3C"
// //                           : hoveredAction === "delete-folder"
// //                           ? "#E74C3C"
// //                           : "",
// //                       transition:
// //                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
// //                       borderRadius: "8px",
// //                       background:
// //                         clickedAction === "delete-folder" ||
// //                         hoveredAction === "delete-folder"
// //                           ? "#FFF5F5"
// //                           : "transparent",
// //                       padding: "10px",
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     <img
// //                       src={
// //                         clickedAction === "delete-folder" ||
// //                         hoveredAction === "delete-folder"
// //                           ? "./delete-active-contract.svg"
// //                           : "./delete.svg"
// //                       }
// //                       alt="Delete Icon"
// //                       className="document-action-icon"
// //                     />
// //                     <p>Delete Folder</p>
// //                   </div>
// //                 </>
// //               ) : (
// //                 <>
// //                   <div
// //                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
// //                     onMouseEnter={() => setHoveredAction("copy")}
// //                     onMouseLeave={() => setHoveredAction(null)}
// //                     onMouseDown={() => setClickedAction("copy")}
// //                     onMouseUp={() => setClickedAction(null)}
// //                     onClick={(e) => {
// //                       e.stopPropagation();
// //                       if (selectedContracts.length > 0) {
// //                         setCurrentDocument(selectedContracts);
// //                       } else {
// //                         setCurrentDocument([paginatedData[isActionMenuOpen]]);
// //                       }
// //                       setIsCopyModalOpen(true);
// //                     }}
// //                     style={{
// //                       color:
// //                         clickedAction === "copy"
// //                           ? "#C95EBE"
// //                           : hoveredAction === "copy"
// //                           ? "#C95EBE"
// //                           : "",
// //                       transition:
// //                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
// //                       borderRadius: "8px",
// //                       background:
// //                         clickedAction === "copy" || hoveredAction === "copy"
// //                           ? "#FAF9F6"
// //                           : "transparent",
// //                       padding: "10px",
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     <img
// //                       src={
// //                         clickedAction === "copy" || hoveredAction === "copy"
// //                           ? "./folder-copy-active.svg"
// //                           : "./folder-copy.svg"
// //                       }
// //                       alt="Copy to Folder Icon"
// //                       className="document-action-icon"
// //                     />
// //                     <p>Copy to Folder</p>
// //                   </div>

// //                   <div
// //                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
// //                     onMouseEnter={() => setHoveredAction("rename")}
// //                     onMouseLeave={() => setHoveredAction(null)}
// //                     onMouseDown={() => setClickedAction("rename")}
// //                     onMouseUp={() => setClickedAction(null)}
// //                     onClick={(e) => {
// //                       e.stopPropagation();
// //                       setCurrentDocument(paginatedData[isActionMenuOpen]);
// //                       setIsRenameModalOpen(true);
// //                     }}
// //                     style={{
// //                       color:
// //                         clickedAction === "rename"
// //                           ? "#C95EBE"
// //                           : hoveredAction === "rename"
// //                           ? "#C95EBE"
// //                           : "",
// //                       transition:
// //                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
// //                       borderRadius: "8px",
// //                       background:
// //                         clickedAction === "rename" || hoveredAction === "rename"
// //                           ? "#FAF9F6"
// //                           : "transparent",
// //                       padding: "10px",
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     <img
// //                       src={
// //                         clickedAction === "rename" || hoveredAction === "rename"
// //                           ? "./edit-active-contract.svg"
// //                           : "./edit.svg"
// //                       }
// //                       alt="Edit Icon"
// //                       className="document-action-icon"
// //                     />
// //                     <p>Rename</p>
// //                   </div>

// //                   <div
// //                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
// //                     onMouseEnter={() => setHoveredAction("delete")}
// //                     onMouseLeave={() => setHoveredAction(null)}
// //                     onMouseDown={() => setClickedAction("delete")}
// //                     onMouseUp={() => setClickedAction(null)}
// //                     onClick={(e) => {
// //                       e.stopPropagation();
// //                       handleDelete(paginatedData[isActionMenuOpen].id);
// //                     }}
// //                     style={{
// //                       color:
// //                         clickedAction === "delete"
// //                           ? "#E74C3C"
// //                           : hoveredAction === "delete"
// //                           ? "#E74C3C"
// //                           : "#000",
// //                       transition:
// //                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
// //                       borderRadius: "8px",
// //                       background:
// //                         clickedAction === "delete" || hoveredAction === "delete"
// //                           ? "#FAF9F6"
// //                           : "transparent",
// //                       padding: "10px",
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     <img
// //                       src={
// //                         clickedAction === "delete" || hoveredAction === "delete"
// //                           ? "./delete-active-contract.svg"
// //                           : "./delete.svg"
// //                       }
// //                       alt="Delete Icon"
// //                       className="document-action-icon"
// //                     />
// //                     <p className="delete-name-svggg">Delete</p>
// //                   </div>
// //                 </>
// //               )}
// //             </div>
// //           </div>
// //         )}
// //         {tagModalDocId && (
// //           <CreateTagModals
// //             isOpen={true}
// //             onClose={() => setTagModalDocId(null)}
// //             documentId={tagModalDocId}
// //             onTagUpdate={() => {
// //               fetchContracts(); // ⬅️ Must be defined
// //               fetchFolders();
// //             }}
// //           />
// //         )}

// //         {isBulkTagModalOpen && selectedContracts.length > 0 && (
// //           <CreateTagModals
// //             isOpen={true}
// //             onClose={() => setIsBulkTagModalOpen(false)}
// //             documentId={selectedContracts.map((doc) => doc.id)}
// //             onTagUpdate={() => {
// //               fetchContracts();
// //               fetchFolders();
// //             }}
// //             onClearSelection={() => setSelectedContracts([])} // ✅ clear checkboxes
// //           />
// //         )}
// //       </div>
// //     </>
// //   );
// // };

// // export default UploadFilePage;
// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useMemo,
// } from "react";
// import Cookies from "js-cookie";
// import api from "../chat/api";
// import { useLocation, useNavigate } from "react-router";
// import { Header } from "../../components/Header/Header";
// import "./UploadFilePage.css";
// import SubscriptionPopup from "./SubscriptionPopup.jsx";
// import { toast } from "react-toastify";
// import UploadModal from "../Contract/UploadModal";
// import CreateFolderModal from "../Contract/CreateFolderModal";
// import FilterModal from "./FilterModal";
// import Spinner from "../Contract/Spinner.jsx";
// import HoverTooltip from "./HoverTooltip.jsx";
// import FilterAppliedTooltip from "./FilterAppliedTooltip.jsx";
// import FileNameWithTooltip from "./FileNameWithTooltip.jsx";
// import CreateTagModals from "../Tags/CreateTagModals.jsx";
// import useGooglePicker from "../Ocr_Data/useGooglePicker.js";

// const UploadFilePage = ({ isMenuOpen }) => {
//   const [isBulkTagModalOpen, setIsBulkTagModalOpen] = useState(false);
//   const uploadButtonRef = useRef(null);
//   const { isConnected, connect, disconnect, openPicker, accessToken } =
//     useGooglePicker();
//   const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
//   const filterBtnRef = useRef(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [files, setFiles] = useState([]);
//   const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
//   const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
//   const [filters, setFilters] = useState({
//     folder: true,
//     normalDocument: true,
//     contract: false,
//     invoices: false,
//     spreadsheet: false,
//   });
//   const [selectedFilters, setSelectedFilters] = useState({
//     folder: false,
//     normalDocument: false,
//     contract: false,
//     invoice: false,
//   });
//   const uploadBtnRef = useRef(null);
//   const [isTagSearch, setIsTagSearch] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const fileInputRef = useRef(null);
//   const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
//   const actionMenuRef = useRef(null);
//   const [isSuccessPopupVisible, setIsSuccessPopupVisible] = useState(false);
//   const [successFolderName, setSuccessFolderName] = useState("");
//   const [selectedContractKeys, setSelectedContractKeys] = useState([]);
//   const [selectedInvoiceKeys, setSelectedInvoiceKeys] = useState([]);
//   const [file_ids, setFileId] = useState(null);
//   const [isFilterApplied, setIsFilterApplied] = useState(false);
//   const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
//   const [token, setToken] = useState(
//     Cookies.get("access_token") || localStorage.getItem("token") || ""
//   );
//   const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
//   const [isRenameFolderModalOpen, setIsRenameFolderModalOpen] = useState(false);
//   const [currentFolder, setCurrentFolder] = useState(null);
//   const [copyInProgress, setCopyInProgress] = useState(false);
//   const [tagModalDocId, setTagModalDocId] = useState(null);
//   const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false);
//   const [folderToDelete, setFolderToDelete] = useState(null);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [editContractId, setEditContractId] = useState(null);
//   const [editedContractData, setEditedContractData] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(25);
//   const editRowRef = useRef(null);
//   const [selectedContracts, setSelectedContracts] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const pdf_key = localStorage.getItem("pdfKey");
//   const tbodyRef = useRef(null);
//   const [exportInProgress, setExportInProgress] = useState(false);
//   const [deleteInProgress, setDeleteInProgress] = useState(false);
//   const [hoveredAction, setHoveredAction] = useState(null);
//   const [clickedAction, setClickedAction] = useState(null);
//   const [cancelledPdfKeys, setCancelledPdfKeys] = useState([]);
//   const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
//   const [currentDocument, setCurrentDocument] = useState(null);
//   const [selectedFolder, setSelectedFolder] = useState(0);
//   const [folders, setFolders] = useState([]);
//   const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);
//   const [selectedFolderName, setSelectedFolderName] = useState("");
//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [popupTitle, setPopupTitle] = useState("");
//   const [popupMessage, setPopupMessage] = useState("");
//   const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
//   const [contractToDelete, setContractToDelete] = useState(null);
//   const [showSingleDeleteConfirm, setShowSingleDeleteConfirm] = useState(false);
//   const [sortConfig, setSortConfig] = useState({
//     key: null,
//     direction: "asc",
//   });
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [status, setStatus] = useState("");
//   const location = useLocation();
//   const contractKey = location.state?.contractKey;
//   const [isSearchFocused, setIsSearchFocused] = useState(false);
//   const [isTooltipVisible, setIsTooltipVisible] = useState(false);

//   const handleSortBySize = () => {
//     setSortConfig((prev) => ({
//       key: "size",
//       direction:
//         prev.key === "size" && prev.direction === "asc" ? "desc" : "asc",
//     }));
//   };

//   const handleSortByDate = () => {
//     setSortConfig((prev) => ({
//       key: "date",
//       direction:
//         prev.key === "date" && prev.direction === "asc" ? "desc" : "asc",
//     }));
//   };

//   function darkenColor(hex, amount = 0.4) {
//     if (!hex || !hex.startsWith("#")) return "#333";
//     const num = parseInt(hex.slice(1), 16);
//     let r = (num >> 16) & 255;
//     let g = (num >> 8) & 255;
//     let b = num & 255;

//     r = Math.floor(r * (1 - amount));
//     g = Math.floor(g * (1 - amount));
//     b = Math.floor(b * (1 - amount));

//     return `rgb(${r}, ${g}, ${b})`;
//   }

//   useEffect(() => {
//     if (
//       isRenameModalOpen ||
//       isCopyModalOpen ||
//       isRenameFolderModalOpen ||
//       isDeleteFolderModalOpen ||
//       confirmDeleteVisible ||
//       contractToDelete ||
//       popupVisible
//     ) {
//       setIsActionMenuOpen(null);
//     }
//   }, [
//     isRenameModalOpen,
//     isCopyModalOpen,
//     isRenameFolderModalOpen,
//     isDeleteFolderModalOpen,
//     confirmDeleteVisible,
//     contractToDelete,
//     popupVisible,
//   ]);

//   useEffect(() => {
//     if (isConnected && !hasOpenedPickerOnce) {
//       setHasOpenedPickerOnce(true);
//     }
//   }, [isConnected, hasOpenedPickerOnce]);

//   const handleAddFromDriveClick = () => {
//     openPicker(async (docs) => {
//       console.log("📄 Files picked:", docs);

//       try {
//         const files = await Promise.all(
//           docs.map(async (doc) => {
//             const res = await fetch(
//               `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
//               {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//               }
//             );

//             if (!res.ok) throw new Error("Failed to fetch file from Drive");

//             const blob = await res.blob();
//             return new File([blob], doc.name, { type: blob.type });
//           })
//         );

//         setFile(files);
//         setIsModalOpen(true);
//       } catch (err) {
//         console.error("Failed to process selected files", err);
//         toast.error("Something went wrong while processing selected files.");
//       }
//     });
//   };

//   useEffect(() => {
//     const cookieToken = Cookies.get("access_token");
//     if (cookieToken) {
//       setToken(cookieToken);
//     }
//   }, []);

//   useEffect(() => {
//     if (tagModalDocId) {
//     }
//   }, [tagModalDocId]);

//   const resetSelections = () => {
//     setSelectedContracts([]);
//     setSelectedContractKeys([]);
//     setSelectedInvoiceKeys([]);
//     setCurrentDocument(null);
//     setCurrentFolder(null);
//     setEditContractId(null);
//     setEditedContractData({});
//     setIsActionMenuOpen(null);
//     setContractToDelete(null);
//     setFolderToDelete(null);
//     setConfirmDeleteVisible(false);
//     setIsRenameModalOpen(false);
//     setIsRenameFolderModalOpen(false);
//     setIsCopyModalOpen(false);
//     setIsDeleteFolderModalOpen(false);
//   };

//   const clearFilters = async () => {
//     setSelectedFilters({
//       folder: false,
//       normalDocument: false,
//       contract: false,
//       invoice: false,
//     });

//     try {
//       const response = await api.get("api/v1/readpdf/files-and-folders/");
//       if (response.status === 200) {
//         const { files, folders } = response.data;
//         setFiles(Array.isArray(files) ? files : []);
//         setFolders(Array.isArray(folders) ? folders : []);
//         setIsFilterApplied(false);
//       }
//     } catch (error) {
//       setFiles([]);
//       setFolders([]);
//     }
//   };

//   const filteredContracts = useMemo(() => {
//     if (!Array.isArray(files) || files.length === 0) return [];

//     const query = searchQuery.toLowerCase().trim();

//     return files.filter((file) => {
//       const nameMatch = file?.pdf_name?.toLowerCase().includes(query);

//       const tagMatch =
//         file?.tags?.some((tag) =>
//           tag.name?.toLowerCase().includes(query.replace("tags:", "").trim())
//         ) || false;

//       return isTagSearch ? tagMatch : nameMatch || tagMatch;
//     });
//   }, [files, searchQuery, isTagSearch]);

//   const totalPages = useMemo(() => {
//     const totalItems = folders.length + files.length;
//     return Math.ceil(totalItems / rowsPerPage);
//   }, [folders, files, rowsPerPage]);

//   const toggleModal = () => {
//     setIsModalOpen((prev) => !prev);
//   };

//   const [actionMenuPosition, setActionMenuPosition] = useState({
//     top: 0,
//     left: 0,
//   });

//   const toggleActionMenu = (index, event) => {
//     event.stopPropagation();
//     if (isActionMenuOpen === index) {
//       setIsActionMenuOpen(null);
//     } else {
//       const rect = event.currentTarget.getBoundingClientRect();
//       setActionMenuPosition({
//         top: rect.bottom + window.scrollY + 6,
//         left: rect.left + window.scrollX - 20,
//       });
//       setIsActionMenuOpen(index);
//     }
//   };

//   const [file, setFile] = useState(null);

//   const handleFileChange = (event) => {
//     if (!isCreateFolderModalOpen) {
//       const selectedFiles = Array.from(event.target.files || []);
//       if (selectedFiles.length === 0) return;

//       setFile(selectedFiles);
//       setIsModalOpen(true);
//     }
//   };

//   const handleApplyFilters = (newFilters, files, folders) => {
//     const filteredFiles = files
//       .filter((file) => {
//         if (newFilters.folder && file.isFolder) return true;
//         if (newFilters.normalDocument && file.type === "normal_document")
//           return true;
//         if (newFilters.contract && file.type === "contract") return true;
//         if (newFilters.invoice && file.type === "invoice") return true;
//         if (newFilters.spreadsheet && file.type === "spreadsheet") return true;
//         return false;
//       })
//       .map((file) => {
//         let fileType = "Unknown";
//         const name = file.pdf_name || file.name || "";
//         if (name.endsWith(".pdf")) fileType = "pdf";
//         else if (name.endsWith(".xlsx")) fileType = "xlsx";
//         else if (name.endsWith(".xls")) fileType = "xls";
//         else if (name.endsWith(".csv")) fileType = "csv";
//         else if (name.endsWith(".doc") || name.endsWith(".docx"))
//           fileType = "docx";
//         else if (name.endsWith(".txt")) fileType = "txt";

//         return {
//           ...file,
//           file_type: fileType,
//         };
//       });

//     const filteredFolders = folders.map((folder) => ({
//       ...folder,
//       file_type: "Folder",
//     }));

//     setFiles(filteredFiles);
//     setFolders(filteredFolders);
//   };

//   const handleExport = async () => {
//     if (selectedContracts.length === 0) {
//       showPopup("Error", "Please select at least one document to export.");
//       return;
//     }
//     if (!selectedContractKeys.length && !selectedInvoiceKeys.length) {
//       alert("Please select at least one document to export.");
//       return;
//     }

//     setExportInProgress(true);

//     try {
//       const response = await api.post(
//         "api/v1/readpdf/export-doc/",
//         {
//           contract_keys: selectedContractKeys,
//           invoice_keys: selectedInvoiceKeys,
//         },
//         {
//           responseType: "blob",
//         }
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "exported_documents.csv");
//       document.body.appendChild(link);
//       link.click();

//       resetSelections();
//     } catch (error) {
//       if (error.response) {
//         const message =
//           error.response.data.msg || "Failed to export documents.";
//         showPopup("Error", message);
//       } else {
//         showPopup("Error", "An unexpected error occurred. Please try again.");
//       }
//     } finally {
//       setExportInProgress(false);
//     }
//   };

//   const handleClickOutside = (event) => {
//     if (
//       actionMenuRef.current &&
//       !actionMenuRef.current.contains(event.target)
//     ) {
//       setIsActionMenuOpen(null);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("click", handleClickOutside);

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   const handleCancel = () => {
//     resetSelections();
//     setSelectedContracts([]);

//     setIsModalOpen(false);
//     setIsFilterModalOpen(false);
//     setPopupVisible(false);

//     setConfirmDeleteVisible(false);
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(Number(event.target.value));
//     setCurrentPage(1);
//   };
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//       scrollToTop();
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//       scrollToTop();
//     }
//   };

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//       scrollToTop();
//     }
//   };

//   const scrollToTop = () => {
//     if (tbodyRef.current) {
//       tbodyRef.current.scrollTop = 0;
//     }
//   };

//   const handleBulkDeleteConfirmation = () => {
//     if (selectedContracts.length === 0) {
//       showPopup("Error", "No files or folders selected for bulk deletion.");
//       return;
//     }

//     setPopupTitle("Confirm Bulk Deletion");
//     setPopupMessage(
//       "Are you sure you want to delete the selected items? This action cannot be undone."
//     );
//     setDeleteTarget("bulk");
//     setConfirmDeleteVisible(true);
//   };

//   const fetchFolders = async () => {
//     if (!token) return;
//   };

//   const fetchContracts = async () => {
//     if (!token) return;
//     setLoading(true);
//     try {
//       const response = await api.get("api/v1/readpdf/files-and-folders/");

//       const { files, folders } = response.data;

//       setFiles(files || []);
//       setFolders(folders || []);
//     } catch (error) {
//       if (
//         error.response &&
//         error.response.data?.message ===
//           "No valid trial or active subscription. Redirecting to payment."
//       ) {
//         setShowSubscriptionPopup(true);
//       } else {
//         toast.error("Failed to load documents. Please try again later.", {
//           autoClose: 3000,
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSelectAll = () => {
//     const allItems = [...folders, ...files].map((item) => {
//       const isFolder = !!item.documents;
//       return {
//         ...item,
//         document_type: isFolder ? "folder" : item.document_type || "file",
//       };
//     });

//     if (selectedContracts.length === allItems.length) {
//       setSelectedContracts([]);
//       setSelectedContractKeys([]);
//       setSelectedInvoiceKeys([]);
//     } else {
//       setSelectedContracts(allItems);
//       setSelectedContractKeys(
//         allItems
//           .filter((item) => item.document_type === "contract")
//           .map((item) => item.key)
//       );
//       setSelectedInvoiceKeys(
//         allItems
//           .filter((item) => item.document_type === "invoice")
//           .map((item) => item.key)
//       );
//     }
//   };

//   const filteredData = useMemo(() => {
//     const normalizedQuery = searchQuery
//       .trim()
//       .replace(/\s+/g, " ")
//       .toLowerCase();

//     if (!normalizedQuery) return [...folders, ...files];

//     return [...folders, ...files].filter((item) =>
//       (item.name || "").toLowerCase().includes(normalizedQuery)
//     );
//   }, [folders, files, searchQuery]);

//   const parseTimeAgo = (timeAgo) => {
//     if (!timeAgo) return 0;

//     const [amountStr, unit] = timeAgo.toLowerCase().split(" ");
//     const amount = parseInt(amountStr);
//     const now = new Date();

//     switch (unit) {
//       case "second":
//       case "seconds":
//         return now.getTime() - amount * 1000;
//       case "minute":
//       case "minutes":
//         return now.getTime() - amount * 60 * 1000;
//       case "hour":
//       case "hours":
//         return now.getTime() - amount * 60 * 60 * 1000;
//       case "day":
//       case "days":
//         return now.getTime() - amount * 24 * 60 * 60 * 1000;
//       case "week":
//       case "weeks":
//         return now.getTime() - amount * 7 * 24 * 60 * 60 * 1000;
//       case "month":
//       case "months":
//         return now.getTime() - amount * 30 * 24 * 60 * 60 * 1000;
//       default:
//         return 0;
//     }
//   };

//   const combinedFilesAndFolders = useMemo(() => {
//     const sorted = [...folders, ...files].map((item) => ({
//       ...item,
//       isFolder: !!item.documents,
//       timeAgoParsed: parseTimeAgo(item.time_ago),
//       sizeParsed: parseFloat(
//         item.document_size || item.folder_size || item.size || 0
//       ),
//       uploadedTime: new Date(item.created_at || item.uploaded_at).getTime(),
//     }));

//     if (sortConfig.key === "size") {
//       sorted.sort((a, b) =>
//         sortConfig.direction === "asc"
//           ? a.sizeParsed - b.sizeParsed
//           : b.sizeParsed - a.sizeParsed
//       );
//     } else if (sortConfig.key === "date") {
//       sorted.sort((a, b) =>
//         sortConfig.direction === "asc"
//           ? a.uploadedTime - b.uploadedTime
//           : b.uploadedTime - a.uploadedTime
//       );
//     } else {
//       sorted.sort((a, b) => b.timeAgoParsed - a.timeAgoParsed);
//     }

//     return sorted;
//   }, [folders, files, sortConfig]);

//   const paginatedData = useMemo(() => {
//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     return combinedFilesAndFolders.slice(startIndex, endIndex);
//   }, [combinedFilesAndFolders, currentPage, rowsPerPage]);

//   const filteredPaginatedData = useMemo(() => {
//     const query = searchQuery.toLowerCase().trim();
//     const data = combinedFilesAndFolders;

//     const filtered = data.filter((item) => {
//       const nameMatch = (item.name || "").toLowerCase().includes(query);
//       const tagMatch =
//         item.tags?.some((tag) =>
//           tag.name?.toLowerCase().includes(query.replace("tags:", "").trim())
//         ) || false;

//       return isTagSearch ? tagMatch : nameMatch || tagMatch;
//     });

//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     return filtered.slice(startIndex, endIndex);
//   }, [
//     combinedFilesAndFolders,
//     searchQuery,
//     isTagSearch,
//     currentPage,
//     rowsPerPage,
//   ]);

//   const handleCheckboxChange = (item) => {
//     const isSelected = selectedContracts.some(
//       (selectedItem) => selectedItem.id === item.id
//     );

//     if (isSelected) {
//       setSelectedContracts(
//         selectedContracts.filter((selectedItem) => selectedItem.id !== item.id)
//       );

//       if (item.document_type === "contract") {
//         setSelectedContractKeys(
//           selectedContractKeys.filter((key) => key !== item.key)
//         );
//       } else if (item.document_type === "invoice") {
//         setSelectedInvoiceKeys(
//           selectedInvoiceKeys.filter((key) => key !== item.key)
//         );
//       }
//     } else {
//       setSelectedContracts([...selectedContracts, item]);

//       if (item.document_type === "contract") {
//         setSelectedContractKeys([...selectedContractKeys, item.key]);
//       } else if (item.document_type === "invoice") {
//         setSelectedInvoiceKeys([...selectedInvoiceKeys, item.key]);
//       }
//     }
//   };

//   useEffect(() => {
//     if (!folders.length && !files.length) {
//       fetchFolders();
//       fetchContracts();
//     }
//   }, []);

//   const handleUploadSuccess = () => {
//     fetchContracts();
//     fetchFolders();
//     toggleModal();
//   };

//   const handleCloseModal = () => {
//     toggleModal();
//   };

//   const toggleFilterModal = () => {
//     setIsFilterModalOpen((prev) => !prev);
//   };

//   const CopyToFolderModal = ({
//     isOpen,
//     onClose,
//     documents,
//     folders,
//     onCopy,
//     onCreateFolder,
//   }) => {
//     const [selectedFolder, setSelectedFolder] = useState(null);
//     const [selectedFolderName, setSelectedFolderName] = useState("");
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [creatingNewFolder, setCreatingNewFolder] = useState(false);
//     const [newFolderName, setNewFolderName] = useState("");
//     const [errorMessage, setErrorMessage] = useState("");

//     const handleSave = async () => {
//       if (!selectedFolder) {
//         setErrorMessage("Please select a folder.");
//         return;
//       }
//       if (!documents || documents.length === 0) {
//         alert("No document selected for copying.");
//         return;
//       }

//       setErrorMessage("");
//       setCopyInProgress(true);
//       try {
//         await onCopy(
//           documents.map((doc) => doc.id),
//           selectedFolder
//         );
//         onClose();
//         resetSelections();
//       } catch (err) {
//         setErrorMessage("Failed to copy documents.");
//       } finally {
//         setCopyInProgress(false);
//       }
//     };

//     const handleCreateFolder = async () => {
//       const trimmedFolderName = newFolderName.trim();

//       if (!trimmedFolderName) {
//         setErrorMessage("Folder name cannot be empty.");
//         return;
//       }

//       if (!documents || documents.length === 0) {
//         toast.warn("Please select at least one document.", { autoClose: 2000 });
//         return;
//       }

//       const isDuplicate = folders.some(
//         (folder) =>
//           folder.name.toLowerCase() === trimmedFolderName.toLowerCase()
//       );

//       if (isDuplicate) {
//         toast.warn("A folder with this name already exists.", {
//           autoClose: 3000,
//         });
//         return;
//       }

//       setErrorMessage("");
//       setLoading(true);

//       try {
//         const documentIds = documents.map((doc) => doc.id);

//         const response = await api.post("api/v1/readpdf/add-files/", {
//           file_ids: documentIds,
//           folder_name: trimmedFolderName,
//         });

//         if (response.status === 200) {
//           const newFolderId = response.data.folder_id;

//           setSelectedFolder(newFolderId);
//           setSelectedFolderName(trimmedFolderName);
//           setNewFolderName("");
//           setCreatingNewFolder(false);

//           if (onCreateFolder) {
//             onCreateFolder({
//               id: newFolderId,
//               name: trimmedFolderName,
//             });
//           }

//           fetchFolders();
//           fetchContracts();
//           resetSelections();
//           onClose();
//         }
//       } catch (error) {
//         if (
//           error.response &&
//           error.response.data &&
//           error.response.data.msg === "Folder with this name already exists"
//         ) {
//           toast.warn("A folder with this name already exists.", {
//             autoClose: 2000,
//           });
//         } else {
//           toast.error("Failed to create folder. Please try again.", {
//             autoClose: 2000,
//           });
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     return isOpen ? (
//       <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//         <div className="copy-modal">
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-lg font-semibold text-gray-700">
//               Copy to Folder
//             </h2>
//             <button
//               onClick={onClose}
//               className="text-gray-500 hover:text-gray-700 transition"
//             >
//               X
//             </button>
//           </div>
//           <p>Copy into any folder and organize your documents</p>
//           <h3>Choose Folder</h3>

//           <div className="select-container">
//             <div
//               className="custom-select"
//               onClick={() => setDropdownOpen(!dropdownOpen)}
//             >
//               <div className="selected-option">
//                 {selectedFolder ? selectedFolderName : "Select a folder"}
//               </div>
//               <span className="select-icon">
//                 <img src="/copyToFolder-icon.svg" alt="Dropdown Icon" />
//               </span>
//             </div>

//             {creatingNewFolder && (
//               <div className="new-folder-container flex mt-2 p-2 border border-gray-300 rounded-md">
//                 <input
//                   type="text"
//                   placeholder="Enter your folder name here"
//                   value={newFolderName}
//                   onChange={(e) => setNewFolderName(e.target.value)}
//                   style={{
//                     color: "#000000",
//                     width: "200px",
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "15px",
//                     fontStyle: "normal",
//                     fontWeight: 400,
//                     lineHeight: "normal",
//                     padding: "12px",
//                     border: "none",
//                     background: "#FFFFFF",
//                   }}
//                 />
//                 <div className="folder-action-buttons flex ml-2">
//                   <button
//                     onClick={async () => {
//                       await handleCreateFolder();
//                     }}
//                     className="save-button-copy"
//                   >
//                     Save
//                   </button>
//                   <button
//                     onClick={() => setCreatingNewFolder(false)}
//                     className="cancel-button-copy"
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </div>
//             )}

//             {dropdownOpen && (
//               <div className="custom-dropdown-options">
//                 {folders.length > 0 ? (
//                   folders.map((folder) => (
//                     <div
//                       key={folder.id}
//                       className="custom-dropdown-option"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setSelectedFolder(folder.id);
//                         setSelectedFolderName(folder.name);
//                         setDropdownOpen(false);
//                       }}
//                     >
//                       {folder.name}
//                     </div>
//                   ))
//                 ) : (
//                   <div className="custom-dropdown-option no-folders">
//                     No folders available
//                   </div>
//                 )}
//               </div>
//             )}

//             {dropdownOpen && !creatingNewFolder && (
//               <button
//                 className="create-new-folder-btn mt-3"
//                 onClick={() => {
//                   setCreatingNewFolder(true);
//                   setDropdownOpen(true);
//                 }}
//               >
//                 <img
//                   src="/folder-icon-copy.svg"
//                   alt="Folder Icon"
//                   className="folder-icon"
//                 />
//                 <span>Create New Folder</span>
//               </button>
//             )}
//           </div>

//           {errorMessage && (
//             <p className="error-message text-red-500 mt-2">{errorMessage}</p>
//           )}

//           {selectedFolder && (
//             <div className="copy-modal-actions flex justify-end mt-20">
//               <button onClick={onClose} className="cancel-button">
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSave}
//                 disabled={copyInProgress}
//                 className="save-button"
//               >
//                 {copyInProgress ? "Copying..." : "Copy"}
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     ) : null;
//   };

//   const RenameModal = ({ isOpen, onClose, document, onRename }) => {
//     const [newName, setNewName] = useState("");

//     const [isRenaming, setIsRenaming] = useState(false);
//     useEffect(() => {
//       if (document) {
//         const initialName = document.pdf_name || document.name || "";
//         setNewName(initialName);
//       }
//     }, [document]);

//     const handleSave = async () => {
//       if (!newName.trim()) return;
//       setIsRenaming(true);

//       try {
//         await onRename(document.id, newName.trim());
//       } catch (err) {
//       } finally {
//         setIsRenaming(false);
//         onClose();
//       }
//     };

//     return isOpen ? (
//       <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//         <div className="rename-modal">
//           <h2>Rename Document</h2>
//           <p>Create a Custom Name for your Documents</p>
//           <h3>Title</h3>
//           <input
//             type="text"
//             value={newName}
//             onChange={(e) => setNewName(e.target.value)}
//             placeholder="Enter new name"
//             disabled={isRenaming}
//           />
//           <div className="rename-modal-actions">
//             <button onClick={onClose}>Cancel</button>
//             <button
//               onClick={handleSave}
//               disabled={isRenaming || !newName.trim()}
//             >
//               {isRenaming ? "Saving..." : "Save"}
//             </button>
//           </div>
//         </div>
//       </div>
//     ) : null;
//   };

//   const handleRename = async (documentId, newName) => {
//     try {
//       const response = await api.put(
//         `api/v1/readpdf/rename-doc/${documentId}/`,
//         { new_name: newName }
//       );
//       if (response.status === 200) {
//         setFiles((prevFiles) =>
//           prevFiles.map((file) =>
//             file.id === documentId
//               ? { ...file, pdf_name: response.data.new_name }
//               : file
//           )
//         );

//         fetchContracts();
//         fetchFolders();
//       }
//     } catch (err) {
//       showPopup("Error", "Rename failed. Please try again.");
//       throw err;
//     }
//   };

//   const handleRenameFolder = async (folderId, newName) => {
//     try {
//       const response = await api.put(
//         `api/v1/readpdf/rename-folder/${folderId}/`,
//         { new_name: newName }
//       );

//       if (response.status === 200) {
//         setFolders((prevFolders) =>
//           prevFolders.map((folder) =>
//             folder.id === folderId
//               ? { ...folder, folder_name: response.data.folder_name }
//               : folder
//           )
//         );

//         fetchContracts();
//         fetchFolders();
//       }
//     } catch (error) {
//       if (error.response) {
//         showPopup(
//           "Error",
//           `Failed to rename folder: ${
//             error.response.data.msg || error.response.statusText
//           }`
//         );
//       } else if (error.request) {
//         showPopup(
//           "Error",
//           "Failed to rename folder: No response received from the server."
//         );
//       } else {
//         showPopup("Error", "An unexpected error occurred. Please try again.");
//       }
//     }
//   };

//   const handleCopyToFolder = async (folderId, fileIds) => {
//     const flatFileIds = fileIds.flat();

//     setCopyInProgress(true);

//     try {
//       const response = await api.post(
//         `api/v1/readpdf/add-files/`,
//         { file_ids: flatFileIds, folder_id: folderId }
//       );

//       if (response.status === 200) {
//         setFileId(folderId);
//         setSuccessFolderName(
//           folders.find((f) => f.id === folderId)?.name || "Selected Folder"
//         );
//         setIsSuccessPopupVisible(true);
//       }
//     } catch (error) {
//       if (error.response) {
//         toast.error(
//           error.response.data.msg ||
//             "Failed to copy documents. Please try again.",
//           { autoClose: 3000 }
//         );
//       } else if (error.request) {
//         showPopup(
//           "Error",
//           "No response received from the server. Please check your network."
//         );
//       } else {
//         showPopup("Error", "An unexpected error occurred. Please try again.");
//       }
//     } finally {
//       setCopyInProgress(false);
//     }
//   };

//   const handleViewMore = (fileKey) => {
//     if (!fileKey) {
//       alert("File key is not available.");
//       return;
//     }

//     navigate("/Contract/contract-details", { state: { contractKey: fileKey } });
//   };

//   const enableEdit = (contract) => {
//     if (contract) {
//       setIsActionMenuOpen(false);
//       setEditContractId(contract.id);
//       setEditedContractData({ ...contract });
//     } else {
//       setEditContractId(null);
//       setEditedContractData({});
//     }
//   };

//   const handleEditChange = (field, value) => {
//     setEditedContractData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };
//   const goToPage = (pageNumber) => {
//     if (pageNumber < 1 || pageNumber > totalPages) return;
//     setCurrentPage(pageNumber);
//   };

//   const handleIncreasePage = () => {
//     setCurrentPage((prevPage) =>
//       prevPage < totalPages ? prevPage + 1 : prevPage
//     );
//   };

//   const handleDecreasePage = () => {
//     setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
//   };

//   const showPopup = (title, message) => {
//     setIsSuccessPopupVisible(false);
//     setPopupTitle(title);
//     setPopupMessage(message);
//     setPopupVisible(true);
//   };

//   const closePopup = () => {
//     setPopupVisible(false);
//     fetchContracts();
//     fetchFolders();
//   };

//   const openModal = () => {
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//   };

//   useEffect(() => {
//     if (location.state?.cancelledPdfKeys) {
//       setCancelledPdfKeys(location.state.cancelledPdfKeys);
//     }
//   }, [location.state]);

//   useEffect(() => {
//     if (contractKey) {
//     }
//   }, [contractKey]);

//   const formatDateTimeWithRelative = (dateTimeString) => {
//     if (!dateTimeString) return "N/A";

//     const date = new Date(dateTimeString);
//     const now = new Date();

//     if (isNaN(date.getTime())) return "N/A";

//     const diffInMs = now - date;
//     const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
//     const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
//     const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

//     let relativeTime;
//     if (diffInMinutes < 1) {
//       relativeTime = "Just now";
//     } else if (diffInMinutes < 60) {
//       relativeTime = `${diffInMinutes} minutes ago`;
//     } else if (diffInHours < 24) {
//       relativeTime = `${diffInHours} hours ago`;
//     } else {
//       relativeTime = `${diffInDays} days ago`;
//     }

//     const absoluteDate = date.toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });

//     return `${relativeTime} (${absoluteDate})`;
//   };
//   const handleFile = (e) => {
//     return new Promise((resolve, reject) => {
//       let selectedFile = e.target.files[0];

//       const fileType = ["application/pdf"];

//       if (selectedFile) {
//         if (selectedFile && fileType.includes(selectedFile.type)) {
//           let reader = new FileReader();
//           reader.readAsDataURL(selectedFile);
//           reader.onload = (e) => {
//             const result = e.target.result;
//             resolve(result);
//           };
//           reader.onerror = (error) => {
//             reject(error);
//           };
//         } else {
//         }
//       } else {
//         reject(new Error("No file selected"));
//       }
//     });
//   };

//   const handleBulkDelete = async () => {
//     if (selectedContracts.length === 0) {
//       showPopup("Error", "No files or folders selected for deletion.");
//       return;
//     }
//     setDeleteInProgress(true);
//     try {
//       const folderIds = selectedContracts
//         .filter(
//           (item) =>
//             item.documents ||
//             item.document_type === "folder" ||
//             item.doc_type === "folder"
//         )
//         .map((item) => item.id);

//       const documentIds = selectedContracts
//         .filter(
//           (item) =>
//             !item.documents &&
//             item.document_type !== "folder" &&
//             item.doc_type !== "folder"
//         )
//         .map((item) => item.id);

//       const payload = {
//         folder_ids: folderIds,
//         document_ids: documentIds,
//       };

//       const response = await api.post(`api/v1/readpdf/bulk-delete/`, payload);

//       if (response.status === 200) {
//         const { deleted_folders, deleted_documents, failed_collections } =
//           response.data;

//         setFiles((prevFiles) =>
//           prevFiles.filter((file) => !deleted_documents.includes(file.id))
//         );
//         setFolders((prevFolders) =>
//           prevFolders.filter((folder) => !deleted_folders.includes(folder.id))
//         );

//         setSelectedContracts([]);

//         setTimeout(() => {
//           setConfirmDeleteVisible(false);
//           setDeleteInProgress(false);
//           fetchContracts();
//           fetchFolders();
//         }, 2000);
//       } else {
//         showPopup(
//           "Error",
//           "Failed to delete selected items. Please try again."
//         );
//       }
//     } catch (error) {
//       showPopup("Error", "An unexpected error occurred during deletion.");
//       setConfirmDeleteVisible(false);
//       setDeleteInProgress(false);
//       fetchContracts();
//       fetchFolders();
//     } finally {
//       setConfirmDeleteVisible(false);
//     }
//   };

//   const handleDelete = (pdfId) => {
//     if (!token) {
//       showPopup("Session Expired", "Session expired. Please log in again.");
//       return;
//     }

//     setPopupTitle("Are you sure you want to delete the selected item(s)");
//     setPopupMessage(
//       "Are you sure you want to delete this PDF? This action cannot be undone."
//     );

//     setContractToDelete(pdfId);
//     setDeleteTarget("single");
//     setShowSingleDeleteConfirm(true);
//   };

//   const handleEditSave = async (contractId) => {
//     if (!editedContractData.contract_name) {
//       showPopup("Error", "Contract name is required.");
//       return;
//     }

//     try {
//       const response = await api.post(`api/v1/contract/edit-contract-name/`, {
//         contract_key: editedContractData?.key,
//         new_contract_name: editedContractData?.contract_name,
//       });

//       if (response.status === 200) {
//         setFiles((prevFiles) =>
//           prevFiles.map((filee) =>
//             filee.id === filee ? editedContractData : filee
//           )
//         );
//         setEditContractId(null);
//         showPopup("Success", "Contract updated successfully.");
//       }
//     } catch (error) {
//       if (error.response) {
//         showPopup(
//           "Error",
//           `Failed to update contract: ${
//             error.response.data.msg || error.response.statusText
//           }`
//         );
//       } else if (error.request) {
//         showPopup(
//           "Error",
//           "Failed to update contract: No response received from the server."
//         );
//       } else {
//         showPopup("Error", "Failed to update contract. Please try again.");
//       }
//     }
//   };

//   const confirmDelete = async () => {
//     if (!contractToDelete || !token) {
//       showPopup("Error", "No file or folder selected for deletion.");
//       return;
//     }

//     setDeleteInProgress(true);

//     try {
//       const targetItem = [...files, ...folders].find(
//         (item) => item.id === contractToDelete
//       );

//       const isFolder =
//         targetItem?.documents ||
//         targetItem?.document_type === "folder" ||
//         targetItem?.doc_type === "folder";

//       const payload = {
//         folder_ids: isFolder ? [contractToDelete] : [],
//         document_ids: !isFolder ? [contractToDelete] : [],
//       };

//       const response = await api.post(`api/v1/readpdf/bulk-delete/`, payload);

//       if (response.status === 200) {
//         const { deleted_folders = [], deleted_documents = [] } = response.data;

//         setFiles((prev) =>
//           prev.filter((file) => !deleted_documents.includes(file.id))
//         );
//         setFolders((prev) =>
//           prev.filter((folder) => !deleted_folders.includes(folder.id))
//         );

//         fetchContracts();
//         fetchFolders();
//       } else {
//         toast.error("Failed to delete the item. Please try again.");
//       }
//     } catch (error) {
//       toast.error("An unexpected error occurred during deletion.");
//       setDeleteInProgress(false);
//       setConfirmDeleteVisible(false);
//       setContractToDelete(null);
//       fetchContracts();
//       fetchFolders();
//     } finally {
//       setDeleteInProgress(false);
//       setConfirmDeleteVisible(false);
//       setContractToDelete(null);
//     }
//   };

//   useEffect(() => {
//     if (editContractId) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [editContractId]);

//   const upload = async (e) => {
//     const selectedFile = e.target.files[0];
//     if (!selectedFile) {
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", e.target.files[0]);
//     let file = null;
//     handleFile(e).then((res) => {
//       file = res;
//     });

//     try {
//       setLoading(true);
//       setStatus("Uploading...");
//       const response = await api
//         .post(`api/v1/readpdf/qdrant-upload-async/`, formData, {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         })
//         .then((res) => {});
//     } catch (err) {
//       setLoading(false);
//       setStatus("Error during file upload");
//       if (
//         err.response &&
//         err.response.data &&
//         err.response.data.msg === "Unsupported file format"
//       ) {
//         toast.warn("Unsupported file format", { autoClose: 2000 });
//       } else {
//         toast.error("An error occurred during file upload", {
//           autoClose: 2000,
//         });
//       }
//     }
//   };

//   const handleDeleteFolder = async (folderId) => {
//     setDeleteInProgress(true);
//     try {
//       const response = await api.delete(
//         `api/v1/readpdf/delete-folder/${folderId}/`
//       );

//       if (response.status === 204) {
//         setFolders((prevFolders) =>
//           prevFolders.filter((folder) => folder.id !== folderId)
//         );

//         setTimeout(() => {
//           setIsDeleteFolderModalOpen(false);
//           setDeleteInProgress(false);
//           fetchContracts();
//           fetchFolders();
//         }, 2000);
//       } else {
//         showPopup("Error", "Failed to delete folder. Please try again.");
//         setDeleteInProgress(false);
//       }
//     } catch (error) {
//       showPopup("Error", "Failed to delete folder. Please try again.");
//       setDeleteInProgress(false);
//     }
//   };

//   return (
//     <>
//       {loading && <Spinner />}
//       <div className="full-container max-w-full overflow-x-hidden">
//         <div className="">
//           <Header name="Documents" icon={""} isMenuOpen={isMenuOpen} />
//         </div>

//         <div>
//           <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[6px]">
//             <div
//               className="flex items-center gap-1 min-w-[300px]"
//               style={{ marginLeft: isMenuOpen ? "206px" : "110px" }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   width: "320px",
//                   height: "40px",
//                   padding: "8px 20px 8px 26px",
//                   alignItems: "center",
//                   gap: "1px",
//                   flexShrink: 0,
//                   borderRadius: "20px",
//                   border: isSearchFocused
//                     ? "1px solid rgba(187, 66, 174, 0.36)"
//                     : "1px solid rgba(0, 0, 0, 0.10)",
//                   backgroundColor: "#FFF",
//                   boxShadow: isSearchFocused
//                     ? "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)"
//                     : "none",
//                   overflow: "hidden",
//                 }}
//               >
//                 <img
//                   src="/search.svg"
//                   alt="Search"
//                   style={{
//                     width: "24px",
//                     height: "24px",
//                     flexShrink: 0,
//                     marginRight: "4px",
//                   }}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Search by name or type Tags: tagname"
//                   value={searchQuery}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setSearchQuery(value);

//                     if (value.toLowerCase().startsWith("tags:")) {
//                       setIsTagSearch(true);
//                     } else {
//                       setIsTagSearch(false);
//                     }
//                   }}
//                   onFocus={() => setIsSearchFocused(true)}
//                   onBlur={() => setIsSearchFocused(false)}
//                   style={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "14px",
//                     fontStyle: "normal",
//                     fontWeight: 400,
//                     lineHeight: "normal",
//                     border: "none",
//                     outline: "none",
//                     width: "100%",
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                     color: "#171717",
//                   }}
//                 />
//               </div>

//               <button
//                 ref={filterBtnRef}
//                 onMouseEnter={() => setIsHovered(true)}
//                 onMouseLeave={() => setIsHovered(false)}
//                 className={`button-filter-doc-button  bg-white border ${
//                   isFilterApplied
//                     ? "border-[rgba(187,66,174,0.36)]"
//                     : "border-[rgba(0,0,0,0.10)]"
//                 }`}
//                 onClick={toggleFilterModal}
//               >
//                 <img
//                   src="/filter-icon-first.svg"
//                   alt="Filter Icon"
//                   className="inline-block mr-2"
//                 />
//                 <span className="filter-text-button">Filter</span>
//               </button>

//               {isFilterApplied && (
//                 <>
//                   <img
//                     src="/Filter_CTA.svg"
//                     alt="Clear Filter"
//                     className="absolute bottom-6 -right-1 w-5 h-5"
//                     onClick={clearFilters}
//                   />

//                   <FilterAppliedTooltip
//                     targetRef={filterBtnRef}
//                     isVisible={isHovered}
//                     selectedFilters={selectedFilters}
//                   />
//                 </>
//               )}
//             </div>

//             <div className="flex items-center gap-3 flex-wrap justify-end">
//               {selectedContracts.length > 0 ? (
//                 <div className="flex items-center gap-2 flex-wrap justify-end">
//                   <div
//                     style={{
//                       display: "flex",
//                       padding: "3px 12px",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       gap: "10px",
//                       borderRadius: "8px",
//                       background: "rgba(139, 85, 221, 0.08)",
//                       color: "#8B55DD",
//                       fontFamily: "Outfit",
//                       fontSize: "14px",
//                       fontWeight: 400,
//                     }}
//                   >
//                     {selectedContracts.length} Documents selected
//                   </div>

//                   <button
//                     onClick={() => setIsBulkTagModalOpen(true)}
//                     className="flex items-center h-[36px] px-[14px] py-[8px] gap-[4px] rounded-[6px] border border-[rgba(0,0,0,0.10)] bg-[#8B55DD] text-white text-sm font-[Outfit]"
//                   >
//                     <span className="text-[#F5F4F3] font-[Outfit] text-[14px] font-medium leading-none">
//                       Bulk tag
//                     </span>
//                     <img
//                       src="/tag-icon-white.svg"
//                       alt="Tag"
//                       className="w-4 h-4"
//                     />
//                   </button>

//                   {selectedContracts.every(
//                     (item) => item.document_type !== "folder" && !item.documents
//                   ) && (
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setCurrentDocument(selectedContracts);
//                         setIsCopyModalOpen(true);
//                       }}
//                       disabled={exportInProgress}
//                       className="flex items-center justify-center gap-1.5 px-[14px] py-[8px] rounded-full border border-[rgba(0,0,0,0.10)] bg-[rgba(139,85,221,0.16)] text-[#8B55DD] font-medium text-sm font-[Outfit] transition disabled:opacity-60 disabled:cursor-not-allowed"
//                     >
//                       <img
//                         src="./copyToFolder.svg"
//                         alt="Copy"
//                         className="w-4 h-4 inline-block"
//                       />
//                       <span className="text-[#8B55DD] text-[14px] font-medium leading-none">
//                         {exportInProgress ? "Copying..." : "Copy to Folder"}
//                       </span>
//                     </button>
//                   )}

//                   {selectedContracts.every(
//                     (item) =>
//                       item.document_type === "contract" ||
//                       item.document_type === "invoice"
//                   ) && (
//                     <button
//                       onClick={handleExport}
//                       disabled={exportInProgress}
//                       className="flex items-center justify-center gap-1 px-[14px] py-[8px] rounded-full border border-[rgba(0,0,0,0.10)] bg-[rgba(139,85,221,0.16)] disabled:opacity-60 disabled:cursor-not-allowed transition"
//                     >
//                       <img
//                         src="/export-icon-blue.svg"
//                         alt="Export"
//                         className="w-4 h-4"
//                       />
//                       <span className="text-[#8B55DD] font-[Outfit] text-[14px] font-medium leading-none">
//                         {exportInProgress ? "Exporting..." : "Export"}
//                       </span>
//                     </button>
//                   )}

//                   <button
//                     onClick={handleBulkDeleteConfirmation}
//                     disabled={selectedContracts.length === 0}
//                     className="flex items-center justify-center gap-1 px-[14px] py-[8px] rounded-full border border-transparent bg-red-100 hover:bg-red-200 disabled:opacity-60 disabled:cursor-not-allowed transition"
//                   >
//                     <img
//                       src="/delete-icon-red.svg"
//                       alt="Delete"
//                       className="w-4 h-4"
//                     />
//                     <span className="text-[rgba(226,25,25,0.76)] font-[Outfit] text-[14px] font-medium leading-none">
//                       Delete
//                     </span>
//                   </button>

//                   <button
//                     onClick={handleCancel}
//                     className="flex items-center justify-center gap-1 p-2 rounded-full border border-[rgba(0,0,0,0.10)] bg-[#ECECEC] transition"
//                   >
//                     <img
//                       src="/cancel_icon.svg"
//                       alt="Cancel Icon"
//                       className="w-5 h-5 min-w-[20px] min-h-[20px]"
//                     />
//                   </button>
//                 </div>
//               ) : (
//                 <>
//                   <button
//                     onClick={() => setIsCreateFolderModalOpen(true)}
//                     className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-md border border-[#C95EBE] bg-white hover:bg-gray-50 transition"
//                   >
//                     <img
//                       src="/upload-doc-create.svg"
//                       alt="Create Folder"
//                       className="w-5 h-5"
//                     />
//                     <span className="text-[#C95EBE] font-[Outfit] text-[14px] font-semibold leading-[24px] tracking-[0.14px]">
//                       Create Folder
//                     </span>
//                   </button>

//                   <div className="relative z-50 inline-block">
//                     <button
//                       ref={uploadButtonRef}
//                       className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
//                       onClick={() => setIsTooltipVisible(!isTooltipVisible)}
//                       onMouseEnter={() => {
//                         if (uploadButtonRef.current) {
//                           const rect =
//                             uploadButtonRef.current.getBoundingClientRect();
//                           setTooltipCoords({
//                             top: rect.top + window.scrollY + 45,
//                             left: rect.left + window.scrollX + rect.width - 140,
//                           });
//                         }
//                       }}
//                     >
//                       <img src="/upload_icon_white.svg" className="w-5 h-5" />
//                       <span className="new-custom-butons-design-texts">
//                         Upload
//                       </span>
//                     </button>

//                     {isTooltipVisible && (
//                       <div
//                         className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
//                         style={{
//                           top: `${tooltipCoords.top + 10}px`,
//                           left: `${tooltipCoords.left - 50}px`,
//                         }}
//                         onMouseLeave={() => setIsTooltipVisible(false)}
//                       >
//                         <div
//                           className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                           onClick={() => {
//                             setIsTooltipVisible(false);
//                             fileInputRef.current.click();
//                           }}
//                         >
//                           <img
//                             src="/upload-icon.svg"
//                             alt="Upload"
//                             className="w-4 h-4"
//                           />
//                           Add from device
//                         </div>

//                         {!isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onClick={() => {
//                               setIsTooltipVisible(false);
//                               navigate("/account/integration");
//                             }}
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/connect-icon-hover.svg"
//                                   : "/connect-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />{" "}
//                             Connect Drive
//                           </div>
//                         )}

//                         {isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                             onClick={handleAddFromDriveClick}
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/picker-icon-hover.svg"
//                                   : "/picker-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />
//                             Add from Drive
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       multiple
//                       className="hidden"
//                       accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png,.docx"
//                       onChange={handleFileChange}
//                     />

//                     <HoverTooltip
//                       targetRef={uploadBtnRef}
//                       isVisible={isTooltipVisible}
//                       content={"Your tooltip content"}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           <div
//             className={`overflow-x-auto  transition-all duration-300 mt-1 w-full`}
//             style={{
//               marginLeft: isMenuOpen ? "182px" : "80px",
//             }}
//           >
//             <div className="overflow-x-auto w-[100%]">
//               <div
//                 className="relative overflow-x-auto  custom-scrollbar-container"
//                 style={{
//                   height: "calc(100vh - 158px)",
//                 }}
//                 ref={tbodyRef}
//               >
//                 <table className="text-sm text-left table-auto w-full">
//                   <thead className="bg-[#FFF] h-[46px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
//                     <tr>
//                       <th className="w-[40px] px-3">
//                         <input
//                           type="checkbox"
//                           className="custom-checkbox"
//                           style={{
//                             appearance: "none",
//                             border: "1.5px solid #c0c0c0",
//                             borderRadius: "4px",
//                             cursor: "pointer",
//                             backgroundImage:
//                               selectedContracts.length ===
//                                 folders.length + files.length &&
//                               folders.length + files.length > 0
//                                 ? "url('/checck.svg')"
//                                 : "none",
//                             backgroundPosition: "center",
//                             backgroundRepeat: "no-repeat",
//                             backgroundSize: "20px 20px",
//                           }}
//                           onChange={handleSelectAll}
//                           checked={
//                             selectedContracts.length ===
//                               folders.length + files.length &&
//                             folders.length + files.length > 0
//                           }
//                         />
//                       </th>
//                       <th className="w-[60px] px-1 file-size-of-heading">
//                         File Name
//                       </th>
//                       <th className="w-[60px] px-3 file-size-of-heading">
//                         File Type
//                       </th>
//                       <th className="w-[60px] px-3 file-size-of-heading">
//                         <div
//                           className="flex items-center gap-2 cursor-pointer"
//                           onClick={handleSortBySize}
//                         >
//                           <span>Size</span>
//                           <img
//                             src="/icons-size-icon.svg"
//                             alt="Size Icon"
//                             className="w-4 h-4"
//                           />
//                         </div>
//                       </th>
//                       <th className="w-[70px] px-3 file-size-of-heading">
//                         <div
//                           className="flex items-center gap-2 cursor-pointer"
//                           onClick={handleSortByDate}
//                         >
//                           <span>Uploaded Date</span>
//                           <img
//                             src="/icons-size-icon.svg"
//                             alt="Date Icon"
//                             className="w-4 h-4"
//                           />
//                         </div>
//                       </th>
//                       <th className="w-[70px] px-3 file-size-of-heading">
//                         Tags
//                       </th>
//                       <th className="w-[50px] px-3 file-size-of-heading">
//                         Chat
//                       </th>
//                       <th className="w-[200px] px-3 file-size-of-heading">
//                         Action
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {loading ? (
//                       <tr className="h-[36px]">
//                         <td colSpan="7" className="text-center">
//                           <Spinner />
//                         </td>
//                       </tr>
//                     ) : filteredPaginatedData.length > 0 ? (
//                       filteredPaginatedData.map((item, index) => (
//                         <tr
//                           key={`${
//                             item.isFolder ? item.doc_type : item.document_type
//                           }-${index}`}
//                           className="h-[40px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
//                           onClick={(e) => {
//                             if (
//                               e.target.type !== "checkbox" &&
//                               !e.target.classList.contains("action-button")
//                             ) {
//                               e.stopPropagation();

//                               if (cancelledPdfKeys.includes(item.key)) {
//                                 return;
//                               }

//                               if (item.documents) {
//                                 navigate(`/folder/?folderId=${item.id}`, {
//                                   state: {
//                                     folderId: item.id,
//                                     folderName: item.name,
//                                   },
//                                 });
//                               } else {
//                                 navigate("/chat", {
//                                   state: {
//                                     pdfUrl: item.pdf_url,
//                                     pdfKey: item.key,
//                                     pdfId: item.id,
//                                     document_type: item.document_type || null,
//                                   },
//                                 });
//                               }
//                             }
//                           }}
//                         >
//                           <td className="px-3">
//                             <input
//                               type="checkbox"
//                               className="custom-checkbox"
//                               style={{
//                                 appearance: "none",
//                                 border: "1.5px solid #c0c0c0",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                                 backgroundImage: selectedContracts.some(
//                                   (selectedItem) => selectedItem.id === item.id
//                                 )
//                                   ? "url('/checck.svg')"
//                                   : "none",
//                                 backgroundPosition: "center",
//                                 backgroundRepeat: "no-repeat",
//                                 backgroundSize: "20px 20px",
//                               }}
//                               checked={selectedContracts.some(
//                                 (selectedItem) => selectedItem.id === item.id
//                               )}
//                               onChange={() =>
//                                 handleCheckboxChange({
//                                   ...item,
//                                   document_type: item.isFolder
//                                     ? item.doc_type
//                                     : item.document_type,
//                                 })
//                               }
//                             />
//                           </td>
//                           <td className="px-1 truncate">
//                             <div className="flex items-center gap-2">
//                               <img
//                                 src={
//                                   item.documents
//                                     ? "/folder-icon-new.svg"
//                                     : item.file_type === "pdf"
//                                     ? "/pdff.svg"
//                                     : item.file_type === "xlsx"
//                                     ? "/Xls.svg"
//                                     : item.file_type === "docx"
//                                     ? "/docX.svg"
//                                     : item.file_type === "csv"
//                                     ? "/CSV.svg"
//                                     : item.file_type === "txt"
//                                     ? "/TXT.svg"
//                                     : item.file_type === "xls"
//                                     ? "/Xls.svg"
//                                     : "/pdf.svg"
//                                 }
//                                 className="w-5 h-5"
//                                 alt="Icon"
//                               />
//                               <FileNameWithTooltip name={item.name} />
//                             </div>
//                           </td>
//                           <td className="px-3 file-size-of-subheading">
//                             {item.documents
//                               ? "Folder"
//                               : item.document_type || "N/A"}
//                           </td>
//                           <td className="px-3 file-size-of-subheading">
//                             {item.documents
//                               ? item.folder_size || item.size || "N/A"
//                               : item.document_size || item.size || "N/A"}
//                           </td>
//                           <td className="px-3 file-size-of-subheading">
//                             {item.created_at || item.uploaded_at
//                               ? new Date(
//                                   item.created_at || item.uploaded_at
//                                 ).toLocaleDateString()
//                               : "N/A"}
//                           </td>
//                           <td className="px-3 file-size-of-subheading">
//                             {item.tags && item.tags.length > 0 ? (
//                               <div
//                                 className={`flex flex-wrap gap-1 relative max-w-[190px] ${
//                                   cancelledPdfKeys.includes(item.key)
//                                     ? "opacity-50 cursor-not-allowed pointer-events-none"
//                                     : "group"
//                                 }`}
//                                 onClick={(e) => {
//                                   if (cancelledPdfKeys.includes(item.key))
//                                     return;
//                                   e.stopPropagation();
//                                   setTagModalDocId(item.id);
//                                 }}
//                               >
//                                 {item.tags.slice(0, 2).map((tag) => (
//                                   <span
//                                     key={tag.id}
//                                     className="tag-pill cursor-pointer"
//                                     style={{
//                                       color: darkenColor(tag.color),
//                                       backgroundColor: `${tag.color}1A`,
//                                       border: `2px solid ${tag.color}`,
//                                     }}
//                                   >
//                                     {tag.name}
//                                   </span>
//                                 ))}

//                                 {item.tags.length > 2 &&
//                                   (() => {
//                                     const tag = item.tags[2];
//                                     return (
//                                       <span
//                                         className="tag-pill"
//                                         style={{
//                                           color: darkenColor(tag.color),
//                                           backgroundColor: `${tag.color}1A`,
//                                           border: `2px solid ${tag.color}`,
//                                         }}
//                                       >
//                                         +{item.tags.length - 2}
//                                       </span>
//                                     );
//                                   })()}

//                                 {!cancelledPdfKeys.includes(item.key) && (
//                                   <div className="hidden group-hover:flex absolute top-[100%] left-0 mt-1 z-50 bg-white p-2 rounded-md shadow-lg border border-gray-200 flex-wrap gap-1 w-max max-w-xs">
//                                     {item.tags.map((tag) => (
//                                       <span
//                                         key={tag.id}
//                                         className="tag-pill"
//                                         style={{
//                                           color: darkenColor(tag.color),
//                                           backgroundColor: `${tag.color}1A`,
//                                           border: `2px solid ${tag.color}`,
//                                         }}
//                                       >
//                                         {tag.name}
//                                       </span>
//                                     ))}
//                                   </div>
//                                 )}
//                               </div>
//                             ) : (
//                               <span
//                                 className={`inline-flex items-center gap-2 px-3 py-[6px] rounded-[20px] border border-[rgba(0,0,0,0.10)] bg-white text-[#52525B] text-[14px] font-[500] font-[Outfit] ${
//                                   cancelledPdfKeys.includes(item.key)
//                                     ? "opacity-50 cursor-not-allowed pointer-events-none"
//                                     : "cursor-pointer"
//                                 }`}
//                                 onClick={(e) => {
//                                   if (cancelledPdfKeys.includes(item.key))
//                                     return;
//                                   e.stopPropagation();
//                                   setTagModalDocId(item.id);
//                                 }}
//                               >
//                                 + Add Tag
//                               </span>
//                             )}
//                           </td>

//                           <td className="px-3 file-size-of-subheading">
//                             <div
//                               title={
//                                 cancelledPdfKeys.includes(item.key)
//                                   ? "You cancelled this upload. Please refresh to remove it."
//                                   : ""
//                               }
//                             >
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();

//                                   if (cancelledPdfKeys.includes(item.key)) {
//                                     return;
//                                   }

//                                   if (item.documents) {
//                                     navigate("/Contract/FolderChat", {
//                                       state: {
//                                         folderId: item.id,
//                                         folderName: item.name || "N/A",
//                                         pdfList: item.documents.map((doc) => ({
//                                           pdfKey: doc.key || doc.id,
//                                           pdfUrl:
//                                             doc.pdf_url ||
//                                             doc.file_url ||
//                                             doc.pdfUrl ||
//                                             "",
//                                           name: doc.name,
//                                         })),
//                                       },
//                                     });
//                                   } else {
//                                     navigate("/chat", {
//                                       state: {
//                                         pdfUrl: item.pdf_url || item.url,
//                                         pdfKey: item.key,
//                                         pdfId: item.id,
//                                         document_type:
//                                           item.document_type || null,
//                                       },
//                                     });
//                                   }
//                                 }}
//                                 onMouseEnter={() => setIsHovered(true)}
//                                 onMouseLeave={() => setIsHovered(false)}
//                                 disabled={cancelledPdfKeys.includes(item.key)}
//                                 className={`flex items-center gap-1 font-medium chat-button-documents-for ${
//                                   cancelledPdfKeys.includes(item.key)
//                                     ? "text-gray-400 cursor-not-allowed"
//                                     : "text-purple-500"
//                                 }`}
//                               >
//                                 <img
//                                   src={
//                                     isHovered
//                                       ? "/chat-icon-doc-hover.svg"
//                                       : "/chat-icon-doc.svg"
//                                   }
//                                   className="w-4 h-4"
//                                   alt="Chat"
//                                 />
//                                 Chat
//                               </button>
//                             </div>
//                           </td>

//                           <td className="px-3 relative">
//                             <img
//                               src={
//                                 cancelledPdfKeys.includes(item.key)
//                                   ? "./action.svg"
//                                   : "./action.svg"
//                               }
//                               alt="Actions"
//                               width="20"
//                               height="20"
//                               onClick={(e) => {
//                                 if (cancelledPdfKeys.includes(item.key)) {
//                                   return;
//                                 }
//                                 toggleActionMenu(index, e);
//                               }}
//                               style={{
//                                 cursor: cancelledPdfKeys.includes(item.key)
//                                   ? "not-allowed"
//                                   : "pointer",
//                                 opacity: cancelledPdfKeys.includes(item.key)
//                                   ? 0.4
//                                   : 1,
//                               }}
//                               title={
//                                 cancelledPdfKeys.includes(item.key)
//                                   ? "This upload was cancelled. Please refresh to remove it."
//                                   : "Actions"
//                               }
//                             />
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr className="h-[44px] text-center">
//                         <td colSpan="7" className="py-6 text-black-400">
//                           <img
//                             src="/no-contracts.svg"
//                             alt="No Data"
//                             className="mx-auto mb-2"
//                           />
//                           <p className="text-[16px]">
//                             Looks like your table is empty!
//                           </p>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               {paginatedData.length > 0 && (
//                 <div className="pagination-doc ml-2">
//                   <div className="pagination-dropdown">
//                     <p className="page-selector">{currentPage}</p>
//                   </div>
//                   <p className="contentDown">of {totalPages} pages</p>
//                   <button
//                     onClick={handlePreviousPage}
//                     disabled={currentPage === 1}
//                     style={{
//                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="decrease.svg"
//                       alt="Previous Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                   <button
//                     onClick={handleNextPage}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       cursor:
//                         currentPage === totalPages ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="increase.svg"
//                       alt="Next Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {confirmDeleteVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="document-popup-box-delete">
//               <h2>Are you sure you want to delete the selected item(s)?</h2>
//               <p>
//                 Once deleted, the selected item(s) will be permanently removed.
//                 This action cannot be undone.
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "8px",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   onClick={() => {
//                     if (!deleteInProgress) {
//                       setConfirmDeleteVisible(false);
//                     }
//                   }}
//                   className="document-popup-close-delete"
//                   disabled={deleteInProgress}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleBulkDelete}
//                   className="document-popup-close-button"
//                   disabled={deleteInProgress}
//                 >
//                   {deleteInProgress ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {contractToDelete && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="document-popup-box-delete">
//               <h2>Are you sure you want to delete the selected item(s)?</h2>
//               <p>
//                 Once deleted, the selected item(s) will be permanently removed.
//                 This action cannot be undone.
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "8px",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   onClick={() => setContractToDelete(null)}
//                   className="document-popup-close-delete"
//                   disabled={deleteInProgress}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   className="document-popup-close-button"
//                   disabled={deleteInProgress}
//                 >
//                   {deleteInProgress ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         <UploadModal
//           isOpen={isModalOpen}
//           onClose={handleCloseModal}
//           onUploadSuccess={handleUploadSuccess}
//           type={"document"}
//           file={file}
//         />
//         <RenameModal
//           isOpen={isRenameModalOpen}
//           onClose={() => setIsRenameModalOpen(false)}
//           document={currentDocument}
//           onRename={(documentId, newName) => handleRename(documentId, newName)}
//         />

//         <CopyToFolderModal
//           isOpen={isCopyModalOpen}
//           onClose={() => setIsCopyModalOpen(false)}
//           documents={currentDocument}
//           folders={folders}
//           onCopy={(documentId, folderId) =>
//             handleCopyToFolder(folderId, [documentId])
//           }
//           onCreateFolder={fetchFolders}
//         />

//         <FilterModal
//           isOpen={isFilterModalOpen}
//           onClose={() => setIsFilterModalOpen(false)}
//           onApply={(filteredFiles, filteredFolders) => {
//             setFiles(filteredFiles);
//             setFolders(filteredFolders);
//             setIsFilterApplied(true);
//           }}
//           setFiles={setFiles}
//           setFolders={setFolders}
//           setIsFilterApplied={setIsFilterApplied}
//           selectedFilters={selectedFilters}
//           setSelectedFilters={setSelectedFilters}
//           clearFilters={clearFilters}
//         />

//         <CreateFolderModal
//           isOpen={isCreateFolderModalOpen}
//           onClose={() => setIsCreateFolderModalOpen(false)}
//           onCreateSuccess={fetchFolders}
//         />
//         <RenameModal
//           isOpen={isRenameFolderModalOpen}
//           onClose={() => setIsRenameFolderModalOpen(false)}
//           document={currentFolder}
//           onRename={handleRenameFolder}
//         />

//         <button
//           onClick={handleBulkDelete}
//           disabled={selectedContracts.length === 0}
//         >
//           <img src="/delete-icon-red.svg" alt="Delete Icon" />
//         </button>

//         {isSuccessPopupVisible && (
//           <div className="success-popup-overlay">
//             <div className="success-popup-box">
//               <div className="stacked-icons-container">
//                 <img
//                   src="/folder-copy-tick.svg"
//                   alt="Tick"
//                   className="icon tick-icon"
//                 />
//                 <img
//                   src="/folder-copy-circle.svg"
//                   alt="Circle"
//                   className="icon circle-icon"
//                 />
//                 <img
//                   src="/folder-copied-circle.svg"
//                   alt="Copied"
//                   className="icon copied-icon"
//                 />
//               </div>

//               <h2 className="folder-uploaded-success">
//                 Folder Successfully Copied
//               </h2>
//               <p className="folder-folderName">
//                 Your documents have been copied to {successFolderName}.
//               </p>
//               <div className="copy-folder-last">
//                 <button
//                   onClick={() => navigate(`/folder/?folderId=${file_ids}`)}
//                   className="copy-folder-view"
//                 >
//                   View Folder
//                 </button>

//                 <button
//                   onClick={() => setIsSuccessPopupVisible(false)}
//                   className="copy-folder-done"
//                 >
//                   Done
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {isDeleteFolderModalOpen && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="document-popup-box-delete">
//               <h2>Are you sure you want to delete the selected item(s)?</h2>
//               <p>
//                 Once deleted, the selected item(s) will be permanently removed.
//                 This action cannot be undone.
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "8px",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   onClick={() => setIsDeleteFolderModalOpen(false)}
//                   className="document-popup-close-delete"
//                   disabled={deleteInProgress}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={() => handleDeleteFolder(folderToDelete)}
//                   className="document-popup-close-button"
//                   disabled={deleteInProgress}
//                 >
//                   {deleteInProgress ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {showSubscriptionPopup && (
//           <SubscriptionPopup onClose={() => setShowSubscriptionPopup(false)} />
//         )}

//         {isActionMenuOpen !== null && (
//           <div
//             className="fixed inset-0 z-[9998] backdrop-overlay"
//             onClick={() => setIsActionMenuOpen(null)}
//           >
//             <div
//               className={`document-action-menu ${
//                 paginatedData[isActionMenuOpen]?.documents
//                   ? "folder-options"
//                   : ""
//               } fixed z-[9999] bg-white shadow-md rounded-md`}
//               ref={actionMenuRef}
//               style={{
//                 top:
//                   isActionMenuOpen >= paginatedData.length - 4
//                     ? `${actionMenuPosition.top - 130}px`
//                     : `${actionMenuPosition.top}px`,
//                 left: `${actionMenuPosition.left}px`,
//               }}
//             >
//               {paginatedData[isActionMenuOpen]?.documents ? (
//                 <>
//                   <div
//                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-2"
//                     onMouseEnter={() => setHoveredAction("rename-folder")}
//                     onMouseLeave={() => setHoveredAction(null)}
//                     onMouseDown={() => setClickedAction("rename-folder")}
//                     onMouseUp={() => setClickedAction(null)}
//                     onClick={() => {
//                       setCurrentFolder(paginatedData[isActionMenuOpen]);
//                       setIsRenameFolderModalOpen(true);
//                     }}
//                     style={{
//                       color:
//                         clickedAction === "rename-folder"
//                           ? "#C95EBE"
//                           : hoveredAction === "rename-folder"
//                           ? "#C95EBE"
//                           : "",
//                       transition:
//                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                       borderRadius: "8px",
//                       background:
//                         clickedAction === "rename-folder" ||
//                         hoveredAction === "rename-folder"
//                           ? "#FAF9F6"
//                           : "transparent",
//                       padding: "10px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src={
//                         clickedAction === "rename-folder" ||
//                         hoveredAction === "rename-folder"
//                           ? "./edit-active-contract.svg"
//                           : "./edit.svg"
//                       }
//                       alt="Edit Icon"
//                       className="document-action-icon"
//                     />
//                     <p>Rename Folder</p>
//                   </div>

//                   <div
//                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
//                     onMouseEnter={() => setHoveredAction("delete-folder")}
//                     onMouseLeave={() => setHoveredAction(null)}
//                     onMouseDown={() => setClickedAction("delete-folder")}
//                     onMouseUp={() => setClickedAction(null)}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setFolderToDelete(paginatedData[isActionMenuOpen].id);
//                       setIsDeleteFolderModalOpen(true);
//                     }}
//                     style={{
//                       color:
//                         clickedAction === "delete-folder"
//                           ? "#E74C3C"
//                           : hoveredAction === "delete-folder"
//                           ? "#E74C3C"
//                           : "",
//                       transition:
//                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                       borderRadius: "8px",
//                       background:
//                         clickedAction === "delete-folder" ||
//                         hoveredAction === "delete-folder"
//                           ? "#FFF5F5"
//                           : "transparent",
//                       padding: "10px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src={
//                         clickedAction === "delete-folder" ||
//                         hoveredAction === "delete-folder"
//                           ? "./delete-active-contract.svg"
//                           : "./delete.svg"
//                       }
//                       alt="Delete Icon"
//                       className="document-action-icon"
//                     />
//                     <p>Delete Folder</p>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div
//                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
//                     onMouseEnter={() => setHoveredAction("copy")}
//                     onMouseLeave={() => setHoveredAction(null)}
//                     onMouseDown={() => setClickedAction("copy")}
//                     onMouseUp={() => setClickedAction(null)}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       if (selectedContracts.length > 0) {
//                         setCurrentDocument(selectedContracts);
//                       } else {
//                         setCurrentDocument([paginatedData[isActionMenuOpen]]);
//                       }
//                       setIsCopyModalOpen(true);
//                     }}
//                     style={{
//                       color:
//                         clickedAction === "copy"
//                           ? "#C95EBE"
//                           : hoveredAction === "copy"
//                           ? "#C95EBE"
//                           : "",
//                       transition:
//                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                       borderRadius: "8px",
//                       background:
//                         clickedAction === "copy" || hoveredAction === "copy"
//                           ? "#FAF9F6"
//                           : "transparent",
//                       padding: "10px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src={
//                         clickedAction === "copy" || hoveredAction === "copy"
//                           ? "./folder-copy-active.svg"
//                           : "./folder-copy.svg"
//                       }
//                       alt="Copy to Folder Icon"
//                       className="document-action-icon"
//                     />
//                     <p>Copy to Folder</p>
//                   </div>

//                   <div
//                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
//                     onMouseEnter={() => setHoveredAction("rename")}
//                     onMouseLeave={() => setHoveredAction(null)}
//                     onMouseDown={() => setClickedAction("rename")}
//                     onMouseUp={() => setClickedAction(null)}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentDocument(paginatedData[isActionMenuOpen]);
//                       setIsRenameModalOpen(true);
//                     }}
//                     style={{
//                       color:
//                         clickedAction === "rename"
//                           ? "#C95EBE"
//                           : hoveredAction === "rename"
//                           ? "#C95EBE"
//                           : "",
//                       transition:
//                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                       borderRadius: "8px",
//                       background:
//                         clickedAction === "rename" || hoveredAction === "rename"
//                           ? "#FAF9F6"
//                           : "transparent",
//                       padding: "10px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src={
//                         clickedAction === "rename" || hoveredAction === "rename"
//                           ? "./edit-active-contract.svg"
//                           : "./edit.svg"
//                       }
//                       alt="Edit Icon"
//                       className="document-action-icon"
//                     />
//                     <p>Rename</p>
//                   </div>

//                   <div
//                     className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
//                     onMouseEnter={() => setHoveredAction("delete")}
//                     onMouseLeave={() => setHoveredAction(null)}
//                     onMouseDown={() => setClickedAction("delete")}
//                     onMouseUp={() => setClickedAction(null)}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleDelete(paginatedData[isActionMenuOpen].id);
//                     }}
//                     style={{
//                       color:
//                         clickedAction === "delete"
//                           ? "#E74C3C"
//                           : hoveredAction === "delete"
//                           ? "#E74C3C"
//                           : "#000",
//                       transition:
//                         "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                       borderRadius: "8px",
//                       background:
//                         clickedAction === "delete" || hoveredAction === "delete"
//                           ? "#FAF9F6"
//                           : "transparent",
//                       padding: "10px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src={
//                         clickedAction === "delete" || hoveredAction === "delete"
//                           ? "./delete-active-contract.svg"
//                           : "./delete.svg"
//                       }
//                       alt="Delete Icon"
//                       className="document-action-icon"
//                     />
//                     <p className="delete-name-svggg">Delete</p>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         )}
//         {tagModalDocId && (
//           <CreateTagModals
//             isOpen={true}
//             onClose={() => setTagModalDocId(null)}
//             documentId={tagModalDocId}
//             onTagUpdate={() => {
//               fetchContracts();
//               fetchFolders();
//             }}
//           />
//         )}

//         {isBulkTagModalOpen && selectedContracts.length > 0 && (
//           <CreateTagModals
//             isOpen={true}
//             onClose={() => setIsBulkTagModalOpen(false)}
//             documentId={selectedContracts.map((doc) => doc.id)}
//             onTagUpdate={() => {
//               fetchContracts();
//               fetchFolders();
//             }}
//             onClearSelection={() => setSelectedContracts([])}
//           />
//         )}
//       </div>
//     </>
//   );
// };

// export default UploadFilePage;
/* global google */
/* global gapi */
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import Cookies from "js-cookie";
import api from "../chat/api";
import { useLocation, useNavigate } from "react-router";
import { Header } from "../../components/Header/Header";
import "./UploadFilePage.css";
import { toast } from "../../utils/appToast";
import UploadModal from "../Contract/UploadModal";
import CreateFolderModal from "../Contract/CreateFolderModal";
import FilterModal from "./FilterModal";
import HoverTooltip from "./HoverTooltip.jsx";
import FilterAppliedTooltip from "./FilterAppliedTooltip.jsx";
import FileNameWithTooltip from "./FileNameWithTooltip.jsx";
import CreateTagModals from "../Tags/CreateTagModals.jsx";
import useGooglePicker from "../Ocr_Data/useGooglePicker.js";

// --- Extracted Modals outside main component for React Performance --- //

const CopyToFolderModal = ({ isOpen, onClose, documents, folders, onCopy, onCreateFolder }) => {
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [selectedFolderName, setSelectedFolderName] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [creatingNewFolder, setCreatingNewFolder] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [copyInProgress, setCopyInProgress] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!selectedFolder) {
      setErrorMessage("Please select a folder.");
      return;
    }
    if (!documents || documents.length === 0) {
      alert("No document selected for copying.");
      return;
    }

    setErrorMessage("");
    setCopyInProgress(true);
    try {
      await onCopy(documents.map((doc) => doc.id), selectedFolder);
      onClose();
    } catch (err) {
      setErrorMessage("Failed to copy documents.");
    } finally {
      setCopyInProgress(false);
    }
  };

  const handleCreateFolder = async () => {
    const trimmedFolderName = newFolderName.trim();
    if (!trimmedFolderName) {
      setErrorMessage("Folder name cannot be empty.");
      return;
    }
    if (!documents || documents.length === 0) {
      toast.warn("Please select at least one document.", { autoClose: 2000 });
      return;
    }

    const isDuplicate = folders.some((folder) => folder.name.toLowerCase() === trimmedFolderName.toLowerCase());
    if (isDuplicate) {
      toast.warn("A folder with this name already exists.", { autoClose: 3000 });
      return;
    }

    setErrorMessage("");
    setLoading(true);

    try {
      const documentIds = documents.map((doc) => doc.id);
      const response = await api.post("api/v1/readpdf/add-files/", {
        file_ids: documentIds,
        folder_name: trimmedFolderName,
      });

      if (response.status === 200) {
        const newFolderId = response.data.folder_id;
        setSelectedFolder(newFolderId);
        setSelectedFolderName(trimmedFolderName);
        setNewFolderName("");
        setCreatingNewFolder(false);
        if (onCreateFolder) onCreateFolder();
        onClose();
      }
    } catch (error) {
      if (error.response?.data?.msg === "Folder with this name already exists") {
        toast.warn("A folder with this name already exists.", { autoClose: 2000 });
      } else {
        toast.error("Failed to create folder. Please try again.", { autoClose: 2000 });
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 font-outfit">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[#171717] text-[18px] font-semibold">Copy to Folder</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl transition-colors">×</button>
        </div>
        <p className="text-[#52525B] text-[14px] mb-6">Copy into any folder and organize your documents</p>
        
        <h3 className="text-[#171717] text-[14px] font-medium mb-2">Choose Folder</h3>
        <div className="relative">
          <div
            className="flex justify-between items-center w-full px-4 py-2 border border-gray-300 rounded-[8px] cursor-pointer hover:border-[#C95EBE] transition-colors"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <span className={`text-[14px] ${selectedFolder ? "text-[#171717]" : "text-gray-400"}`}>
              {selectedFolder ? selectedFolderName : "Select a folder"}
            </span>
            <img src="/copyToFolder-icon.svg" alt="Dropdown" className="w-4 h-4" />
          </div>

          {creatingNewFolder && (
            <div className="flex items-center gap-2 mt-2 p-2 border border-gray-200 rounded-[8px] bg-gray-50">
              <input
                type="text"
                placeholder="Enter folder name"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                className="flex-grow px-3 py-1.5 text-[14px] border border-gray-300 rounded-[6px] outline-none focus:border-[#C95EBE]"
              />
              <button onClick={handleCreateFolder} className="px-3 py-1.5 bg-[#C95EBE] text-white rounded-[6px] text-[13px] font-medium hover:bg-[#b04b9e]">
                {loading ? "Saving..." : "Save"}
              </button>
              <button onClick={() => setCreatingNewFolder(false)} className="px-3 py-1.5 bg-white border border-gray-300 text-gray-600 rounded-[6px] text-[13px] font-medium hover:bg-gray-100">
                Cancel
              </button>
            </div>
          )}

          {dropdownOpen && (
            <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-200 rounded-[8px] shadow-lg max-h-[200px] overflow-y-auto z-50 py-1">
              {folders.length > 0 ? (
                folders.map((folder) => (
                  <div
                    key={folder.id}
                    className="px-4 py-2 text-[14px] text-[#171717] hover:bg-[#F8F3FF] cursor-pointer"
                    onClick={() => {
                      setSelectedFolder(folder.id);
                      setSelectedFolderName(folder.name);
                      setDropdownOpen(false);
                    }}
                  >
                    {folder.name}
                  </div>
                ))
              ) : (
                <div className="px-4 py-2 text-[14px] text-gray-500 italic">No folders available</div>
              )}
            </div>
          )}

          {dropdownOpen && !creatingNewFolder && (
            <button
              className="flex items-center gap-2 mt-3 text-[#C95EBE] text-[14px] font-medium hover:text-[#b04b9e] transition-colors"
              onClick={() => { setCreatingNewFolder(true); setDropdownOpen(true); }}
            >
              <img src="/folder-icon-copy.svg" alt="Folder" className="w-4 h-4" />
              Create New Folder
            </button>
          )}
        </div>

        {errorMessage && <p className="text-red-500 text-[13px] mt-2">{errorMessage}</p>}

        <div className="flex justify-end gap-3 mt-8">
          <button onClick={onClose} className="px-5 py-2 rounded-[8px] border border-gray-200 text-[#52525B] text-[14px] font-medium hover:bg-gray-50">
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={copyInProgress || !selectedFolder}
            className="px-5 py-2 rounded-[8px] bg-[#C95EBE] text-white text-[14px] font-medium hover:bg-[#b04b9e] disabled:opacity-60"
          >
            {copyInProgress ? "Copying..." : "Copy"}
          </button>
        </div>
      </div>
    </div>
  );
};

const RenameModal = ({ isOpen, onClose, document, onRename }) => {
  const [newName, setNewName] = useState("");
  const [isRenaming, setIsRenaming] = useState(false);

  useEffect(() => {
    if (document) {
      const initialName = document.pdf_name || document.name || document.folder_name || "";
      setNewName(initialName);
    }
  }, [document]);

  const handleSave = async () => {
    if (!newName.trim()) return;
    setIsRenaming(true);
    try {
      await onRename(document.id, newName.trim());
    } catch (err) {
      console.error(err);
    } finally {
      setIsRenaming(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white rounded-[12px] shadow-xl w-[400px] p-6 font-outfit">
        <h2 className="text-[#171717] text-[18px] font-semibold mb-1">Rename Document</h2>
        <p className="text-[#52525B] text-[14px] mb-5">Create a Custom Name for your Documents</p>
        
        <label className="block text-[#171717] text-[14px] font-medium mb-1.5">Title</label>
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="Enter new name"
          disabled={isRenaming}
          className="w-full px-3 py-2 border border-gray-300 rounded-[8px] outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] text-[14px] text-[#171717]"
        />
        
        <div className="flex justify-end gap-3 mt-6">
          <button onClick={onClose} className="px-5 py-2 rounded-[8px] border border-gray-200 text-[#52525B] text-[14px] font-medium hover:bg-gray-50">
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isRenaming || !newName.trim()}
            className="px-5 py-2 rounded-[8px] bg-[#C95EBE] text-white text-[14px] font-medium hover:bg-[#b04b9e] disabled:opacity-60"
          >
            {isRenaming ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};


// --- Main Component --- //

const UploadFilePage = ({ isMenuOpen }) => {
  const [isBulkTagModalOpen, setIsBulkTagModalOpen] = useState(false);
  const uploadButtonRef = useRef(null);
  const { isConnected, openPicker, accessToken } = useGooglePicker();
  const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
  const filterBtnRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filters, setFilters] = useState({ folder: true, normalDocument: true, contract: false, invoices: false, spreadsheet: false });
  const [selectedFilters, setSelectedFilters] = useState({ folder: false, normalDocument: false, contract: false, invoice: false });
  const uploadBtnRef = useRef(null);
  const [isTagSearch, setIsTagSearch] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const fileInputRef = useRef(null);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const actionMenuRef = useRef(null);
  const [isSuccessPopupVisible, setIsSuccessPopupVisible] = useState(false);
  const [successFolderName, setSuccessFolderName] = useState("");
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [selectedInvoiceKeys, setSelectedInvoiceKeys] = useState([]);
  const [file_ids, setFileId] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [token, setToken] = useState(Cookies.get("access_token") || localStorage.getItem("token") || "");
  const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
  const [isRenameFolderModalOpen, setIsRenameFolderModalOpen] = useState(false);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [copyInProgress, setCopyInProgress] = useState(false);
  const [tagModalDocId, setTagModalDocId] = useState(null);
  const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false);
  const [folderToDelete, setFolderToDelete] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const editRowRef = useRef(null);
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const tbodyRef = useRef(null);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [cancelledPdfKeys, setCancelledPdfKeys] = useState([]);
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [folders, setFolders] = useState([]);
  const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const [showSingleDeleteConfirm, setShowSingleDeleteConfirm] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const location = useLocation();
  const contractKey = location.state?.contractKey;
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [actionMenuPosition, setActionMenuPosition] = useState({ top: 0, left: 0 });
  const [file, setFile] = useState(null);

  const handleSortBySize = () => setSortConfig((prev) => ({ key: "size", direction: prev.key === "size" && prev.direction === "asc" ? "desc" : "asc" }));
  const handleSortByDate = () => setSortConfig((prev) => ({ key: "date", direction: prev.key === "date" && prev.direction === "asc" ? "desc" : "asc" }));

  function darkenColor(hex, amount = 0.4) {
    if (!hex || !hex.startsWith("#")) return "#333";
    const num = parseInt(hex.slice(1), 16);
    let r = (num >> 16) & 255;
    let g = (num >> 8) & 255;
    let b = num & 255;
    r = Math.floor(r * (1 - amount));
    g = Math.floor(g * (1 - amount));
    b = Math.floor(b * (1 - amount));
    return `rgb(${r}, ${g}, ${b})`;
  }

  useEffect(() => {
    if (isRenameModalOpen || isCopyModalOpen || isRenameFolderModalOpen || isDeleteFolderModalOpen || confirmDeleteVisible || contractToDelete || popupVisible) {
      setIsActionMenuOpen(null);
    }
  }, [isRenameModalOpen, isCopyModalOpen, isRenameFolderModalOpen, isDeleteFolderModalOpen, confirmDeleteVisible, contractToDelete, popupVisible]);

  useEffect(() => {
    if (isConnected && !hasOpenedPickerOnce) setHasOpenedPickerOnce(true);
  }, [isConnected, hasOpenedPickerOnce]);

  const handleAddFromDriveClick = () => {
    openPicker(async (docs) => {
      try {
        const pickedFiles = await Promise.all(
          docs.map(async (doc) => {
            const res = await fetch(`https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`, { headers: { Authorization: `Bearer ${accessToken}` }});
            if (!res.ok) throw new Error("Failed to fetch file from Drive");
            const blob = await res.blob();
            return new File([blob], doc.name, { type: blob.type });
          })
        );
        setFile(pickedFiles);
        setIsModalOpen(true);
      } catch (err) {
        toast.error("Something went wrong while processing selected files.");
      }
    });
  };

  useEffect(() => {
    const cookieToken = Cookies.get("access_token");
    if (cookieToken) setToken(cookieToken);
  }, []);

  useEffect(() => {
    if (location.state?.cancelledPdfKeys) {
      setCancelledPdfKeys(location.state.cancelledPdfKeys);
    }
  }, [location.state]);

  const resetSelections = () => {
    setSelectedContracts([]);
    setSelectedContractKeys([]);
    setSelectedInvoiceKeys([]);
    setCurrentDocument(null);
    setCurrentFolder(null);
    setEditContractId(null);
    setEditedContractData({});
    setIsActionMenuOpen(null);
    setContractToDelete(null);
    setFolderToDelete(null);
    setConfirmDeleteVisible(false);
    setIsRenameModalOpen(false);
    setIsRenameFolderModalOpen(false);
    setIsCopyModalOpen(false);
    setIsDeleteFolderModalOpen(false);
  };

  const clearFilters = async () => {
    setSelectedFilters({ folder: false, normalDocument: false, contract: false, invoice: false });
    try {
      const response = await api.get("api/v1/readpdf/files-and-folders/");
      if (response.status === 200) {
        setFiles(Array.isArray(response.data.files) ? response.data.files : []);
        setFolders(Array.isArray(response.data.folders) ? response.data.folders : []);
        setIsFilterApplied(false);
      }
    } catch (error) {
      setFiles([]);
      setFolders([]);
    }
  };

  const toggleModal = () => setIsModalOpen((prev) => !prev);
  const toggleFilterModal = () => setIsFilterModalOpen((prev) => !prev);

  const toggleActionMenu = (index, event) => {
    event.stopPropagation();
    if (isActionMenuOpen === index) {
      setIsActionMenuOpen(null);
    } else {
      const rect = event.currentTarget.getBoundingClientRect();
      setActionMenuPosition({ top: rect.bottom + 6, left: rect.left - 130 });
      setIsActionMenuOpen(index);
    }
  };

  const handleFileChange = (event) => {
    if (!isCreateFolderModalOpen) {
      const selectedFiles = Array.from(event.target.files || []);
      if (selectedFiles.length === 0) return;
      setFile(selectedFiles);
      setIsModalOpen(true);
    }
  };

  const handleExport = async () => {
    if (selectedContracts.length === 0 || (!selectedContractKeys.length && !selectedInvoiceKeys.length)) {
      showPopup("Error", "Please select at least one document to export.");
      return;
    }
    setExportInProgress(true);
    try {
      const response = await api.post("api/v1/readpdf/export-doc/", {
        contract_keys: selectedContractKeys,
        invoice_keys: selectedInvoiceKeys,
      }, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "exported_documents.csv");
      document.body.appendChild(link);
      link.click();
      resetSelections();
    } catch (error) {
      showPopup("Error", error.response?.data?.msg || "Failed to export documents.");
    } finally {
      setExportInProgress(false);
    }
  };

  const handleClickOutside = (event) => {
    if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
      setIsActionMenuOpen(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCancel = () => {
    resetSelections();
    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);
    setConfirmDeleteVisible(false);
  };

  const handleUploadSuccess = () => {
    fetchContracts();
    fetchFolders();
    toggleModal();
  };

  const handleCloseModal = () => toggleModal();

  const handleBulkDeleteConfirmation = () => {
    if (selectedContracts.length === 0) {
      showPopup("Error", "No files or folders selected for bulk deletion.");
      return;
    }
    setPopupTitle("Confirm Bulk Deletion");
    setPopupMessage("Are you sure you want to delete the selected items? This action cannot be undone.");
    setDeleteTarget("bulk");
    setConfirmDeleteVisible(true);
  };

  const fetchFolders = async () => { /* Add logic if needed separately */ };

  const fetchContracts = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const response = await api.get("api/v1/readpdf/files-and-folders/");
      setFiles(response.data.files || []);
      setFolders(response.data.folders || []);
    } catch (error) {
      if (error.response?.data?.message !== "No valid trial or active subscription. Redirecting to payment.") {
        toast.error("Failed to load documents. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAll = () => {
    const allItems = [...folders, ...files].map((item) => ({
      ...item,
      document_type: !!item.documents ? "folder" : item.document_type || "file",
    }));

    if (selectedContracts.length === allItems.length) {
      setSelectedContracts([]);
      setSelectedContractKeys([]);
      setSelectedInvoiceKeys([]);
    } else {
      setSelectedContracts(allItems);
      setSelectedContractKeys(allItems.filter((i) => i.document_type === "contract").map((i) => i.key));
      setSelectedInvoiceKeys(allItems.filter((i) => i.document_type === "invoice").map((i) => i.key));
    }
  };

  const handleCheckboxChange = (item) => {
    const isSelected = selectedContracts.some((selectedItem) => selectedItem.id === item.id);
    if (isSelected) {
      setSelectedContracts(selectedContracts.filter((selectedItem) => selectedItem.id !== item.id));
      if (item.document_type === "contract") setSelectedContractKeys(selectedContractKeys.filter((key) => key !== item.key));
      else if (item.document_type === "invoice") setSelectedInvoiceKeys(selectedInvoiceKeys.filter((key) => key !== item.key));
    } else {
      setSelectedContracts([...selectedContracts, item]);
      if (item.document_type === "contract") setSelectedContractKeys([...selectedContractKeys, item.key]);
      else if (item.document_type === "invoice") setSelectedInvoiceKeys([...selectedInvoiceKeys, item.key]);
    }
  };

  const parseTimeAgo = (timeAgo) => {
    if (!timeAgo) return 0;
    const [amountStr, unit] = timeAgo.toLowerCase().split(" ");
    const amount = parseInt(amountStr);
    const now = new Date();
    switch (unit) {
      case "second": case "seconds": return now.getTime() - amount * 1000;
      case "minute": case "minutes": return now.getTime() - amount * 60 * 1000;
      case "hour": case "hours": return now.getTime() - amount * 60 * 60 * 1000;
      case "day": case "days": return now.getTime() - amount * 24 * 60 * 60 * 1000;
      case "week": case "weeks": return now.getTime() - amount * 7 * 24 * 60 * 60 * 1000;
      case "month": case "months": return now.getTime() - amount * 30 * 24 * 60 * 60 * 1000;
      default: return 0;
    }
  };

  const combinedFilesAndFolders = useMemo(() => {
    const sorted = [...folders, ...files].map((item) => ({
      ...item,
      isFolder: !!item.documents,
      timeAgoParsed: parseTimeAgo(item.time_ago),
      sizeParsed: parseFloat(item.document_size || item.folder_size || item.size || 0),
      uploadedTime: new Date(item.created_at || item.uploaded_at).getTime(),
    }));

    if (sortConfig.key === "size") {
      sorted.sort((a, b) => sortConfig.direction === "asc" ? a.sizeParsed - b.sizeParsed : b.sizeParsed - a.sizeParsed);
    } else if (sortConfig.key === "date") {
      sorted.sort((a, b) => sortConfig.direction === "asc" ? a.uploadedTime - b.uploadedTime : b.uploadedTime - a.uploadedTime);
    } else {
      sorted.sort((a, b) => b.timeAgoParsed - a.timeAgoParsed);
    }
    return sorted;
  }, [folders, files, sortConfig]);

  const filteredPaginatedData = useMemo(() => {
    const query = searchQuery.toLowerCase().trim();
    return combinedFilesAndFolders.filter((item) => {
      const nameMatch = (item.name || "").toLowerCase().includes(query);
      const tagMatch = item.tags?.some((tag) => tag.name?.toLowerCase().includes(query.replace("tags:", "").trim())) || false;
      return isTagSearch ? tagMatch : nameMatch || tagMatch;
    });
  }, [combinedFilesAndFolders, searchQuery, isTagSearch]);

  const showPopup = (title, message) => {
    setIsSuccessPopupVisible(false);
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
    fetchContracts();
    fetchFolders();
  };

  const handleBulkDelete = async () => {
    if (selectedContracts.length === 0) {
      showPopup("Error", "No files or folders selected for deletion.");
      return;
    }
    setDeleteInProgress(true);
    try {
      const folderIds = selectedContracts.filter((item) => item.documents || item.document_type === "folder" || item.doc_type === "folder").map((item) => item.id);
      const documentIds = selectedContracts.filter((item) => !item.documents && item.document_type !== "folder" && item.doc_type !== "folder").map((item) => item.id);

      const payload = { folder_ids: folderIds, document_ids: documentIds };
      const response = await api.post(`api/v1/readpdf/bulk-delete/`, payload);

      if (response.status === 200) {
        const { deleted_folders, deleted_documents } = response.data;
        setFiles((prev) => prev.filter((file) => !deleted_documents.includes(file.id)));
        setFolders((prev) => prev.filter((folder) => !deleted_folders.includes(folder.id)));
        setSelectedContracts([]);
        setTimeout(() => {
          setConfirmDeleteVisible(false);
          setDeleteInProgress(false);
          fetchContracts();
          fetchFolders();
        }, 2000);
      } else {
        showPopup("Error", "Failed to delete selected items. Please try again.");
      }
    } catch (error) {
      showPopup("Error", "An unexpected error occurred during deletion.");
      setConfirmDeleteVisible(false);
      setDeleteInProgress(false);
      fetchContracts();
      fetchFolders();
    }
  };

  const handleDelete = (pdfId) => {
    if (!token) {
      showPopup("Session Expired", "Session expired. Please log in again.");
      return;
    }
    setPopupTitle("Are you sure you want to delete the selected item(s)");
    setPopupMessage("Are you sure you want to delete this PDF? This action cannot be undone.");
    setContractToDelete(pdfId);
    setDeleteTarget("single");
    setConfirmDeleteVisible(true);
  };

  const confirmDelete = async () => {
    if (!contractToDelete || !token) {
      showPopup("Error", "No file or folder selected for deletion.");
      return;
    }
    setDeleteInProgress(true);
    try {
      const targetItem = [...files, ...folders].find((item) => item.id === contractToDelete);
      const isFolder = targetItem?.documents || targetItem?.document_type === "folder" || targetItem?.doc_type === "folder";

      const payload = {
        folder_ids: isFolder ? [contractToDelete] : [],
        document_ids: !isFolder ? [contractToDelete] : [],
      };

      const response = await api.post(`api/v1/readpdf/bulk-delete/`, payload);

      if (response.status === 200) {
        const { deleted_folders = [], deleted_documents = [] } = response.data;
        setFiles((prev) => prev.filter((file) => !deleted_documents.includes(file.id)));
        setFolders((prev) => prev.filter((folder) => !deleted_folders.includes(folder.id)));
        fetchContracts();
        fetchFolders();
      } else {
        toast.error("Failed to delete the item. Please try again.");
      }
    } catch (error) {
      toast.error("An unexpected error occurred during deletion.");
    } finally {
      setDeleteInProgress(false);
      setConfirmDeleteVisible(false);
      setContractToDelete(null);
    }
  };

  const handleDeleteFolder = async (folderId) => {
    setDeleteInProgress(true);
    try {
      const response = await api.delete(`api/v1/readpdf/delete-folder/${folderId}/`);
      if (response.status === 204) {
        setFolders((prevFolders) => prevFolders.filter((folder) => folder.id !== folderId));
        setTimeout(() => {
          setIsDeleteFolderModalOpen(false);
          setDeleteInProgress(false);
          fetchContracts();
          fetchFolders();
        }, 2000);
      } else {
        showPopup("Error", "Failed to delete folder. Please try again.");
        setDeleteInProgress(false);
      }
    } catch (error) {
      showPopup("Error", "Failed to delete folder. Please try again.");
      setDeleteInProgress(false);
    }
  };

  const handleRenameFolder = async (folderId, newName) => {
    try {
      const response = await api.put(`api/v1/readpdf/rename-folder/${folderId}/`, { new_name: newName });
      if (response.status === 200) {
        setFolders((prevFolders) => prevFolders.map((folder) => folder.id === folderId ? { ...folder, name: response.data.folder_name } : folder));
        fetchContracts();
        fetchFolders();
      }
    } catch (error) {
      showPopup("Error", "Failed to rename folder.");
    }
  };

  const handleRename = async (documentId, newName) => {
    try {
      const response = await api.put(`api/v1/readpdf/rename-doc/${documentId}/`, { new_name: newName });
      if (response.status === 200) {
        setFiles((prevFiles) => prevFiles.map((file) => file.id === documentId ? { ...file, pdf_name: response.data.new_name, name: response.data.new_name } : file));
        fetchContracts();
        fetchFolders();
      }
    } catch (err) {
      showPopup("Error", "Rename failed. Please try again.");
    }
  };

  const handleCopyToFolder = async (folderId, fileIds) => {
    const flatFileIds = fileIds.flat();
    setCopyInProgress(true);
    try {
      const response = await api.post(`api/v1/readpdf/add-files/`, { file_ids: flatFileIds, folder_id: folderId });
      if (response.status === 200) {
        setFileId(folderId);
        setSuccessFolderName(folders.find((f) => f.id === folderId)?.name || "Selected Folder");
        setIsSuccessPopupVisible(true);
      }
    } catch (error) {
      toast.error(error.response?.data?.msg || "Failed to copy documents.");
    } finally {
      setCopyInProgress(false);
    }
  };

  useEffect(() => {
    if (!folders.length && !files.length) {
      fetchFolders();
      fetchContracts();
    }
  }, []);

  return (
    <div className="max-w-full overflow-x-hidden flex flex-col flex-grow font-outfit">
      <div>
        <Header name="Documents" icon={""} isMenuOpen={isMenuOpen} />
      </div>

      <div className="w-full mt-4">
        {/* Top Action Bar */}
        <div className="flex justify-between items-center w-full px-4 mb-4">
          {/* Left: Search and Filter */}
          <div className="flex items-center gap-3 w-1/2">
            <div
              className={`flex w-[380px] h-[40px] px-4 py-2 items-center gap-2 rounded-[24px] bg-white transition-all duration-200 overflow-hidden ${
                isSearchFocused
                  ? "border border-[#BB42AE]/36 shadow-[0_11px_3px_transparent,0_7px_3px_rgba(0,0,0,0.01),0_4px_2px_rgba(0,0,0,0.05),0_2px_2px_rgba(0,0,0,0.09),0_0_1px_rgba(0,0,0,0.10)]"
                  : "border border-black/10"
              }`}
            >
              <img src="/search.svg" alt="Search" className="w-[18px] h-[18px] opacity-70" />
              <input
                type="text"
                placeholder="Search by name or type Tags: tagname"
                className="font-outfit text-[14px] font-normal border-none outline-none w-full text-[#171717] bg-transparent whitespace-nowrap placeholder:text-gray-400"
                value={searchQuery}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchQuery(value);
                  setIsTagSearch(value.toLowerCase().startsWith("tags:"));
                }}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
              />
            </div>

            <div className="relative group inline-block">
              <button
                ref={filterBtnRef}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className={`flex items-center justify-center gap-2 h-[40px] px-5 rounded-[24px] bg-white transition-all duration-200 ${
                  isFilterApplied ? "border border-[#BB42AE]/36 shadow-sm" : "border border-black/10"
                }`}
                onClick={toggleFilterModal}
              >
                <img src="/filter-icon-first.svg" alt="Filter Icon" className="w-[16px] h-[16px]" />
                <span className="font-outfit text-[#171717] text-[14px] font-medium">Filter</span>
              </button>
              {isFilterApplied && (
                <>
                  <img
                    src="/Filter_CTA.svg"
                    alt="Clear Filter"
                    className="absolute -bottom-1 -right-1 w-[18px] h-[18px] cursor-pointer z-10 bg-white rounded-full shadow-sm hover:scale-110 transition-transform"
                    onClick={clearFilters}
                  />
                  <FilterAppliedTooltip targetRef={filterBtnRef} isVisible={isHovered} selectedFilters={selectedFilters} />
                </>
              )}
            </div>
          </div>

          {/* Right: Action Buttons */}
          <div className="flex items-center gap-2 flex-wrap justify-end">
            {selectedContracts.length > 0 ? (
              <div className="flex items-center gap-2">
                <span className="bg-[#F8F3FF] text-[#C95EBE] text-sm px-3 py-1.5 rounded-full font-medium font-outfit border border-[#C95EBE]/20">
                  {selectedContracts.length} Documents selected
                </span>

                <button
                  onClick={() => setIsBulkTagModalOpen(true)}
                  className="flex items-center gap-1.5 bg-[#C95EBE] text-white text-[14px] font-outfit font-medium px-4 py-2 rounded-[8px] hover:bg-[#b04b9e] transition-colors"
                >
                  Bulk tag
                  <img src="/tag-icon-white.svg" alt="Tag" className="w-4 h-4" />
                </button>

                {selectedContracts.every((item) => item.document_type !== "folder" && !item.documents) && (
                  <button
                    onClick={() => { setCurrentDocument(selectedContracts); setIsCopyModalOpen(true); }}
                    disabled={exportInProgress}
                    className="flex items-center gap-1.5 border border-[#C95EBE]/30 bg-[#F8F3FF] text-[#C95EBE] text-[14px] font-outfit font-medium px-4 py-2 rounded-[8px] hover:bg-[#f1e6ff] transition-colors disabled:opacity-60"
                  >
                    <img src="./copyToFolder.svg" alt="Copy" className="w-4 h-4" />
                    {exportInProgress ? "Copying..." : "Copy to Folder"}
                  </button>
                )}

                {selectedContracts.every((item) => item.document_type === "contract" || item.document_type === "invoice") && (
                  <button
                    onClick={handleExport}
                    disabled={exportInProgress}
                    className="flex items-center gap-1.5 border border-[#C95EBE]/30 bg-[#F8F3FF] text-[#C95EBE] text-[14px] font-outfit font-medium px-4 py-2 rounded-[8px] hover:bg-[#f1e6ff] transition-colors disabled:opacity-60"
                  >
                    <img src="/export-icon-blue.svg" alt="Export" className="w-4 h-4" />
                    {exportInProgress ? "Exporting..." : "Export"}
                  </button>
                )}

                <button
                  onClick={handleBulkDeleteConfirmation}
                  className="flex items-center gap-1.5 bg-[#FFF0F0] text-[#E21919] text-[14px] font-outfit font-medium px-4 py-2 rounded-[8px] hover:bg-[#ffe5e5] transition-colors"
                >
                  <img src="/delete-icon-red.svg" alt="Delete" className="w-4 h-4" />
                  Delete
                </button>

                <button
                  onClick={handleCancel}
                  className="flex items-center justify-center p-[8px] rounded-[8px] border border-black/10 bg-[#F4F4F5] hover:bg-[#E4E4E7] transition-colors"
                >
                  <img src="/cancel_icon.svg" alt="Cancel" className="w-[16px] h-[16px]" />
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setIsCreateFolderModalOpen(true)}
                  className="flex items-center gap-2 px-4 py-2 bg-white border border-[#C95EBE] rounded-[8px] hover:bg-gray-50 transition-colors shadow-sm"
                >
                  <img src="/upload-doc-create.svg" alt="Create Folder" className="w-4 h-4" />
                  <span className="text-[#C95EBE] font-outfit text-[14px] font-medium">Create Folder</span>
                </button>

                <div className="relative inline-block">
                  <button
                    ref={uploadButtonRef}
                    className="flex items-center justify-center gap-2 px-[22px] py-[9px] bg-[#C95EBE] rounded-[8px] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] transition-colors shadow-sm"
                    onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                  >
                    <img src="/upload_icon_white.svg" alt="Upload" className="w-[18px] h-[18px]" />
                    Upload
                  </button>

                  {isTooltipVisible && (
                    <div className="absolute top-[115%] right-0 w-[188px] bg-white shadow-lg border border-gray-100 rounded-[12px] p-2 z-[1000] text-left">
                      <div
                        className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors"
                        onClick={() => { setIsTooltipVisible(false); fileInputRef.current.click(); }}
                      >
                        <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
                        Add from device
                      </div>

                      {!isConnected ? (
                        <div
                          className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                          onClick={() => { setIsTooltipVisible(false); navigate("/account/integration"); }}
                        >
                          <img src="/connect-icon.svg" alt="Connect" className="w-4 h-4" />
                          Connect Drive
                        </div>
                      ) : (
                        <div
                          className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                          onClick={() => { setIsTooltipVisible(false); handleAddFromDriveClick(); }}
                        >
                          <img src="/picker-icon.svg" alt="Drive" className="w-4 h-4" />
                          Add from Drive
                        </div>
                      )}
                    </div>
                  )}
                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    className="hidden"
                    accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png,.docx"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Table UI */}
        <div className="w-full px-2">
          <div className="relative overflow-auto custom-scrollbar w-full" style={{ height: "calc(100vh - 158px)" }}>
            <table className="w-full text-sm text-left table-auto border-separate border-spacing-0">
              <thead className="bg-white h-12 text-[#1E1E1E] font-medium">
                <tr>
                  <th className="w-[40px] px-3 sticky top-0 bg-white z-20 border-b border-black/10 align-middle text-center">
                    <input
                      type="checkbox"
                      style={{
                        appearance: "none",
                        border: "1.5px solid #c0c0c0",
                        borderRadius: "4px",
                        cursor: "pointer",
                        width: "18px",
                        height: "18px",
                        backgroundImage: selectedContracts.length === folders.length + files.length && folders.length + files.length > 0 ? "url('/checck.svg')" : "none",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "14px 14px",
                        display: "block",
                      }}
                      className="mx-auto"
                      onChange={handleSelectAll}
                      checked={selectedContracts.length === folders.length + files.length && folders.length + files.length > 0}
                    />
                  </th>
                  <th className="min-w-[200px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">File Name</th>
                  <th className="w-[100px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">File Type</th>
                  <th className="w-[120px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10 cursor-pointer hover:text-[#52525B]" onClick={handleSortBySize}>
                    <div className="flex items-center gap-1.5">Size <img src="/icons-size-icon.svg" className="w-3.5 h-3.5" alt="Sort" /></div>
                  </th>
                  <th className="w-[140px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10 cursor-pointer hover:text-[#52525B]" onClick={handleSortByDate}>
                    <div className="flex items-center gap-1.5">Uploaded Date <img src="/icons-size-icon.svg" className="w-3.5 h-3.5" alt="Sort" /></div>
                  </th>
                  <th className="min-w-[150px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">Tags</th>
                  <th className="w-[80px] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">Chat</th>
                  <th className="w-[80px] px-3 py-2 align-middle text-center text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">Action</th>
                </tr>
              </thead>
              <tbody className="bg-white">
              {loading ? (
                  <tr>
                    <td colSpan="8" className="py-20 border-b border-black/10">
                      <div className="text-center flex flex-col items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C95EBE] mx-auto mb-4"></div>
                        <p className="text-[#52525B] font-outfit text-[15px]">Loading Documents...</p>
                      </div>
                    </td>
                  </tr>
                ) : filteredPaginatedData.length > 0 ? (
                  filteredPaginatedData.map((item, index) => (
                    <tr
                      key={`${item.isFolder ? item.doc_type : item.document_type}-${index}`}
                      className="h-[40px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
                      onClick={(e) => {
                        if (
                          e.target.type !== "checkbox" &&
                          !e.target.classList.contains("action-button") &&
                          !e.target.closest("button")
                        ) {
                          e.stopPropagation();

                          if (cancelledPdfKeys.includes(item.key)) {
                            return;
                          }

                          if (item.documents) {
                            navigate(`/folder/?folderId=${item.id}`, {
                              state: {
                                folderId: item.id,
                                folderName: item.name,
                              },
                            });
                          } else {
                            navigate("/chat", {
                              state: {
                                pdfUrl: item.pdf_url,
                                pdfKey: item.key,
                                pdfId: item.id,
                                document_type: item.document_type || null,
                              },
                            });
                          }
                        }
                      }}
                    >
                      <td className="px-3 py-2 align-middle text-center border-b border-black/10">
                        <input
                          type="checkbox"
                          style={{
                            appearance: "none",
                            border: "1.5px solid #c0c0c0",
                            borderRadius: "4px",
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            backgroundImage: selectedContracts.some((s) => s.id === item.id) ? "url('/checck.svg')" : "none",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "14px 14px",
                            display: "block",
                          }}
                          className="mx-auto"
                          checked={selectedContracts.some((s) => s.id === item.id)}
                          onChange={() => handleCheckboxChange({ ...item, document_type: item.isFolder ? item.doc_type : item.document_type })}
                        />
                      </td>
                      <td className="px-1 truncate border-b border-black/10">
                        <div className="flex items-center gap-2">
                          <img
                            src={
                              item.documents
                                ? "/folder-icon-new.svg"
                                : item.file_type === "pdf"
                                ? "/pdff.svg"
                                : item.file_type === "xlsx"
                                ? "/Xls.svg"
                                : item.file_type === "docx"
                                ? "/docX.svg"
                                : item.file_type === "csv"
                                ? "/CSV.svg"
                                : item.file_type === "txt"
                                ? "/TXT.svg"
                                : item.file_type === "xls"
                                ? "/Xls.svg"
                                : "/pdf.svg"
                            }
                            className="w-5 h-5 flex-shrink-0"
                            alt="Icon"
                          />
                          <FileNameWithTooltip name={item.name} />
                        </div>
                      </td>
                      <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10 capitalize">
                        {item.documents ? "Folder" : item.document_type || "N/A"}
                      </td>
                      <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10">
                        {item.documents ? item.folder_size || item.size || "N/A" : item.document_size || item.size || "N/A"}
                      </td>
                      <td className="px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] border-b border-black/10">
                        {item.created_at || item.uploaded_at ? new Date(item.created_at || item.uploaded_at).toLocaleDateString() : "N/A"}
                      </td>
                      <td className="px-3 py-2 align-middle border-b border-black/10">
                        {item.tags && item.tags.length > 0 ? (
                          <div
                            className={`flex flex-wrap gap-1 relative max-w-[190px] ${
                              cancelledPdfKeys.includes(item.key) ? "opacity-50 cursor-not-allowed pointer-events-none" : "group"
                            }`}
                            onClick={(e) => {
                              if (cancelledPdfKeys.includes(item.key)) return;
                              e.stopPropagation();
                              setTagModalDocId(item.id);
                            }}
                          >
                            {item.tags.slice(0, 2).map((tag) => (
                              <span
                                key={tag.id}
                                className="tag-pill cursor-pointer"
                                style={{
                                  color: darkenColor(tag.color),
                                  backgroundColor: `${tag.color}1A`,
                                  border: `2px solid ${tag.color}`,
                                }}
                              >
                                {tag.name}
                              </span>
                            ))}

                            {item.tags.length > 2 && (() => {
                                const tag = item.tags[2];
                                return (
                                  <span
                                    className="tag-pill"
                                    style={{
                                      color: darkenColor(tag.color),
                                      backgroundColor: `${tag.color}1A`,
                                      border: `2px solid ${tag.color}`,
                                    }}
                                  >
                                    +{item.tags.length - 2}
                                  </span>
                                );
                            })()}

                            {!cancelledPdfKeys.includes(item.key) && (
                              <div className="hidden group-hover:flex absolute top-[100%] left-0 mt-1 z-50 bg-white p-2 rounded-md shadow-lg border border-gray-200 flex-wrap gap-1 w-max max-w-xs">
                                {item.tags.map((tag) => (
                                  <span
                                    key={tag.id}
                                    className="tag-pill"
                                    style={{
                                      color: darkenColor(tag.color),
                                      backgroundColor: `${tag.color}1A`,
                                      border: `2px solid ${tag.color}`,
                                    }}
                                  >
                                    {tag.name}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <span
                            className={`inline-flex items-center gap-2 px-3 py-[6px] rounded-[20px] border border-[rgba(0,0,0,0.10)] bg-white text-[#52525B] text-[14px] font-[500] font-[Outfit] ${
                              cancelledPdfKeys.includes(item.key) ? "opacity-50 cursor-not-allowed pointer-events-none" : "cursor-pointer"
                            }`}
                            onClick={(e) => {
                              if (cancelledPdfKeys.includes(item.key)) return;
                              e.stopPropagation();
                              setTagModalDocId(item.id);
                            }}
                          >
                            + Add Tag
                          </span>
                        )}
                      </td>
                      <td className="px-3 py-2 align-middle border-b border-black/10">
                        <div title={cancelledPdfKeys.includes(item.key) ? "You cancelled this upload. Please refresh to remove it." : ""}>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();

                              if (cancelledPdfKeys.includes(item.key)) {
                                return;
                              }

                              if (item.documents) {
                                navigate("/Contract/FolderChat", {
                                  state: {
                                    folderId: item.id,
                                    folderName: item.name || "N/A",
                                    pdfList: item.documents.map((doc) => ({
                                      pdfKey: doc.key || doc.id,
                                      pdfUrl: doc.pdf_url || doc.file_url || doc.pdfUrl || "",
                                      name: doc.name,
                                    })),
                                  },
                                });
                              } else {
                                navigate("/chat", {
                                  state: {
                                    pdfUrl: item.pdf_url || item.url,
                                    pdfKey: item.key,
                                    pdfId: item.id,
                                    document_type: item.document_type || null,
                                  },
                                });
                              }
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            disabled={cancelledPdfKeys.includes(item.key)}
                            className={`flex items-center gap-1 font-medium chat-button-documents-for ${
                              cancelledPdfKeys.includes(item.key) ? "text-gray-400 cursor-not-allowed" : "text-purple-500"
                            }`}
                          >
                            <img
                              src={isHovered ? "/chat-icon-doc-hover.svg" : "/chat-icon-doc.svg"}
                              className="w-4 h-4"
                              alt="Chat"
                            />
                            Chat
                          </button>
                        </div>
                      </td>
                      <td className="px-3 py-2 align-middle text-center border-b border-black/10 relative">
                        <img
                          src={cancelledPdfKeys.includes(item.key) ? "./action.svg" : "./action.svg"}
                          alt="Actions"
                          width="20"
                          height="20"
                          onClick={(e) => {
                            if (cancelledPdfKeys.includes(item.key)) return;
                            toggleActionMenu(index, e);
                          }}
                          style={{
                            cursor: cancelledPdfKeys.includes(item.key) ? "not-allowed" : "pointer",
                            opacity: cancelledPdfKeys.includes(item.key) ? 0.4 : 1,
                          }}
                          title={cancelledPdfKeys.includes(item.key) ? "This upload was cancelled. Please refresh to remove it." : "Actions"}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="py-16 text-center border-b border-black/10">
                      <div className="flex flex-col items-center justify-center">
                        <img src="/no-contracts.svg" alt="No Documents Found" className="mb-4 w-[120px] h-[120px]" />
                        <p className="text-[#52525B] font-outfit text-[15px]">Looks like your table is empty!</p>
                      </div>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Row Action Menus - Portal strategy for z-index issues */}
      {isActionMenuOpen !== null && (
        <div
          className="fixed z-[9999] bg-white rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-gray-100 p-1.5 min-w-[150px] font-outfit"
          ref={actionMenuRef}
          style={{ top: `${actionMenuPosition.top}px`, left: `${actionMenuPosition.left}px` }}
        >
          {filteredPaginatedData[isActionMenuOpen]?.documents ? (
            <>
              <div
                onClick={() => {
                  setCurrentFolder(filteredPaginatedData[isActionMenuOpen]);
                  setIsRenameFolderModalOpen(true);
                  setIsActionMenuOpen(null);
                }}
                className="flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer text-[#52525B] hover:bg-[#FAF9F6] hover:text-[#C95EBE] transition-colors"
              >
                <img src="/edit.svg" alt="Edit" className="w-4 h-4" />
                <span className="text-[14px] font-medium">Rename Folder</span>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setFolderToDelete(filteredPaginatedData[isActionMenuOpen].id);
                  setIsDeleteFolderModalOpen(true);
                  setIsActionMenuOpen(null);
                }}
                className="flex items-center gap-2.5 px-3 py-2 mt-0.5 rounded-[8px] cursor-pointer text-[#52525B] hover:bg-[#FFF0F0] hover:text-[#E21919] transition-colors"
              >
                <img src="/delete.svg" alt="Delete" className="w-4 h-4" />
                <span className="text-[14px] font-medium">Delete Folder</span>
              </div>
            </>
          ) : (
            <>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentDocument([filteredPaginatedData[isActionMenuOpen]]);
                  setIsCopyModalOpen(true);
                  setIsActionMenuOpen(null);
                }}
                className="flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer text-[#52525B] hover:bg-[#FAF9F6] hover:text-[#C95EBE] transition-colors"
              >
                <img src="/folder-copy.svg" alt="Copy" className="w-4 h-4" />
                <span className="text-[14px] font-medium">Copy to Folder</span>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentDocument(filteredPaginatedData[isActionMenuOpen]);
                  setIsRenameModalOpen(true);
                  setIsActionMenuOpen(null);
                }}
                className="flex items-center gap-2.5 px-3 py-2 mt-0.5 rounded-[8px] cursor-pointer text-[#52525B] hover:bg-[#FAF9F6] hover:text-[#C95EBE] transition-colors"
              >
                <img src="/edit.svg" alt="Rename" className="w-4 h-4" />
                <span className="text-[14px] font-medium">Rename</span>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(filteredPaginatedData[isActionMenuOpen].id);
                  setIsActionMenuOpen(null);
                }}
                className="flex items-center gap-2.5 px-3 py-2 mt-0.5 rounded-[8px] cursor-pointer text-[#52525B] hover:bg-[#FFF0F0] hover:text-[#E21919] transition-colors"
              >
                <img src="/delete.svg" alt="Delete" className="w-4 h-4" />
                <span className="text-[14px] font-medium">Delete</span>
              </div>
            </>
          )}
        </div>
      )}

      {/* Global Modals and Popups */}
      {confirmDeleteVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center animate-[fadeIn_0.2s_ease-out] font-outfit">
            <h2 className="text-[#171717] text-[18px] font-semibold mb-3">Are you sure you want to delete the selected item(s)?</h2>
            <p className="text-[#52525B] text-[14px] leading-relaxed mb-6">
              Once deleted, the selected item(s) will be permanently removed. This action cannot be undone.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => setConfirmDeleteVisible(false)}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] border border-gray-200 text-[#52525B] text-[14px] font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={deleteTarget === "bulk" ? handleBulkDelete : confirmDelete}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] bg-red-600 text-white text-[14px] font-medium hover:bg-red-700 transition-colors disabled:opacity-70"
              >
                {deleteInProgress ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isDeleteFolderModalOpen && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center animate-[fadeIn_0.2s_ease-out] font-outfit">
            <h2 className="text-[#171717] text-[18px] font-semibold mb-3">Are you sure you want to delete this folder?</h2>
            <p className="text-[#52525B] text-[14px] leading-relaxed mb-6">
              All documents inside this folder will also be removed. This action cannot be undone.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => setIsDeleteFolderModalOpen(false)}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] border border-gray-200 text-[#52525B] text-[14px] font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => handleDeleteFolder(folderToDelete)}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] bg-red-600 text-white text-[14px] font-medium hover:bg-red-700 transition-colors disabled:opacity-70"
              >
                {deleteInProgress ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {popupVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center font-outfit">
            <h2 className="text-[#171717] text-[18px] font-semibold mb-3">{popupTitle}</h2>
            <p className="text-[#52525B] text-[14px] leading-relaxed mb-6">{popupMessage}</p>
            <button className="bg-[#C95EBE] hover:bg-[#b04b9e] text-white text-[14px] font-medium px-6 py-2.5 rounded-[8px] transition-colors" onClick={closePopup}>
              Close
            </button>
          </div>
        </div>
      )}

      {isSuccessPopupVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[400px] p-8 text-center font-outfit flex flex-col items-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <img src="/green-icon-tick.svg" alt="Success" className="w-8 h-8" />
            </div>
            <h2 className="text-[#171717] text-[20px] font-semibold mb-2">Folder Successfully Copied</h2>
            <p className="text-[#52525B] text-[14px] mb-8">Your documents have been copied to <span className="font-semibold text-[#171717]">{successFolderName}</span>.</p>
            
            <div className="flex gap-3 w-full">
              <button onClick={() => navigate(`/folder/?folderId=${file_ids}`)} className="flex-1 py-2.5 border border-[#C95EBE] text-[#C95EBE] rounded-[8px] text-[14px] font-medium hover:bg-gray-50 transition-colors">
                View Folder
              </button>
              <button onClick={() => setIsSuccessPopupVisible(false)} className="flex-1 py-2.5 bg-[#C95EBE] text-white rounded-[8px] text-[14px] font-medium hover:bg-[#b04b9e] transition-colors">
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      <UploadModal isOpen={isModalOpen} onClose={handleCloseModal} onUploadSuccess={handleUploadSuccess} type={"document"} file={file} />
      
      <RenameModal isOpen={isRenameModalOpen} onClose={() => setIsRenameModalOpen(false)} document={currentDocument} onRename={handleRename} />
      
      <RenameModal isOpen={isRenameFolderModalOpen} onClose={() => setIsRenameFolderModalOpen(false)} document={currentFolder} onRename={handleRenameFolder} />
      
      <CopyToFolderModal isOpen={isCopyModalOpen} onClose={() => setIsCopyModalOpen(false)} documents={currentDocument} folders={folders} onCopy={handleCopyToFolder} onCreateFolder={fetchFolders} />
      
      <FilterModal isOpen={isFilterModalOpen} onClose={() => setIsFilterModalOpen(false)} onApply={(filteredFiles, filteredFolders) => { setFiles(filteredFiles); setFolders(filteredFolders); setIsFilterApplied(true); }} setFiles={setFiles} setFolders={setFolders} setIsFilterApplied={setIsFilterApplied} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} clearFilters={clearFilters} />
      
      <CreateFolderModal isOpen={isCreateFolderModalOpen} onClose={() => setIsCreateFolderModalOpen(false)} onCreateSuccess={fetchFolders} />

      {tagModalDocId && <CreateTagModals isOpen={true} onClose={() => setTagModalDocId(null)} documentId={tagModalDocId} onTagUpdate={() => { fetchContracts(); fetchFolders(); }} />}
      
      {isBulkTagModalOpen && selectedContracts.length > 0 && <CreateTagModals isOpen={true} onClose={() => setIsBulkTagModalOpen(false)} documentId={selectedContracts.map((doc) => doc.id)} onTagUpdate={() => { fetchContracts(); fetchFolders(); }} onClearSelection={() => setSelectedContracts([])} />}

    </div>
  );
};

export default UploadFilePage;
